(function () {
  "use strict";

  var MOUNT_SELECTOR = "[data-ss-cart-promotion-mount]";
  var SYSTEM_GIFT_CAMPAIGN = "_ss_free_gift_campaign";
  var SYSTEM_GIFT_TIER = "_ss_free_gift_tier";
  var SYSTEM_GIFT_VARIANT = "_ss_free_gift_variant";
  var SYSTEM_GIFT_TITLE = "_ss_free_gift_title";
  var GIFT_TYPE = "FREE_GIFT";
  var BUY_N_PAY_M_TYPE = "BUY_N_PAY_M";
  var BUY_X_GET_Y_TYPE = "BUY_X_GET_Y";
  var CART_BENEFIT_TYPES = [
    "FIXED_AMOUNT_OFF",
    "PERCENTAGE_OFF",
    "FIXED_BUNDLE_PRICE",
    BUY_N_PAY_M_TYPE,
    BUY_X_GET_Y_TYPE,
    GIFT_TYPE,
  ];
  var PRICE_BENEFIT_TYPES = [
    "FIXED_AMOUNT_OFF",
    "PERCENTAGE_OFF",
    "FIXED_BUNDLE_PRICE",
    BUY_N_PAY_M_TYPE,
    BUY_X_GET_Y_TYPE,
  ];
  var LOYALTY_DISCOUNT_CODE_PATTERN = /^SSLOYALTY-/i;
  var INTERNAL_CART_MUTATION_OPTION = "ssCartPromotionInternal";
  var BOOTSTRAP_TTL_MS = 60000;
  var BOOTSTRAP_CACHE_VERSION = "2";
  var DISCOVER_PRODUCT_LIMIT = 40;
  var DISCOVER_EXCLUDED_KEYWORDS = ["gift-card", "gift card"];
  var state = {
    bootstrap: null,
    bootstrapFetchedAt: 0,
    bootstrapPromise: null,
    cart: null,
    expiresTimer: null,
    isRefreshing: false,
    refreshPending: false,
    refreshPromise: null,
    refreshRequest: null,
    refreshReasons: new Set(),
    isSyncing: false,
    isRendering: false,
    lastSyncSignature: "",
    lastRepriceSignature: null,
    observer: null,
    observerTimer: null,
    cartRefreshBound: false,
    cartRefreshTimer: null,
    cartRefreshDueAt: 0,
    lastSectionRenderAt: 0,
    protocolDataset: null,
    collectionProductsCache: new Map(),
    giftSellingPriceCentsCache: new Map(),
    giftSellingPriceRequestCache: new Map(),
    productJsonCache: new Map(),
    variantJsonCache: new Map(),
    discoverRequestId: 0,
    eventsBound: false,
  };

  function getMounts() {
    return Array.from(document.querySelectorAll(MOUNT_SELECTOR));
  }

  function getPrimaryMount() {
    return getMounts()[0] || null;
  }

  function ensureRuntimeMounts(sourceMount) {
    var protocolSource = getProtocolSource(sourceMount);
    if (!protocolSource) return;
    getMounts().forEach(function (mount) {
      copyProtocolDataset(protocolSource, mount);
    });
    ensureGroupsMount(protocolSource);
  }

  function getProtocolSource(preferredMount) {
    var candidates = [
      preferredMount,
      document.getElementById("silksilky-cart-promotion-embed"),
      document.querySelector("[data-ss-cart-promotion-fallback]"),
    ].concat(getMounts());

    for (var index = 0; index < candidates.length; index += 1) {
      var source = candidates[index];
      if (source && source.dataset && source.dataset.proxyPath) {
        rememberProtocolDataset(source.dataset);
        return source;
      }
    }

    if (state.protocolDataset) return { dataset: state.protocolDataset };
    return preferredMount || null;
  }

  function rememberProtocolDataset(dataset) {
    if (!dataset || !dataset.proxyPath) return;
    state.protocolDataset = Object.keys(dataset).reduce(function (result, key) {
      if (isMountIdentityDatasetKey(key)) return result;
      if (dataset[key] != null) result[key] = dataset[key];
      return result;
    }, {});
  }

  function ensureGroupsMount(sourceMount) {
    var existingGroupsMount = document.querySelector(
      '[data-ss-cart-promotion-mount][data-kind="groups"]'
    );
    if (existingGroupsMount) {
      copyProtocolDataset(sourceMount, existingGroupsMount);
      return existingGroupsMount;
    }

    var anchor = findCartItemsAnchor();
    if (!anchor) return null;

    var mount = document.createElement("div");
    mount.className =
      "ss-cart-promotion-mount ss-cart-promotion-mount--groups tab-cart minicart-tabs-content active";
    mount.hidden = true;
    mount.setAttribute("data-ss-cart-promotion-mount", "");
    mount.dataset.kind = "groups";
    copyProtocolDataset(sourceMount, mount);

    if (anchor.insertMode === "prepend") {
      anchor.element.insertBefore(mount, anchor.element.firstChild);
      return mount;
    }
    anchor.element.parentNode.insertBefore(mount, anchor.element);
    return mount;
  }

  function findCartItemsAnchor() {
    var containerSelectors = [
      "#minicart .items",
      ".minicart-body .items",
      ".minicart__products",
      "[data-cart-items]",
      "cart-items",
      "#CartDrawer-CartItems",
      ".drawer__cart-items-wrapper",
      ".cart-items",
    ];
    var itemSelectors = [".cart-item", ".minicart__product"];

    for (var index = 0; index < containerSelectors.length; index += 1) {
      var container = document.querySelector(containerSelectors[index]);
      if (container) return { element: container, insertMode: "prepend" };
    }

    for (var itemIndex = 0; itemIndex < itemSelectors.length; itemIndex += 1) {
      var item = document.querySelector(itemSelectors[itemIndex]);
      if (item && item.parentNode)
        return { element: item, insertMode: "before" };
    }

    return null;
  }

  function copyProtocolDataset(source, target) {
    if (!source || !target) return;
    Object.keys(source.dataset).forEach(function (key) {
      if (isMountIdentityDatasetKey(key)) return;
      if (source.dataset[key] == null) return;
      target.dataset[key] = source.dataset[key];
    });
  }

  function isMountIdentityDatasetKey(key) {
    return key === "kind" || key === "ssCartPromotionMount";
  }

  function getLabels(mount) {
    if (!mount) return {};
    return {
      add: mount.dataset.labelAdd || "Add",
      back: mount.dataset.labelBack || "Back to cart",
      discover: mount.dataset.labelDiscover || "Discover more items",
      discoverEmpty:
        mount.dataset.labelDiscoverEmpty ||
        "No matching products are available right now.",
      discoverLoading:
        mount.dataset.labelDiscoverLoading || "Loading products...",
      free: mount.dataset.labelFree || "Free",
      item: mount.dataset.labelItem || "item",
      items: mount.dataset.labelItems || "items",
      freeItem: mount.dataset.labelFreeItem || "FREE ITEM",
      buyNPayMFreeRewardOne:
        mount.dataset.templateBuyNPayMFreeRewardOne ||
        "{{ count }} {{ free }} {{ item }}",
      buyNPayMFreeRewardOther:
        mount.dataset.templateBuyNPayMFreeRewardOther ||
        "{{ count }} {{ free }} {{ item }}",
      buyNPayMApplied:
        mount.dataset.templateBuyNPayMApplied || "{{ reward }} applied",
      buyNPayMEligible:
        mount.dataset.templateBuyNPayMEligible || "{{ reward }} eligible",
      buyXGetYApplied:
        mount.dataset.templateBuyXGetYApplied ||
        "You've unlocked {{ rewards }}",
      buyXGetYRewardOne:
        mount.dataset.templateBuyXGetYRewardOne ||
        "{{ count }} {{ item }} {{ discount }} off",
      buyXGetYRewardOther:
        mount.dataset.templateBuyXGetYRewardOther ||
        "{{ count }} {{ item }} {{ discount }} off",
      buyXGetYResultFirst:
        mount.dataset.templateBuyXGetYResultFirst ||
        "{{ count }} {{ item }} {{ discount }} off",
      buyXGetYResultAdditional:
        mount.dataset.templateBuyXGetYResultAdditional ||
        "another {{ count }} {{ item }} {{ discount }} off",
      buyXGetYProgressRepeatOne:
        mount.dataset.templateBuyXGetYProgressRepeatOne ||
        "Add {{ count }} more {{ item }}; another item will get {{ discount }} off",
      buyXGetYProgressRepeatOther:
        mount.dataset.templateBuyXGetYProgressRepeatOther ||
        "Add {{ count }} more {{ item }}; {{ reward_count }} more items will get {{ discount }} off",
      buyXGetYProgressUpgrade:
        mount.dataset.templateBuyXGetYProgressUpgrade ||
        "Add {{ count }} more {{ item }} to unlock {{ rewards }}",
      freeShipping: mount.dataset.labelFreeShipping || "Free Shipping",
      freeGift: mount.dataset.labelFreeGift || "Free Gift",
      freeGifts: mount.dataset.labelFreeGifts || "Free Gifts",
      off: mount.dataset.labelOff || "OFF",
      giftTitle: mount.dataset.templateGiftTitle || "{{ free }} {{ gift }}",
      shippingUnlocked:
        mount.dataset.templateShippingUnlocked ||
        "You have got {{ shipping }}!",
      shippingPriceUnlocked:
        mount.dataset.templateShippingPriceUnlocked ||
        "You have unlocked {{ shipping }} + {{ reward }}",
      shippingGiftUnlockedOne:
        mount.dataset.templateShippingGiftUnlockedOne ||
        "You've unlocked {{ shipping }} + {{ count }} Free Gift!",
      shippingGiftUnlockedOther:
        mount.dataset.templateShippingGiftUnlockedOther ||
        "You've unlocked {{ shipping }} + {{ count }} Free Gifts!",
      quantity: mount.dataset.labelQuantity || "Quantity",
      giftGapReward: mount.dataset.labelGiftGapReward || "a free gift",
      nextGiftGapReward:
        mount.dataset.labelNextGiftGapReward || "the next free gift",
      giftUnlocked: mount.dataset.labelGiftUnlocked || "Unlocked",
      allGiftsUnlocked:
        mount.dataset.labelAllGiftsUnlocked || "You've unlocked all free gifts",
      close: mount.dataset.labelClose || "Close",
      locked: mount.dataset.labelLock || "Locked",
      amountLocked:
        mount.dataset.templateAmountLocked ||
        "You are only {{ amount }} away from {{ reward }}.",
      amountUnlocked:
        mount.dataset.templateAmountUnlocked || "{{ reward }} unlocked.",
      giftLocked:
        mount.dataset.templateGiftLocked || "Spend {{ amount }} more to unlock",
      saved: mount.dataset.templateSaved || "Saved {{ amount }}",
      giftEarnedSummaryOne:
        mount.dataset.templateGiftEarnedSummaryOne ||
        "You earned {{ count }} gift",
      giftEarnedSummaryOther:
        mount.dataset.templateGiftEarnedSummaryOther ||
        "You earned {{ count }} gifts",
      giftEarnedRewardSummaryOne:
        mount.dataset.templateGiftEarnedRewardSummaryOne ||
        "You earned {{ count }} {{ gift }}",
      quantityGiftGapOne:
        mount.dataset.templateQuantityGiftGapOne ||
        "Add {{ count }} more item for {{ gift }}",
      quantityGiftGapOther:
        mount.dataset.templateQuantityGiftGapOther ||
        "Add {{ count }} more items for {{ gift }}",
      quantityGiftItemGapOne:
        mount.dataset.templateQuantityGiftItemGapOne ||
        "Add {{ count }} more {{ item }} to unlock {{ gift }}",
      quantityGiftItemGapOther:
        mount.dataset.templateQuantityGiftItemGapOther ||
        "Add {{ count }} more {{ item }} to unlock {{ gift }}",
      subtotalGiftGap:
        mount.dataset.templateSubtotalGiftGap ||
        "Spend {{ amount }} more for {{ gift }}",
      quantityPriceGapOne:
        mount.dataset.templateQuantityPriceGapOne ||
        "Add {{ count }} more item to save {{ reward }}",
      quantityPriceGapOther:
        mount.dataset.templateQuantityPriceGapOther ||
        "Add {{ count }} more items to save {{ reward }}",
      bundleQuantityPriceGapOne:
        mount.dataset.templateBundleQuantityPriceGapOne ||
        "Add {{ count }} more item to get {{ quantity }} items for {{ amount }}",
      bundleQuantityPriceGapOther:
        mount.dataset.templateBundleQuantityPriceGapOther ||
        "Add {{ count }} more items to get {{ quantity }} items for {{ amount }}",
      buyNPayMQuantityPriceGapOne:
        mount.dataset.templateBuyNPayMQuantityPriceGapOne ||
        "Add {{ count }} more {{ item }} to save {{ reward }}",
      buyNPayMQuantityPriceGapOther:
        mount.dataset.templateBuyNPayMQuantityPriceGapOther ||
        "Add {{ count }} more {{ item }} to save {{ reward }}",
      buyXGetYQuantityPriceGapOne:
        mount.dataset.templateBuyXGetYQuantityPriceGapOne ||
        "Add {{ count }} more {{ item }} to get {{ reward }}",
      buyXGetYQuantityPriceGapOther:
        mount.dataset.templateBuyXGetYQuantityPriceGapOther ||
        "Add {{ count }} more {{ item }} to get {{ reward }}",
      subtotalPriceGap:
        mount.dataset.templateSubtotalPriceGap ||
        "Spend {{ amount }} more to save {{ reward }}",
      bundleApplied:
        mount.dataset.templateBundleApplied ||
        "Applied: {{ quantity }} items for {{ amount }}",
      giftTierEarned: mount.dataset.templateGiftTierEarned || "Earned",
      giftTierFuture:
        mount.dataset.templateGiftTierFuture || "Gift {{ index }}",
    };
  }

  function routesFallback(key, fallback) {
    return window.routes && window.routes[key] ? window.routes[key] : fallback;
  }

  function storefrontPath(path) {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    var normalizedRoot = String(root || "/");
    if (normalizedRoot.charAt(normalizedRoot.length - 1) !== "/") {
      normalizedRoot += "/";
    }
    return normalizedRoot + String(path || "").replace(/^\/+/, "");
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function isSystemGiftItem(item) {
    return Boolean(getProperty(item, SYSTEM_GIFT_CAMPAIGN));
  }

  function isAppliedFreeGiftItem(item) {
    return isSystemGiftItem(item) && finalLinePriceCents(item) <= 0;
  }

  function getProperty(item, key) {
    if (!item || !item.properties) return null;
    if (Array.isArray(item.properties)) {
      var pair = item.properties.find(function (entry) {
        return entry && (entry.name === key || entry[0] === key);
      });
      return pair ? pair.value || pair[1] : null;
    }
    return item.properties[key] || null;
  }

  function normalizeHandle(value) {
    return String(value == null ? "" : value)
      .trim()
      .toLowerCase();
  }

  function displayGroupLabel(value, fallback) {
    var label = String(value || fallback || "").trim();
    if (!label) return "";
    if (/[A-Z]/.test(label) && label === label.toUpperCase()) {
      return label
        .toLowerCase()
        .replace(/(^|[\s-])([a-z])/g, function (_match, prefix, character) {
          return prefix + character.toUpperCase();
        });
    }
    return label;
  }

  function normalizeHandleList(value) {
    var source = Array.isArray(value)
      ? value
      : String(value == null ? "" : value).split(",");
    var seen = new Set();
    return source.reduce(function (items, item) {
      var handle = normalizeHandle(item);
      if (handle && !seen.has(handle)) {
        seen.add(handle);
        items.push(handle);
      }
      return items;
    }, []);
  }

  function lineElementsForItem(item, root) {
    if (!item || !item.key) return [];
    var scope = root && typeof root.querySelectorAll === "function" ? root : document;
    return Array.from(scope.querySelectorAll("[data-ss-line-key]")).filter(
      function (element) {
        return element.dataset.ssLineKey === item.key;
      }
    );
  }

  function lineElementForItem(item, root) {
    return lineElementsForItem(item, root)[0] || null;
  }

  function lineEntryForItem(item, root) {
    return {
      item: item,
      node: lineElementForItem(item, root),
    };
  }

  function updateGiftLineTitles(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var labels = getLabels(getMounts()[0]);
    cart.items.forEach(function (item) {
      if (!isSystemGiftItem(item)) return;
      lineElementsForItem(item).forEach(function (itemNode) {
        var title = giftTitleForGiftLine(item, labels);
        if (title) {
          itemNode.dataset.ssFreeGiftTitle = title;
          var titleLink = itemNode.querySelector(
            ".product-item__name-minicart > a"
          );
          if (titleLink) {
            titleLink.textContent = title;
            titleLink.setAttribute("aria-label", title);
          }
          var imageLink = itemNode.querySelector(
            ".minicart__product__image > a"
          );
          if (imageLink) imageLink.setAttribute("aria-label", title);
        }
        var badge = itemNode.querySelector(".ss-cart-item-free-gift__tag");
        if (badge) {
          var badgeText = giftRewardBadgeTextForGiftLine(item, labels);
          badge.textContent = badgeText;
          badge.hidden = !badgeText;
        }
      });
    });
  }

  function giftTitleForGiftLine(item, labels) {
    var productTitle = productTitleForGiftLine(item);
    if (!isAppliedFreeGiftItem(item)) return productTitle;
    var campaign = campaignById(getProperty(item, SYSTEM_GIFT_CAMPAIGN));
    var tier = campaignTierForGiftLine(campaign, item);
    var rawGiftTitle =
      configuredGiftTitle(tier) || stringProperty(item, SYSTEM_GIFT_TITLE);
    var displayTitle = rawGiftTitle
      ? localizedGiftTitle(rawGiftTitle, labels)
      : displayGroupLabel(labels && labels.freeGift, "Free Gift");
    if (!productTitle) return displayTitle;
    if (
      rawGiftTitle &&
      giftLineTitleMatchesProduct(rawGiftTitle, item, productTitle)
    ) {
      return displayTitle;
    }
    return displayTitle + ": " + productTitle;
  }

  function productTitleForGiftLine(item) {
    var title = String(
      (item &&
        (item.product_title || item.productTitle || item.productTitleText)) ||
        ""
    ).trim();
    if (title) return title;
    return String((item && item.title) || "")
      .split(" / ")[0]
      .trim();
  }

  function giftLineTitleMatchesProduct(title, item, productTitle) {
    var candidate = normalizeGiftLineTitle(title);
    var product = normalizeGiftLineTitle(productTitle);
    var fullTitle = normalizeGiftLineTitle(item && item.title);
    if (!candidate) return false;
    if (product && candidate === product) return true;
    if (fullTitle && candidate === fullTitle) return true;
    return Boolean(product && candidate.indexOf(product + " / ") === 0);
  }

  function normalizeGiftLineTitle(value) {
    return String(value == null ? "" : value)
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function giftRewardBadgeTextForGiftLine(item, labels) {
    return isAppliedFreeGiftItem(item)
      ? (labels && labels.freeGift) || "FREE GIFT"
      : "";
  }

  function campaignTierForGiftLine(campaign, item) {
    if (!campaign || !item) return null;
    var sortOrder = String(getProperty(item, SYSTEM_GIFT_TIER) || "");
    var variantId = String(getProperty(item, SYSTEM_GIFT_VARIANT) || "");
    var tiers = sortTiers(campaign);
    return (
      tiers.find(function (tier) {
        return String((tier && tier.sortOrder) || "") === sortOrder;
      }) ||
      tiers.find(function (tier) {
        return String(giftVariantId(tier) || "") === variantId;
      }) ||
      null
    );
  }

  function stringProperty(item, key) {
    var value = getProperty(item, key);
    return typeof value === "string" ? value.trim() : "";
  }

  function itemTargetMeta(item) {
    var element = lineElementForItem(item);
    var productHandle =
      normalizeHandle(
        item && (item.handle || item.product_handle || item.productHandle)
      ) ||
      normalizeHandle(
        element &&
          (element.dataset.ssProductHandle ||
            element.getAttribute("product-handle"))
      );
    var collectionHandles = normalizeHandleList(
      element && element.dataset.ssCollectionHandles
    );
    return {
      productHandle: productHandle,
      collectionHandles: collectionHandles,
    };
  }

  function campaignTargets(campaign) {
    var targetingConfig =
      campaign && campaign.targetingConfig ? campaign.targetingConfig : {};
    return {
      eligibleProductHandles: normalizeHandleList(
        []
          .concat((campaign && campaign.eligibleProductHandles) || [])
          .concat(targetingConfig.productHandles || [])
      ),
      eligibleCollectionHandles: normalizeHandleList(
        []
          .concat((campaign && campaign.eligibleCollectionHandles) || [])
          .concat(targetingConfig.collectionHandles || [])
      ),
      excludedProductHandles: normalizeHandleList(
        []
          .concat((campaign && campaign.excludedProductHandles) || [])
          .concat(targetingConfig.excludedProductHandles || [])
      ),
      excludedCollectionHandles: normalizeHandleList(
        []
          .concat((campaign && campaign.excludedCollectionHandles) || [])
          .concat(targetingConfig.excludedCollectionHandles || [])
      ),
    };
  }

  function campaignTargetMode(campaign) {
    if (!campaign) return "";
    var targetingConfig = campaign.targetingConfig || {};
    var mode = String(
      campaign.targetMode || campaign.target_mode || targetingConfig.mode || ""
    ).toUpperCase();
    if (mode === "ALL" || mode === "PRODUCTS" || mode === "COLLECTIONS") {
      return mode;
    }

    var targets = campaignTargets(campaign);
    var hasProducts = targets.eligibleProductHandles.length > 0;
    var hasCollections = targets.eligibleCollectionHandles.length > 0;
    if (hasProducts && !hasCollections) return "PRODUCTS";
    if (hasCollections && !hasProducts) return "COLLECTIONS";
    return "";
  }

  function isAllTargetCampaign(campaign) {
    return campaignTargetMode(campaign) === "ALL";
  }

  function canUseAllCollectionDiscover(campaign) {
    return (
      isAllTargetCampaign(campaign) &&
      !campaignTargets(campaign).excludedCollectionHandles.length
    );
  }

  function hasIntersection(left, right) {
    return left.some(function (item) {
      return right.includes(item);
    });
  }

  function isLineEligibleForCampaign(item, campaign) {
    return isTargetMetaEligibleForCampaign(itemTargetMeta(item), campaign);
  }

  function isTargetMetaEligibleForCampaign(meta, campaign) {
    if (!campaign) return true;
    var targets = campaignTargets(campaign);
    var mode = campaignTargetMode(campaign);
    if (!mode) return false;

    if (mode === "PRODUCTS") {
      if (!targets.eligibleProductHandles.length) return false;
      if (
        !meta ||
        !meta.productHandle ||
        !targets.eligibleProductHandles.includes(meta.productHandle)
      )
        return false;
    } else if (mode === "COLLECTIONS") {
      if (!targets.eligibleCollectionHandles.length) return false;
      if (
        !hasIntersection(
          meta && meta.collectionHandles ? meta.collectionHandles : [],
          targets.eligibleCollectionHandles
        )
      )
        return false;
    }

    if (
      meta &&
      meta.productHandle &&
      targets.excludedProductHandles.includes(meta.productHandle)
    )
      return false;
    if (
      hasIntersection(
        meta && meta.collectionHandles ? meta.collectionHandles : [],
        targets.excludedCollectionHandles
      )
    )
      return false;
    return true;
  }

  function isProductMount(mount) {
    return Boolean(mount && mount.dataset.surface === "product");
  }

  function cartHasRegularLineItems(cart) {
    return Boolean(
      cart &&
        Array.isArray(cart.items) &&
        cart.items.some(function (item) {
          return (
            item && Number(item.quantity || 0) > 0 && !isSystemGiftItem(item)
          );
        })
    );
  }

  function mountProductMeta(mount) {
    return {
      productHandle: normalizeHandle(mount && mount.dataset.productHandle),
      collectionHandles: normalizeHandleList(
        mount && mount.dataset.collectionHandles
      ),
    };
  }

  function isMountEligibleForCampaign(mount, campaign) {
    if (!isProductMount(mount)) return true;
    var meta = mountProductMeta(mount);
    if (!meta.productHandle && !meta.collectionHandles.length) return false;
    return isTargetMetaEligibleForCampaign(meta, campaign);
  }

  function canOpenDiscoverForMount(mount, source, campaign, unlocked) {
    if (unlocked || (mount && mount.dataset.hideDiscover === "true"))
      return false;
    return hasDiscoverProducts(source, campaign);
  }

  function finalLinePriceCents(item) {
    if (!item) return 0;
    if (typeof item.final_line_price === "number") return item.final_line_price;
    if (typeof item.line_price === "number") return item.line_price;
    if (typeof item.final_price === "number") {
      return item.final_price * Number(item.quantity || 0);
    }
    return 0;
  }

  function originalLinePriceCents(item) {
    if (!item) return 0;
    if (typeof item.original_line_price === "number")
      return item.original_line_price;
    if (typeof item.original_price === "number") {
      return item.original_price * Number(item.quantity || 0);
    }
    if (typeof item.price === "number") {
      return item.price * Number(item.quantity || 0);
    }
    return finalLinePriceCents(item);
  }

  function eligibleOriginalSubtotalCents(cart, campaign) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (total, item) {
      if (
        isSystemGiftItem(item) ||
        !isLineEligibleForCampaign(item, campaign)
      ) {
        return total;
      }
      return total + originalLinePriceCents(item);
    }, 0);
  }

  function eligibleSubtotal(cart, campaign) {
    return eligibleOriginalSubtotalCents(cart, campaign) / 100;
  }

  function eligibleQuantity(cart, campaign) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (total, item) {
      return (
        total +
        (isSystemGiftItem(item) || !isLineEligibleForCampaign(item, campaign)
          ? 0
          : Number(item.quantity || 0))
      );
    }, 0);
  }

  function campaignThresholdType(campaign) {
    return campaign && campaign.thresholdType === "QUANTITY"
      ? "QUANTITY"
      : "SUBTOTAL";
  }

  function campaignBenefitType(campaign) {
    if (!campaign) return "";
    if (campaign.benefitType) return campaign.benefitType;
    return campaign.type === GIFT_TYPE ? GIFT_TYPE : "FIXED_AMOUNT_OFF";
  }

  function campaignBasis(cart, campaign) {
    return campaignThresholdType(campaign) === "QUANTITY"
      ? eligibleQuantity(cart, campaign)
      : eligibleSubtotal(cart, campaign);
  }

  function tierThreshold(tier) {
    return Number((tier && tier.thresholdValue) || 0);
  }

  function sortTiers(campaign) {
    return (campaign && Array.isArray(campaign.tiers) ? campaign.tiers : [])
      .slice()
      .sort(function (left, right) {
        return tierThreshold(left) - tierThreshold(right);
      });
  }

  function isRepeatablePackCampaign(campaign) {
    var benefitType = campaignBenefitType(campaign);
    return (
      benefitType === BUY_N_PAY_M_TYPE || benefitType === BUY_X_GET_Y_TYPE
    );
  }

  function buyXGetYTierPercentage(tier) {
    var percentage = Number(tier && tier.percentage);
    if (percentage >= 1 && percentage <= 100) return percentage;

    // Read legacy bootstrap payloads during a staggered app/theme rollout.
    var customerPaysPercentage = Number(
      tier && tier.customerPaysPercentage
    );
    return customerPaysPercentage > 0 && customerPaysPercentage < 100
      ? 100 - customerPaysPercentage
      : 0;
  }

  function repeatablePackTierOptions(campaign) {
    var benefitType = campaignBenefitType(campaign);
    return sortTiers(campaign)
      .map(function (tier, index) {
        var thresholdQuantity = Math.floor(tierThreshold(tier));
        if (
          thresholdQuantity < 2 ||
          thresholdQuantity !== tierThreshold(tier)
        ) {
          return null;
        }
        if (benefitType === BUY_N_PAY_M_TYPE) {
          var payQuantity = Math.floor(Number(tier.payQuantity || 0));
          if (payQuantity < 1 || payQuantity >= thresholdQuantity) return null;
          return {
            discountBasisPoints: 10000,
            rewardQuantity: thresholdQuantity - payQuantity,
            sourceIndex: index,
            thresholdQuantity: thresholdQuantity,
            tier: tier,
          };
        }
        if (benefitType === BUY_X_GET_Y_TYPE) {
          var discountedQuantity = Math.floor(
            Number(tier.discountedQuantity || 0)
          );
          var percentage = buyXGetYTierPercentage(tier);
          if (
            discountedQuantity < 1 ||
            discountedQuantity >= thresholdQuantity ||
            percentage < 1 ||
            percentage > 100
          ) {
            return null;
          }
          return {
            percentage: percentage,
            discountBasisPoints: Math.round(percentage * 100),
            rewardQuantity: discountedQuantity,
            sourceIndex: index,
            thresholdQuantity: thresholdQuantity,
            tier: tier,
          };
        }
        return null;
      })
      .filter(Boolean);
  }

  function repeatablePackPlan(campaign, basis) {
    var tiers = repeatablePackTierOptions(campaign);
    var eligibleQuantity = Math.min(
      10000,
      Math.max(0, Math.floor(Number(basis || 0)))
    );
    if (!tiers.length || !eligibleQuantity) return null;
    // The highest configured tier defines a cycle; its remainder uses at most
    // one lower tier so configured progression stays deterministic.
    var highestTierIndex = tiers.length - 1;
    var highestTier = tiers[highestTierIndex];
    var cycleCount = Math.floor(
      eligibleQuantity / highestTier.thresholdQuantity
    );
    var remainder = eligibleQuantity % highestTier.thresholdQuantity;
    var partialTierIndex = -1;
    tiers.forEach(function (tier, tierIndex) {
      if (tier.thresholdQuantity <= remainder) {
        partialTierIndex = tierIndex;
      }
    });

    var tierCounts = new Array(tiers.length).fill(0);
    if (cycleCount > 0) tierCounts[highestTierIndex] = cycleCount;
    if (partialTierIndex >= 0) tierCounts[partialTierIndex] += 1;

    if (!cycleCount && partialTierIndex < 0) return null;
    return {
      tierCounts: tierCounts,
      tiers: tiers,
    };
  }

  function repeatablePackRewardQuantity(plan) {
    if (!plan) return 0;
    return plan.tierCounts.reduce(function (total, count, index) {
      return total + count * plan.tiers[index].rewardQuantity;
    }, 0);
  }

  function buyXGetYPlanSegments(campaign, basis) {
    var plan = repeatablePackPlan(campaign, basis);
    if (!plan) return [];
    return plan.tierCounts
      .map(function (count, index) {
        if (!count) return null;
        var tier = plan.tiers[index];
        return {
          percentage: tier.percentage,
          discountBasisPoints: tier.discountBasisPoints,
          quantity: count * tier.rewardQuantity,
        };
      })
      .filter(Boolean)
      .sort(function (left, right) {
        return right.discountBasisPoints - left.discountBasisPoints;
      });
  }

  function buyXGetYPlanSignature(segments) {
    return JSON.stringify(
      (segments || []).map(function (segment) {
        return [
          Number(segment.discountBasisPoints || 0),
          Number(segment.quantity || 0),
        ];
      })
    );
  }

  function buyXGetYAddedSegments(currentSegments, nextSegments) {
    var currentByDiscount = new Map();
    (currentSegments || []).forEach(function (segment) {
      currentByDiscount.set(
        Number(segment.discountBasisPoints || 0),
        Number(segment.quantity || 0)
      );
    });
    var nextByDiscount = new Map();
    (nextSegments || []).forEach(function (segment) {
      nextByDiscount.set(
        Number(segment.discountBasisPoints || 0),
        Number(segment.quantity || 0)
      );
    });
    var preservesCurrentRewards = Array.from(currentByDiscount).every(function (
      entry
    ) {
      return Number(nextByDiscount.get(entry[0]) || 0) >= entry[1];
    });
    if (!preservesCurrentRewards) return [];
    return (nextSegments || [])
      .map(function (segment) {
        var previousQuantity = Number(
          currentByDiscount.get(Number(segment.discountBasisPoints || 0)) || 0
        );
        var quantity = Number(segment.quantity || 0) - previousQuantity;
        if (quantity <= 0) return null;
        return {
          percentage: segment.percentage,
          discountBasisPoints: segment.discountBasisPoints,
          quantity: quantity,
        };
      })
      .filter(Boolean);
  }

  function buyXGetYRepeatableProgress(campaign, basis) {
    var eligibleQuantity = Math.max(0, Math.floor(Number(basis || 0)));
    var currentSegments = buyXGetYPlanSegments(campaign, eligibleQuantity);
    var currentSignature = buyXGetYPlanSignature(currentSegments);
    var tierOptions = repeatablePackTierOptions(campaign);
    var searchLimit = tierOptions.reduce(function (highest, option) {
      return Math.max(highest, Number(option.thresholdQuantity || 0));
    }, 0);
    var nextQuantity = null;
    var nextSegments = [];
    for (var offset = 1; offset <= searchLimit; offset += 1) {
      var candidateQuantity = eligibleQuantity + offset;
      var candidateSegments = buyXGetYPlanSegments(
        campaign,
        candidateQuantity
      );
      if (buyXGetYPlanSignature(candidateSegments) === currentSignature) {
        continue;
      }
      nextQuantity = candidateQuantity;
      nextSegments = candidateSegments;
      break;
    }
    var addedSegments = buyXGetYAddedSegments(
      currentSegments,
      nextSegments
    );
    return {
      addedSegments: addedSegments,
      currentSegments: currentSegments,
      eligibleQuantity: eligibleQuantity,
      firstRoundComplete: searchLimit > 0 && eligibleQuantity >= searchLimit,
      nextQuantity: nextQuantity,
      nextSegments: nextSegments,
      isUpgrade:
        currentSegments.length > 0 &&
        (addedSegments.length !== 1 ||
          addedSegments.reduce(function (total, segment) {
            return total + Number(segment.quantity || 0);
          }, 0) <= 0),
    };
  }

  function centsFromAmount(amount) {
    return Math.max(0, Math.round(Number(amount || 0) * 100));
  }

  function formatMoney(amount, mount) {
    var cents = centsFromAmount(amount);
    return formatMoneyCents(cents, mount);
  }

  function formatMoneyCents(cents, source) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(
        cents,
        source && source.dataset.moneyFormat
      );
    }
    var currency =
      source && source.dataset.currencyCode
        ? source.dataset.currencyCode
        : "USD";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency,
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return "$" + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function projectedCartTotalCents(cart) {
    return Math.max(
      0,
      cart && typeof cart.total_price === "number" ? cart.total_price : 0
    );
  }

  function updateCartSavingsSummary() {
    var appliedSavingsCents = Math.max(
      0,
      state.cart && typeof state.cart.total_discount === "number"
        ? state.cart.total_discount
        : 0
    );
    document
      .querySelectorAll("[data-cart-savings-row]")
      .forEach(function (row) {
        var baseSavingsCents =
          state.cart && typeof state.cart.total_discount === "number"
            ? appliedSavingsCents
            : Math.max(0, Number(row.dataset.baseSavingsCents || 0));
        var totalSavingsCents = Math.max(0, baseSavingsCents);
        var amount = row.querySelector("[data-cart-savings-amount]");
        row.hidden = totalSavingsCents <= 0;
        if (amount)
          amount.textContent = formatMoneyCents(totalSavingsCents, row);
        var fallbackLabel = row.dataset.labelOtherDiscount || "Other discount";
        var reconciliationFallbackLabel = cartHasLoyaltyDiscountCode(state.cart)
          ? row.dataset.labelPointsDiscount || "Points"
          : fallbackLabel;
        var breakdown = cartDiscountSavingsBreakdown(
          state.cart,
          totalSavingsCents,
          reconciliationFallbackLabel,
          null
        );
        renderCartSavingsBreakdown(
          row,
          reconcileSavingsBreakdown(
            breakdown,
            totalSavingsCents,
            reconciliationFallbackLabel
          ),
          totalSavingsCents
        );
      });
  }

  function promotionSavingsBreakdown() {
    if (!state.cart || !Array.isArray(state.cart.items)) return [];
    return activeCampaigns().reduce(function (items, campaign) {
      var appliedCents = appliedCampaignSavingsCents(campaign, state.cart);
      var label = String((campaign && campaign.name) || "").trim();
      if (appliedCents <= 0 || !label) return items;
      items.push({
        appliedCents: appliedCents,
        label: label,
        savingsCents: appliedCents,
      });
      return items;
    }, []);
  }

  function cartDiscountSavingsBreakdown(
    cart,
    maximumCents,
    fallbackLabel,
    excludeEntry
  ) {
    var maximum = Math.max(0, Math.round(Number(maximumCents) || 0));
    if (!maximum) return [];
    var entries = cartDiscountLedgerEntries(
      cart,
      activeCampaigns(),
      fallbackLabel
    );
    var remaining = maximum;
    var breakdown = [];
    entries.forEach(function (entry) {
      if (
        remaining <= 0 ||
        entry.amountCents <= 0 ||
        (typeof excludeEntry === "function" && excludeEntry(entry))
      )
        return;
      var amountCents = Math.min(remaining, entry.amountCents);
      addSavingsBreakdownItem(breakdown, entry.label, amountCents);
      remaining -= amountCents;
    });
    if (remaining > 0) {
      addSavingsBreakdownItem(breakdown, fallbackLabel, remaining);
    }
    return breakdown;
  }

  function cartDiscountLedgerEntries(cart, campaigns, fallbackLabel) {
    var campaignList = Array.isArray(campaigns) ? campaigns : [];
    var entries = [];
    var entriesByKey = new Map();

    function getEntry(application, item) {
      var title = discountApplicationTitle(application, fallbackLabel);
      var type = String((application && application.type) || "automatic");
      var campaign = campaignForDiscountApplication(
        application,
        item,
        campaignList
      );
      var campaignId = String((campaign && campaign.id) || "");
      var key = campaignId
        ? "campaign|" + campaignId
        : type.toLowerCase() + "|" + title.toLowerCase();
      if (!entriesByKey.has(key)) {
        var entry = {
          amountCents: 0,
          campaignId: campaignId,
          cartLevelAmountCents: 0,
          label: String((campaign && campaign.name) || title).trim(),
          type: type,
        };
        entriesByKey.set(key, entry);
        entries.push(entry);
      }
      return entriesByKey.get(key);
    }

    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function (application) {
        var entry = getEntry(application, null);
        entry.cartLevelAmountCents = Math.max(
          0,
          Math.round(Number(application.total_allocated_amount) || 0)
        );
      });
    }
    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        var allocations = lineDiscountAllocations(item);
        allocations.forEach(function (allocation) {
          var entry = getEntry(allocation.discount_application || {}, item);
          entry.amountCents += Math.max(
            0,
            Math.round(Number(allocation.amount) || 0)
          );
        });
      });
    }

    entries.forEach(function (entry) {
      if (entry.cartLevelAmountCents > 0) {
        entry.amountCents = entry.cartLevelAmountCents;
      }
    });
    entries.sort(function (left, right) {
      var leftCode = left.type === "discount_code" ? 0 : 1;
      var rightCode = right.type === "discount_code" ? 0 : 1;
      return leftCode - rightCode;
    });
    return entries;
  }

  function discountApplicationTitle(application, fallbackLabel) {
    return String(
      (application && (application.title || application.code)) ||
        fallbackLabel ||
        "Other discount"
    ).trim();
  }

  function lineDiscountAllocations(item) {
    return item && Array.isArray(item.line_level_discount_allocations)
      ? item.line_level_discount_allocations
      : [];
  }

  function campaignForDiscountApplication(application, item, campaigns) {
    var type = String((application && application.type) || "automatic")
      .trim()
      .toLowerCase();
    if (type !== "discount_code" && isSystemGiftItem(item)) {
      var giftCampaignId = String(
        getProperty(item, SYSTEM_GIFT_CAMPAIGN) || ""
      );
      var giftCampaign = campaigns.find(function (campaign) {
        return String((campaign && campaign.id) || "") === giftCampaignId;
      });
      if (giftCampaign) return giftCampaign;
    }
    if (type === "discount_code") return null;
    var title = discountApplicationTitle(application, "").toLowerCase();
    if (!title) return null;
    var exactMatches = campaigns.filter(function (campaign) {
      return campaignDiscountApplicationTitles(campaign).some(function (
        candidate
      ) {
        return candidate === title;
      });
    });
    if (exactMatches.length === 1) return exactMatches[0];
    var prefixedMatches = campaigns.filter(function (campaign) {
      var name = String((campaign && campaign.name) || "")
        .trim()
        .toLowerCase();
      return Boolean(name && title.indexOf(name + " [") === 0);
    });
    return prefixedMatches.length === 1 ? prefixedMatches[0] : null;
  }

  function campaignDiscountApplicationTitles(campaign) {
    return [
      campaign && campaign.discountApplicationTitle,
      campaign && campaign.name,
    ]
      .map(function (value) {
        return String(value || "")
          .trim()
          .toLowerCase();
      })
      .filter(Boolean);
  }

  function addSavingsBreakdownItem(items, label, amountCents) {
    var amount = Math.max(0, Math.round(Number(amountCents) || 0));
    var text = String(label || "").trim();
    if (!amount || !text) return items;
    var existing = items.find(function (item) {
      return item.label.toLowerCase() === text.toLowerCase();
    });
    if (existing) {
      existing.amountCents += amount;
    } else {
      items.push({ amountCents: amount, label: text });
    }
    return items;
  }

  function reconcileSavingsBreakdown(items, totalCents, fallbackLabel) {
    var remaining = Math.max(0, Math.round(Number(totalCents) || 0));
    var reconciled = [];
    items.forEach(function (item) {
      if (remaining <= 0) return;
      var amountCents = Math.min(
        remaining,
        Math.max(0, Math.round(Number(item.amountCents) || 0))
      );
      addSavingsBreakdownItem(reconciled, item.label, amountCents);
      remaining -= amountCents;
    });
    if (remaining > 0) {
      addSavingsBreakdownItem(reconciled, fallbackLabel, remaining);
    }
    return reconciled;
  }

  function renderCartSavingsBreakdown(row, items, totalSavingsCents) {
    var total = row.querySelector("[data-cart-savings-details-total]");
    if (total) {
      total.textContent = formatMoneyCents(totalSavingsCents, row);
    }
    var list = row.querySelector("[data-cart-savings-breakdown]");
    if (!list) return;
    var displayItems = [];
    items.forEach(function (item) {
      addSavingsBreakdownItem(
        displayItems,
        savingsDisplayLabel(item.label, row),
        item.amountCents
      );
    });
    list.innerHTML = displayItems
      .map(function (item) {
        return (
          '<li class="minicart-savings-details__item">' +
          "<span>" +
          escapeHtml(item.label) +
          "</span>" +
          "<span>-" +
          escapeHtml(formatMoneyCents(item.amountCents, row)) +
          "</span>" +
          "</li>"
        );
      })
      .join("");
  }

  function savingsDisplayLabel(value, row) {
    var label = String(value || "").trim();
    if (!LOYALTY_DISCOUNT_CODE_PATTERN.test(label)) return label;
    return (
      String(
        (row && row.dataset && row.dataset.labelPointsDiscount) || "Points"
      ).trim() || "Points"
    );
  }

  function cartHasLoyaltyDiscountCode(cart) {
    var codes = [];
    if (cart && Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (discount) {
        if (!discount || discount.applicable === false) return;
        codes.push(discount.code || discount.title || "");
      });
    }
    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function (application) {
        if (!application || application.type !== "discount_code") return;
        codes.push(application.title || application.code || "");
      });
    }
    return codes.some(function (code) {
      return LOYALTY_DISCOUNT_CODE_PATTERN.test(String(code || "").trim());
    });
  }

  function effectiveCampaignSavingsCents(campaign, cart) {
    return appliedCampaignSavingsCents(campaign, cart);
  }

  function appliedCampaignSavingsCents(campaign, cart) {
    var campaignId = String((campaign && campaign.id) || "");
    if (!campaignId || !cart) return 0;
    var campaigns = activeCampaigns().slice();
    if (
      !campaigns.some(function (activeCampaign) {
        return (
          String((activeCampaign && activeCampaign.id) || "") === campaignId
        );
      })
    ) {
      campaigns.push(campaign);
    }
    return cartDiscountLedgerEntries(cart, campaigns, "").reduce(function (
      total,
      entry
    ) {
      return entry.campaignId === campaignId
        ? total + Math.max(0, Number(entry.amountCents) || 0)
        : total;
    },
    0);
  }

  function template(text, values) {
    return Object.keys(values).reduce(function (result, key) {
      return result.replace(
        new RegExp("{{\\s*" + key + "\\s*}}", "g"),
        values[key]
      );
    }, text);
  }

  function compactText(value, maxLength) {
    var text = String(value || "")
      .replace(/\s+/g, " ")
      .trim();
    var limit = Number(maxLength || 0);
    if (!limit || text.length <= limit) return text;
    return text.slice(0, Math.max(1, limit - 3)).replace(/\s+$/, "") + "...";
  }

  async function fetchJson(url, options) {
    var response = await fetch(url, options);
    if (!response.ok) throw new Error("Request failed: " + response.status);
    return response.json();
  }

  async function fetchBootstrap(mount) {
    if (!mount || !mount.dataset.proxyPath) {
      return {
        ok: true,
        serverNow: new Date().toISOString(),
        activeCampaigns: [],
      };
    }
    var url = new URL(mount.dataset.proxyPath, window.location.origin);
    if (mount.dataset.marketId) {
      url.searchParams.set("marketId", mount.dataset.marketId);
    }
    if (mount.dataset.currencyCode) {
      url.searchParams.set("currencyCode", mount.dataset.currencyCode);
    }
    url.searchParams.set("_ssv", BOOTSTRAP_CACHE_VERSION);
    return fetchJson(url.toString(), {
      cache: "no-store",
      credentials: "same-origin",
    });
  }

  function bootstrapNeedsRefresh(options) {
    return Boolean(
      !state.bootstrap ||
        (options && options.refreshBootstrap === true) ||
        !state.bootstrapFetchedAt ||
        Date.now() - state.bootstrapFetchedAt >= BOOTSTRAP_TTL_MS
    );
  }

  function loadBootstrap(mount, options) {
    if (!bootstrapNeedsRefresh(options)) {
      return Promise.resolve(state.bootstrap);
    }
    if (state.bootstrapPromise) return state.bootstrapPromise;
    state.bootstrapPromise = fetchBootstrap(mount)
      .then(function (bootstrap) {
        state.bootstrap = bootstrap;
        state.bootstrapFetchedAt = Date.now();
        scheduleExpiryRefresh();
        return bootstrap;
      })
      .catch(function (error) {
        if (!state.bootstrap) throw error;
        console.warn("Unable to refresh cart promotion campaigns", error);
        return state.bootstrap;
      })
      .finally(function () {
        state.bootstrapPromise = null;
      });
    return state.bootstrapPromise;
  }

  async function fetchCart() {
    return fetchJson(
      (window.routes && window.routes.cart_url
        ? window.routes.cart_url
        : "/cart") + ".js",
      {
        credentials: "same-origin",
      }
    );
  }

  function activeCampaign() {
    return globalCampaign() || activeCampaigns()[0] || null;
  }

  function activeCampaigns() {
    if (!state.bootstrap) return [];
    if (Array.isArray(state.bootstrap.activeCampaigns)) {
      return state.bootstrap.activeCampaigns.filter(function (campaign) {
        return (
          campaign && CART_BENEFIT_TYPES.includes(campaignBenefitType(campaign))
        );
      });
    }
    return [];
  }

  function campaignById(campaignId) {
    if (!campaignId) return null;
    return (
      activeCampaigns().find(function (campaign) {
        return String(campaign.id) === String(campaignId);
      }) || null
    );
  }

  function globalCampaign() {
    return (
      activeCampaigns().find(function (campaign) {
        return isGlobalCampaign(campaign);
      }) || null
    );
  }

  function isGlobalCampaign(campaign) {
    return isAllTargetCampaign(campaign);
  }

  function firstGiftCampaign() {
    return activeCampaigns().find(isGiftCampaign) || null;
  }

  function firstPriceCampaign() {
    return activeCampaigns().find(isPriceCampaign) || null;
  }

  function isGiftCampaign(campaign) {
    return Boolean(
      campaign &&
        (campaign.benefitType === GIFT_TYPE || campaign.type === GIFT_TYPE)
    );
  }

  function isPriceCampaign(campaign) {
    return Boolean(
      campaign && PRICE_BENEFIT_TYPES.includes(campaignBenefitType(campaign))
    );
  }

  function renderAllMounts() {
    var cart = state.cart;
    var global = globalCampaign();
    state.isRendering = true;
    updateGiftLineTitles(cart);
    getMounts().forEach(function (mount) {
      if (mount.dataset.kind === "groups") {
        renderActivityGroups(mount, cart);
      } else if (mount.dataset.kind === "gift") {
        renderGlobalMount(mount, global, cart);
      } else {
        renderGlobalMount(mount, global, cart);
      }
    });
    updateCartSavingsSummary();
    window.setTimeout(function () {
      state.isRendering = false;
    }, 0);
  }

  function syncLoyaltyCartSnapshot(cart) {
    var loyaltyRuntime = window.SilkSilkyLoyaltyCartRedemption;
    if (
      !isCartSnapshot(cart) ||
      !loyaltyRuntime ||
      typeof loyaltyRuntime.syncCartSnapshot !== "function"
    ) {
      return false;
    }
    return loyaltyRuntime.syncCartSnapshot(cart) !== false;
  }

  function isCartSnapshot(value) {
    return Boolean(
      value && Array.isArray(value.items) && value.item_count != null
    );
  }

  function cartSnapshotCoversRenderedLines(cart) {
    if (!isCartSnapshot(cart)) return false;
    var renderedKeys = renderedCartLineKeys();
    if (!renderedKeys.size) return true;
    var cartKeys = new Set();
    cart.items.forEach(function (item) {
      if (item && item.key) cartKeys.add(String(item.key));
    });
    return Array.from(renderedKeys).every(function (key) {
      return cartKeys.has(key);
    });
  }

  function renderedCartLineKeys() {
    return Array.from(document.querySelectorAll("[data-ss-line-key]")).reduce(
      function (keys, node) {
        if (node && node.dataset && node.dataset.ssLineKey) {
          keys.add(String(node.dataset.ssLineKey));
        }
        return keys;
      },
      new Set()
    );
  }

  function renderCartSnapshot(cart) {
    if (
      !isCartSnapshot(cart) ||
      !state.bootstrap ||
      state.isSyncing ||
      !cartSnapshotCoversRenderedLines(cart)
    ) {
      return false;
    }
    var mount = getPrimaryMount();
    if (!mount) return false;
    state.cart = cart;
    ensureRuntimeMounts(mount);
    renderAllMounts();
    return true;
  }

  function hideMount(mount) {
    mount.innerHTML = "";
    if (mount) delete mount.__ssCartPromotionSignature;
    mount.hidden = true;
  }

  function renderGlobalMount(mount, campaign, cart) {
    if (!isProductMount(mount) && !cartHasRegularLineItems(cart)) {
      hideMount(mount);
      return;
    }
    if (shouldRenderCombinedGlobalMount(mount)) {
      renderCombinedGlobalMount(mount, campaign, cart);
      return;
    }
    if (!campaign) {
      hideMount(mount);
      return;
    }
    if (isGiftCampaign(campaign)) {
      renderGiftPromptMount(mount, campaign, cart);
      return;
    }
    renderAmountMount(mount, campaign, cart);
  }

  function shouldRenderCombinedGlobalMount(mount) {
    return Boolean(
      mount &&
        mount.dataset &&
        mount.dataset.kind === "global" &&
        !isProductMount(mount)
    );
  }

  function renderAmountMount(mount, campaign, cart) {
    if (
      !campaign ||
      !isPriceCampaign(campaign) ||
      !cart ||
      !isMountEligibleForCampaign(mount, campaign)
    ) {
      hideMount(mount);
      return;
    }
    var labels = getLabels(mount);
    var progress = campaignProgress(campaign, cart, mount, labels);
    var tiers = sortTiers(campaign);
    if (!tiers.length) {
      hideMount(mount);
      return;
    }
    var text;
    var unlocked = false;
    if (progress.nextTier) {
      if (
        campaignBenefitType(campaign) === BUY_N_PAY_M_TYPE ||
        campaignBenefitType(campaign) === "FIXED_BUNDLE_PRICE"
      ) {
        text = priceGapSentence(
          campaign,
          tierThreshold(progress.nextTier) - Number(progress.basis || 0),
          progress.nextTier,
          mount,
          labels
        );
      } else {
        text = template(labels.amountLocked, {
          amount:
            campaignThresholdType(campaign) === "QUANTITY"
              ? String(
                  Math.max(
                    0,
                    Math.ceil(
                      tierThreshold(progress.nextTier) -
                        Number(progress.basis || 0)
                    )
                  )
                )
              : formatMoney(
                  tierThreshold(progress.nextTier) -
                    Number(progress.basis || 0),
                  mount
                ),
          reward: discountOffRewardText(
            campaign,
            progress.nextTier,
            mount,
            labels
          ),
        });
      }
    } else {
      unlocked = true;
      var best = progress.currentTier || tiers[tiers.length - 1];
      text = priceUnlockedText(campaign, best, mount, labels);
    }
    var canOpenDiscover = canOpenDiscoverForMount(
      mount,
      "campaign",
      campaign,
      unlocked
    );
    var helpHtml = descriptionHelpButtonHtml(
      campaign,
      "ss-cart-promotion-message__help"
    );
    mount.hidden = false;
    mount.innerHTML =
      '<div class="ss-cart-promotion-message' +
      (unlocked ? " is-unlocked" : "") +
      '">' +
      '<span class="ss-cart-promotion-message__text">' +
      '<span class="ss-cart-promotion-message__label">' +
      text +
      "</span>" +
      helpHtml +
      "</span>" +
      (canOpenDiscover
        ? '<button type="button" class="ss-cart-promotion-link" ' +
          promotionDiscoverActionAttributes(campaign) +
          ">" +
          escapeHtml(labels.add) +
          "</button>"
        : "") +
      priceTierProgressHtml(campaign, progress, labels, mount) +
      "</div>";
  }

  function renderGiftMount(mount, campaign, cart) {
    if (
      !campaign ||
      !isGiftCampaign(campaign) ||
      !cart ||
      !isMountEligibleForCampaign(mount, campaign)
    ) {
      hideMount(mount);
      return;
    }
    var labels = getLabels(mount);
    var basis = campaignBasis(cart, campaign);
    var tiers = sortTiers(campaign);
    if (!tiers.length) {
      hideMount(mount);
      return;
    }
    var tier = currentGiftTier(campaign, tiers, basis);
    if (!tier) {
      hideMount(mount);
      return;
    }
    mount.hidden = false;
    mount.innerHTML =
      '<div class="ss-cart-promotion-gifts">' +
      giftTierHtml(tier, basis, labels, mount, campaign) +
      "</div>";
    hydrateGiftSellingPrice(mount, tier);
  }

  function renderGiftPromptMount(mount, campaign, cart) {
    if (
      !campaign ||
      !isGiftCampaign(campaign) ||
      !cart ||
      !isMountEligibleForCampaign(mount, campaign)
    ) {
      hideMount(mount);
      return;
    }
    var labels = getLabels(mount);
    var progress = campaignProgress(campaign, cart, mount, labels);
    if (!progress || !progress.displayTier) {
      hideMount(mount);
      return;
    }
    mount.hidden = false;
    mount.innerHTML = giftPromptHtml(campaign, cart, labels, mount);
  }

  function renderCombinedGlobalMount(mount, campaign, cart) {
    if (!cart) {
      hideMount(mount);
      return;
    }
    var eligibleCampaign =
      campaign && isMountEligibleForCampaign(mount, campaign) ? campaign : null;
    var labels = getLabels(mount);
    var shippingProgress = freeShippingProgressForMount(mount, cart);
    var shippingPresentation = combinedShippingPresentation(
      shippingProgress,
      eligibleCampaign
    );
    var presentedCampaign = shippingPresentation.campaign;
    var milestones = combinedPromotionMilestones(
      shippingPresentation.milestoneProgress,
      presentedCampaign,
      cart,
      mount,
      labels
    );
    if (!milestones.length) {
      hideMount(mount);
      return;
    }

    var nextMilestone =
      milestones.find(function (milestone) {
        return !milestone.unlocked;
      }) || null;
    var isUnlocked = !nextMilestone;
    var promptHtml = combinedPromotionPromptHtml(
      nextMilestone,
      milestones,
      presentedCampaign,
      shippingPresentation.milestoneProgress,
      labels,
      mount,
      cart
    );
    var helpHtml =
      presentedCampaign && (!nextMilestone || nextMilestone.type !== "shipping")
        ? descriptionHelpButtonHtml(
            presentedCampaign,
            "ss-cart-promotion-gift-row__help"
          )
        : "";
    var unlockedSummaryHtml = combinedUnlockedSummaryHtml(
      milestones,
      shippingProgress,
      labels,
      mount
    );

    mount.hidden = false;
    mount.innerHTML =
      '<div class="ss-cart-promotion-gift-row ss-cart-promotion-combined-row' +
      (isUnlocked ? " is-unlocked" : "") +
      '">' +
      '<span class="ss-cart-promotion-gift-row__icon" aria-hidden="true">' +
      combinedPromptIcon(
        nextMilestone,
        shippingPresentation.milestoneProgress
      ) +
      "</span>" +
      '<span class="ss-cart-promotion-gift-row__text">' +
      '<span class="ss-cart-promotion-combined-row__primary">' +
      '<span class="ss-cart-promotion-gift-row__label">' +
      promptHtml +
      "</span>" +
      helpHtml +
      "</span>" +
      unlockedSummaryHtml +
      "</span>" +
      combinedPromotionActionHtml(nextMilestone, mount, labels) +
      combinedPromotionProgressHtml(milestones, labels) +
      "</div>";
  }

  function combinedShippingPresentation(shippingProgress, campaign) {
    if (!shippingProgress) {
      return {
        campaign: campaign,
        milestoneProgress: null,
      };
    }
    if (!shippingProgress.unlocked) {
      return {
        campaign: null,
        milestoneProgress: shippingProgress,
      };
    }
    return {
      campaign: campaign,
      milestoneProgress: shippingProgress,
    };
  }

  function combinedUnlockedSummaryHtml(
    milestones,
    shippingProgress,
    labels,
    mount
  ) {
    if (!shippingProgress || !shippingProgress.unlocked) return "";
    if (
      !milestones.some(function (milestone) {
        return milestone.type !== "shipping";
      })
    ) {
      return "";
    }
    var unlockedGiftCount = milestones.filter(function (milestone) {
      return milestone.type === "gift" && milestone.unlocked;
    }).length;
    var unlockedPriceMilestones = milestones.filter(function (milestone) {
      return milestone.type === "price" && milestone.unlocked;
    });
    var unlockedPriceMilestone =
      unlockedPriceMilestones[unlockedPriceMilestones.length - 1] || null;
    var shipping = freeShippingLabel(labels, shippingProgress);
    var text;
    if (unlockedGiftCount) {
      text = template(
        unlockedGiftCount === 1
          ? labels.shippingGiftUnlockedOne
          : labels.shippingGiftUnlockedOther,
        {
          count: String(unlockedGiftCount),
          shipping: shipping,
        }
      );
    } else if (
      unlockedPriceMilestone &&
      isDiscountOffCampaign(unlockedPriceMilestone.campaign)
    ) {
      text = template(labels.shippingPriceUnlocked, {
        reward: discountOffRewardText(
          unlockedPriceMilestone.campaign,
          unlockedPriceMilestone.tier,
          mount,
          labels
        ),
        shipping: shipping,
      });
    } else {
      text = template(labels.shippingUnlocked, {
        shipping: shipping,
      });
    }
    return (
      '<span class="ss-cart-promotion-combined-row__summary" title="' +
      escapeHtml(text) +
      '">' +
      escapeHtml(text) +
      "</span>"
    );
  }

  function combinedPromotionMilestones(
    shippingProgress,
    campaign,
    cart,
    mount,
    labels
  ) {
    var milestones = [];
    if (shippingProgress) {
      milestones.push({
        type: "shipping",
        basisType: "SUBTOTAL",
        label: freeShippingLabel(labels, shippingProgress),
        basis: shippingProgress.basis,
        previousThreshold: 0,
        threshold: shippingProgress.threshold,
        unlocked: shippingProgress.unlocked,
        gap: shippingProgress.gap,
      });
    }
    if (!campaign) return milestones;

    var campaignBasisValue = campaignBasis(cart, campaign);
    var tiers = sortTiers(campaign).filter(function (tier) {
      return tierThreshold(tier) > 0;
    });
    tiers.forEach(function (tier, index) {
      var threshold = tierThreshold(tier);
      milestones.push({
        type: isGiftCampaign(campaign) ? "gift" : "price",
        basisType: campaignThresholdType(campaign),
        campaign: campaign,
        tier: tier,
        index: index,
        label: combinedCampaignMilestoneLabel(
          campaign,
          tier,
          index,
          labels,
          mount
        ),
        basis: campaignBasisValue,
        previousThreshold: index > 0 ? tierThreshold(tiers[index - 1]) : 0,
        threshold: threshold,
        unlocked: campaignBasisValue >= threshold,
        gap: Math.max(0, threshold - campaignBasisValue),
        subtitle: isGiftCampaign(campaign)
          ? compactGiftTierTitle(tier, labels)
          : "",
      });
    });
    return orderCombinedPromotionMilestones(milestones);
  }

  function orderCombinedPromotionMilestones(milestones) {
    return milestones.slice();
  }

  function combinedPromotionPromptText(
    nextMilestone,
    milestones,
    campaign,
    shippingProgress,
    labels,
    mount,
    cart
  ) {
    if (nextMilestone) {
      if (nextMilestone.type === "shipping") {
        return freeShippingGapSentence(nextMilestone.gap, mount, labels);
      }
      if (nextMilestone.type === "gift") {
        return giftGapSentence(
          nextMilestone.campaign,
          nextMilestone.gap,
          combinedGiftGapRewardText(nextMilestone, milestones, labels),
          mount,
          labels
        );
      }
      return priceGapSentence(
        nextMilestone.campaign,
        nextMilestone.gap,
        nextMilestone.tier,
        mount,
        labels
      );
    }

    if (campaign && isGiftCampaign(campaign)) {
      return (
        String(campaign.name || "").trim() ||
        labels.allGiftsUnlocked ||
        "You've unlocked all free gifts"
      );
    }
    if (campaign && isPriceCampaign(campaign)) {
      var priceMilestone = lastCampaignMilestone(milestones);
      if (priceMilestone && priceMilestone.tier) {
        return priceUnlockedText(campaign, priceMilestone.tier, mount, labels);
      }
    }
    return template(labels.shippingUnlocked, {
      shipping: freeShippingLabel(labels, shippingProgress),
    });
  }

  function combinedPromotionPromptHtml(
    nextMilestone,
    milestones,
    campaign,
    shippingProgress,
    labels,
    mount,
    cart
  ) {
    if (nextMilestone) {
      if (nextMilestone.type === "shipping") {
        return freeShippingGapSentenceHtml(nextMilestone.gap, mount, labels);
      }
      if (nextMilestone.type === "gift") {
        return giftGapSentenceHtml(
          nextMilestone.campaign,
          nextMilestone.gap,
          combinedGiftGapRewardText(nextMilestone, milestones, labels),
          mount,
          labels
        );
      }
      return priceGapSentenceHtml(
        nextMilestone.campaign,
        nextMilestone.gap,
        nextMilestone.tier,
        mount,
        labels
      );
    }

    return escapeHtml(
      combinedPromotionPromptText(
        nextMilestone,
        milestones,
        campaign,
        shippingProgress,
        labels,
        mount,
        cart
      )
    );
  }

  function combinedGiftGapRewardText(nextMilestone, milestones, labels) {
    var hasUnlockedGift = milestones.some(function (milestone) {
      return milestone.type === "gift" && milestone.unlocked;
    });
    return giftGapRewardText(
      nextMilestone && nextMilestone.tier,
      labels,
      hasUnlockedGift
    );
  }

  function lastCampaignMilestone(milestones) {
    for (var index = milestones.length - 1; index >= 0; index -= 1) {
      if (milestones[index].campaign) return milestones[index];
    }
    return null;
  }

  function combinedPromotionActionHtml(nextMilestone, mount, labels) {
    if (!nextMilestone) return "";
    var attributes = "";
    if (nextMilestone.type === "shipping") {
      if (mount && mount.dataset.hideDiscover === "true") return "";
      if (!hasDiscoverProducts("free-shipping")) return "";
      attributes =
        'data-ss-cart-promotion-open data-ss-cart-promotion-source="free-shipping"';
    } else {
      if (
        !canOpenDiscoverForMount(
          mount,
          "campaign",
          nextMilestone.campaign,
          false
        )
      )
        return "";
      attributes = promotionDiscoverActionAttributes(nextMilestone.campaign);
    }
    return (
      '<button type="button" class="ss-cart-promotion-gift-row__action" ' +
      attributes +
      ">" +
      escapeHtml(labels.add || "Add") +
      "</button>"
    );
  }

  function combinedPromotionProgressHtml(milestones, labels) {
    var nextIndex = milestones.findIndex(function (milestone) {
      return !milestone.unlocked;
    });
    var isComplete = nextIndex < 0;
    var isShippingOnly =
      milestones.length === 1 && milestones[0].type === "shipping";
    var visibleMilestones = combinedVisibleMilestones(milestones, nextIndex);
    var focusIndex = isComplete
      ? visibleMilestones[visibleMilestones.length - 1]?.originalIndex
      : nextIndex;
    var segments = visibleMilestones
      .map(function (milestone, index) {
        var status = milestone.unlocked
          ? "earned"
          : milestone.originalIndex === nextIndex
          ? "current"
          : "future";
        var mode = combinedMilestoneDisplayMode(
          milestone,
          status,
          milestone.originalIndex === focusIndex
        );
        var label = isShippingOnly
          ? ""
          : combinedMilestoneDisplayLabel(milestone, mode, labels);
        var subtitle = combinedMilestoneDisplaySubtitle(milestone, mode);
        return (
          '<div class="ss-cart-promotion-gift-progress__segment ss-cart-promotion-gift-progress__segment--' +
          escapeHtml(milestone.type) +
          " is-" +
          status +
          " is-" +
          mode +
          '" role="listitem" style="--segment-flex:' +
          (mode === "expanded" ? 1 : 0) +
          ";--segment-width:" +
          combinedMilestoneWidth(milestone, mode) +
          ";--segment-fill:" +
          combinedMilestoneFill(
            milestone,
            milestones,
            milestone.originalIndex
          ).toFixed(2) +
          '%;--segment-node:100%;">' +
          '<span class="ss-cart-promotion-gift-progress__bar"><span class="ss-cart-promotion-gift-progress__fill"></span></span>' +
          '<span class="ss-cart-promotion-gift-progress__node" aria-hidden="true">' +
          combinedProgressNodeIcon(milestone, status) +
          "</span>" +
          combinedProgressLabelHtml(label, subtitle, milestone, mode) +
          "</div>"
        );
      })
      .join("");
    return (
      '<div class="ss-cart-promotion-gift-progress ss-cart-promotion-gift-progress--combined' +
      (isComplete ? " is-complete" : "") +
      (visibleMilestones.length === 1 ? " is-single" : "") +
      (isShippingOnly ? " is-shipping-only" : "") +
      '" role="list" aria-label="' +
      escapeHtml(
        isShippingOnly
          ? freeShippingLabel(labels, milestones[0])
          : combinedPromotionProgressAriaLabel(milestones, labels)
      ) +
      '">' +
      segments +
      "</div>"
    );
  }

  function combinedVisibleMilestones(milestones, nextIndex) {
    var indexed = milestones.map(function (milestone, index) {
      return Object.assign({ originalIndex: index }, milestone);
    });
    if (!usesCumulativeCombinedProgress(indexed)) {
      return combinedFocusedMilestones(indexed, nextIndex);
    }
    if (indexed.length <= 3) return indexed;
    var currentIndex = nextIndex >= 0 ? nextIndex : indexed.length - 1;
    var currentMilestone = indexed[currentIndex];
    var start = Math.max(0, currentIndex - 2);
    if (currentIndex < 2) start = 0;
    if (
      currentMilestone &&
      currentMilestone.type === "gift" &&
      Number(currentMilestone.index || 0) < 2
    ) {
      start = 0;
    }
    start = Math.min(start, Math.max(0, indexed.length - 3));
    return indexed.slice(start, start + 3);
  }

  function usesCumulativeCombinedProgress(milestones) {
    if (!Array.isArray(milestones)) return false;
    var rewardMilestones = milestones.filter(function (milestone) {
      return milestone.type !== "shipping";
    });
    return (
      rewardMilestones.length > 0 &&
      rewardMilestones.every(function (milestone) {
        return milestone.type === "gift";
      })
    );
  }

  function combinedFocusedMilestones(indexed, nextIndex) {
    if (!indexed.length) return indexed;
    var nextMilestone = nextIndex >= 0 ? indexed[nextIndex] : null;
    if (nextMilestone && nextMilestone.type === "shipping") {
      return indexed.filter(function (milestone) {
        return milestone === nextMilestone;
      });
    }
    var shippingMilestone = indexed.find(function (milestone) {
      return milestone.type === "shipping";
    });
    var focusedReward =
      nextMilestone ||
      indexed
        .slice()
        .reverse()
        .find(function (milestone) {
          return milestone.type !== "shipping";
        });
    return indexed.filter(function (milestone) {
      return milestone === shippingMilestone || milestone === focusedReward;
    });
  }

  function combinedPromotionProgressAriaLabel(milestones, labels) {
    var campaignMilestone = milestones.find(function (milestone) {
      return milestone.campaign;
    });
    var campaignName = String(
      (campaignMilestone && campaignMilestone.campaign.name) || ""
    ).trim();
    if (campaignName) return campaignName;
    var hasGift = milestones.some(function (milestone) {
      return milestone.type === "gift";
    });
    return hasGift
      ? (labels && labels.freeGift) || "Free Gift"
      : "Promotion rewards";
  }

  function combinedMilestoneDisplayMode(milestone, status, isFocus) {
    if (milestone && milestone.type === "shipping") return "compact";
    if (isFocus) return "expanded";
    return "compact";
  }

  function combinedMilestoneDisplayLabel(milestone, mode, labels) {
    if (mode === "expanded" && milestone.type === "gift") return "";
    if (milestone.type === "gift") {
      return milestone.subtitle || milestone.label;
    }
    return milestone.label;
  }

  function combinedMilestoneDisplaySubtitle(milestone, mode) {
    if (mode !== "expanded" || milestone.type !== "gift") return "";
    return milestone.subtitle || "";
  }

  function combinedMilestoneWidth(milestone, mode) {
    if (mode === "expanded") return "auto";
    if (milestone.type === "gift" || milestone.type === "shipping") {
      return "9.6rem";
    }
    return milestone.label.length > 14 ? "10.5rem" : "6.8rem";
  }

  function combinedProgressLabelHtml(label, subtitle) {
    if (!label && !subtitle) return "";
    return (
      '<span class="ss-cart-promotion-gift-progress__label">' +
      (label
        ? '<span class="ss-cart-promotion-gift-progress__label-main">' +
          escapeHtml(label) +
          "</span>"
        : "") +
      (subtitle
        ? '<span class="ss-cart-promotion-gift-progress__label-subtitle">' +
          escapeHtml(subtitle) +
          "</span>"
        : "") +
      "</span>"
    );
  }

  function combinedMilestoneFill(milestone, milestones, milestoneIndex) {
    if (milestone.unlocked) return 100;
    if (
      Array.isArray(milestones) &&
      milestones.some(function (candidate, index) {
        return index > Number(milestoneIndex || 0) && candidate.unlocked;
      })
    ) {
      return 100;
    }
    var previousThreshold = usesCumulativeCombinedProgress(milestones)
      ? Number(milestone.previousThreshold || 0)
      : 0;
    var threshold = Number(milestone.threshold || 0);
    var basis = Number(milestone.basis || 0);
    if (!Number.isFinite(basis) || !Number.isFinite(threshold)) return 0;
    var range = threshold - previousThreshold;
    if (!(range > 0)) return 0;
    return Math.max(
      0,
      Math.min(100, ((basis - previousThreshold) / range) * 100)
    );
  }

  function combinedCampaignMilestoneLabel(
    campaign,
    tier,
    index,
    labels,
    mount
  ) {
    if (isGiftCampaign(campaign)) {
      return compactGiftTierTitle(tier, labels);
    }
    return compactText(priceTierRewardLabel(campaign, tier, mount), 28);
  }

  function combinedPromptIcon(nextMilestone, shippingProgress) {
    if (
      (nextMilestone && nextMilestone.type === "shipping") ||
      (!nextMilestone && shippingProgress)
    ) {
      return shippingSmallIcon();
    }
    return giftSmallIcon();
  }

  function combinedProgressNodeIcon(milestone, status) {
    if (milestone.type === "shipping") return shippingProgressNodeIcon();
    if (milestone.type === "price") return priceProgressNodeIcon(status);
    return giftProgressNodeIcon(status);
  }

  function freeShippingProgressForMount(mount, cart) {
    if (
      !mount ||
      isProductMount(mount) ||
      mount.dataset.freeShippingEnabled !== "true"
    ) {
      return null;
    }
    var thresholdConfig =
      state.bootstrap &&
      state.bootstrap.shipping &&
      state.bootstrap.shipping.freeShippingThreshold;
    var thresholdMinor = Number(thresholdConfig && thresholdConfig.amountMinor);
    var thresholdCurrency = String(
      (thresholdConfig && thresholdConfig.currencyCode) || ""
    ).toUpperCase();
    var cartCurrency = String(
      (cart && cart.currency) || mount.dataset.currencyCode || ""
    ).toUpperCase();
    if (
      !Number.isSafeInteger(thresholdMinor) ||
      thresholdMinor <= 0 ||
      !thresholdCurrency ||
      !cartCurrency ||
      thresholdCurrency !== cartCurrency
    ) {
      return null;
    }
    var basis = projectedCartTotalCents(cart) / 100;
    var threshold = thresholdMinor / 100;
    var gap = Math.max(0, threshold - basis);
    return {
      basis: basis,
      threshold: threshold,
      gap: gap,
      unlocked: basis >= threshold,
    };
  }

  function freeShippingGapSentence(gap, mount, labels) {
    return template(labels.subtotalGiftGap, {
      amount: formatMoney(gap, mount),
      gift: freeShippingLabel(labels),
    });
  }

  function freeShippingGapSentenceHtml(gap, mount, labels) {
    return template(escapeHtml(labels.subtotalGiftGap), {
      amount: promotionAmountHtml(formatMoney(gap, mount)),
      gift: escapeHtml(freeShippingLabel(labels)),
    });
  }

  function freeShippingLabel(labels, shippingProgress) {
    return displayGroupLabel(
      (labels && labels.freeShipping) ||
        (shippingProgress && shippingProgress.label),
      "Free Shipping"
    );
  }

  function renderActivityGroups(mount, cart) {
    var root = mount && mount.parentElement;
    if (!root || !cart || !Array.isArray(cart.items)) {
      if (mount) hideMount(mount);
      return;
    }
    var campaigns = activeCampaigns();
    if (!campaigns.length) {
      resetGroupedCartItems(mount, root);
      hideMount(mount);
      return;
    }

    var labels = getLabels(mount);
    var signature = activityGroupsSignature(mount, cart, labels, campaigns);
    if (!signature.hasContent) {
      resetGroupedCartItems(mount, root);
      markStandaloneCartItems(root, mount, cart, new Set());
      hideMount(mount);
      return;
    }
    if (
      mount.__ssCartPromotionSignature === signature.value &&
      mountContainsLineKeys(mount, signature.groupedLineKeys)
    ) {
      mount.hidden = false;
      clearStandaloneCartItems(root);
      markStandaloneCartItems(root, mount, cart, signature.assignedLineKeys);
      return;
    }

    resetGroupedCartItems(mount, root);
    var assignedLineKeys = new Set();
    var hasContent = false;
    mount.hidden = false;

    var global = globalCampaign();
    var scopedCampaigns = campaigns.filter(function (campaign) {
      return !isGlobalCampaign(campaign);
    });
    var globalGiftCampaign = global && isGiftCampaign(global) ? global : null;
    if (globalGiftCampaign) {
      var globalGiftItems = cart.items.filter(function (item) {
        return (
          isSystemGiftItem(item) &&
          getProperty(item, SYSTEM_GIFT_CAMPAIGN) ===
            String((globalGiftCampaign && globalGiftCampaign.id) || "")
        );
      });
      var globalGiftNodes = globalGiftItems
        .map(function (item) {
          return lineElementForItem(item, root);
        })
        .filter(Boolean);
      globalGiftItems.forEach(function (item) {
        if (item.key) assignedLineKeys.add(item.key);
      });
      if (
        appendGlobalGiftLineItemGroup(
          mount,
          globalGiftNodes,
          labels,
          globalGiftItems
        )
      ) {
        hasContent = true;
      }
    }

    var giftCampaigns = scopedCampaigns.filter(isGiftCampaign);
    giftCampaigns.forEach(function (campaign) {
      if (!sortTiers(campaign).length) return;
      var giftItems = cart.items.filter(function (item) {
        return (
          isSystemGiftItem(item) &&
          getProperty(item, SYSTEM_GIFT_CAMPAIGN) ===
            String((campaign && campaign.id) || "")
        );
      });
      var giftLineEntries = giftItems
        .map(function (item) {
          return lineEntryForItem(item, root);
        })
        .filter(function (entry) {
          return Boolean(entry.item && entry.node);
        });
      var giftNodes = giftLineEntries.map(function (entry) {
        return entry.node;
      });
      var participatingItems = cart.items.filter(function (item) {
        if (
          !item ||
          !item.key ||
          assignedLineKeys.has(item.key) ||
          isSystemGiftItem(item)
        )
          return false;
        return isLineEligibleForCampaign(item, campaign);
      });
      var participatingNodes = participatingItems
        .map(function (item) {
          return lineElementForItem(item, root);
        })
        .filter(Boolean);
      if (!giftNodes.length && !participatingNodes.length) return;
      giftItems.forEach(function (item) {
        if (item.key) assignedLineKeys.add(item.key);
      });
      participatingItems.forEach(function (item) {
        if (item.key) assignedLineKeys.add(item.key);
      });
      appendPromotionGroup(mount, {
        campaign: campaign,
        cart: cart,
        items: giftNodes.concat(participatingNodes),
        giftLineEntries: giftLineEntries,
        labels: labels,
        isGiftGroup: true,
      });
      hasContent = true;
    });

    scopedCampaigns.filter(isPriceCampaign).forEach(function (campaign) {
      var lineItems = cart.items.filter(function (item) {
        if (
          !item ||
          !item.key ||
          assignedLineKeys.has(item.key) ||
          isSystemGiftItem(item)
        )
          return false;
        return isLineEligibleForCampaign(item, campaign);
      });
      if (!lineItems.length) return;
      var lineEntries = lineItems
        .map(function (item) {
          return lineEntryForItem(item, root);
        })
        .filter(function (entry) {
          return Boolean(entry.item && entry.item.key && entry.node);
        });
      if (!lineEntries.length) return;
      var renderLineItems = lineEntries.map(function (entry) {
        return entry.item;
      });
      var nodes = lineEntries.map(function (entry) {
        return entry.node;
      });
      renderLineItems.forEach(function (item) {
        if (item.key) assignedLineKeys.add(item.key);
      });
      appendPromotionGroup(mount, {
        campaign: campaign,
        cart: cart,
        items: nodes,
        lineItems: renderLineItems,
        lineEntries: lineEntries,
        labels: labels,
        isGiftGroup: false,
      });
      hasContent = true;
    });

    if (
      appendRemainingGiftLineItemGroup(
        mount,
        root,
        cart,
        assignedLineKeys,
        labels
      )
    ) {
      hasContent = true;
    }
    if (
      appendRemainingRegularLineItemGroup(
        mount,
        root,
        cart,
        assignedLineKeys
      )
    ) {
      hasContent = true;
    }

    markStandaloneCartItems(root, mount, cart, assignedLineKeys);
    if (!hasContent) {
      hideMount(mount);
      return;
    }
    mount.__ssCartPromotionSignature = signature.value;
  }

  function activityGroupsSignature(mount, cart, labels, campaigns) {
    var assignedLineKeys = new Set();
    var groupedLineKeys = [];
    var groups = [];

    function itemKeys(items) {
      return items
        .map(function (item) {
          return item && item.key ? String(item.key) : "";
        })
        .filter(Boolean);
    }

    function addAssigned(items) {
      items.forEach(function (item) {
        if (item && item.key) assignedLineKeys.add(item.key);
      });
    }

    function addGroup(type, meta, keys) {
      if (!keys.length) return;
      keys.forEach(function (key) {
        groupedLineKeys.push(key);
      });
      groups.push({
        type: type,
        meta: meta || {},
        keys: keys,
      });
    }

    var global = globalCampaign();
    var scopedCampaigns = campaigns.filter(function (campaign) {
      return !isGlobalCampaign(campaign);
    });
    var globalGiftCampaign = global && isGiftCampaign(global) ? global : null;
    if (globalGiftCampaign) {
      var globalGiftItems = cart.items.filter(function (item) {
        return (
          isSystemGiftItem(item) &&
          getProperty(item, SYSTEM_GIFT_CAMPAIGN) ===
            String((globalGiftCampaign && globalGiftCampaign.id) || "")
        );
      });
      var globalGiftKeys = itemKeys(globalGiftItems);
      addAssigned(globalGiftItems);
      addGroup(
        "global-gift",
        {
          badge: giftLineGroupBadgeText(globalGiftItems, labels),
          campaignId: String(
            (globalGiftCampaign && globalGiftCampaign.id) || ""
          ),
        },
        globalGiftKeys
      );
    }

    scopedCampaigns.filter(isGiftCampaign).forEach(function (campaign) {
      if (!sortTiers(campaign).length) return;
      var giftItems = cart.items.filter(function (item) {
        return (
          isSystemGiftItem(item) &&
          getProperty(item, SYSTEM_GIFT_CAMPAIGN) ===
            String((campaign && campaign.id) || "")
        );
      });
      var participatingItems = cart.items.filter(function (item) {
        if (
          !item ||
          !item.key ||
          assignedLineKeys.has(item.key) ||
          isSystemGiftItem(item)
        )
          return false;
        return isLineEligibleForCampaign(item, campaign);
      });
      var keys = itemKeys(giftItems).concat(itemKeys(participatingItems));
      if (!keys.length) return;
      var progress = campaignProgress(campaign, cart, mount, labels);
      var title = campaignGroupTitle(campaign, progress, labels, mount, true);
      addAssigned(giftItems);
      addAssigned(participatingItems);
      addGroup(
        "campaign-gift",
        {
          action: shouldShowGroupPromotionAction(campaign, progress, mount)
            ? "1"
            : "0",
          campaignId: String((campaign && campaign.id) || ""),
          giftBadge: giftLineGroupBadgeText(giftItems, labels),
          giftLineDisplay: giftLineGroupSignature(giftItems, labels),
          subtitle: progress.subtitle,
          title: title,
        },
        keys
      );
    });

    scopedCampaigns.filter(isPriceCampaign).forEach(function (campaign) {
      var lineItems = cart.items.filter(function (item) {
        if (
          !item ||
          !item.key ||
          assignedLineKeys.has(item.key) ||
          isSystemGiftItem(item)
        )
          return false;
        return isLineEligibleForCampaign(item, campaign);
      });
      var keys = itemKeys(lineItems);
      if (!keys.length) return;
      var progress = campaignProgress(campaign, cart, mount, labels);
      addAssigned(lineItems);
      addGroup(
        "campaign-price",
        {
          action: shouldShowGroupPromotionAction(campaign, progress, mount)
            ? "1"
            : "0",
          buyNPayMDisplay:
            campaignBenefitType(campaign) === BUY_N_PAY_M_TYPE
              ? buyNPayMLineGroupSignature(lineItems, campaign)
              : "",
          buyXGetYDisplay:
            campaignBenefitType(campaign) === BUY_X_GET_Y_TYPE
              ? buyXGetYLineGroupSignature(lineItems, campaign)
              : "",
          campaignId: String((campaign && campaign.id) || ""),
          subtitle: progress.subtitle,
          title: campaignGroupTitle(campaign, progress, labels, mount, false),
        },
        keys
      );
    });

    var remainingGiftItems = cart.items.filter(function (item) {
      return (
        item &&
        item.key &&
        !assignedLineKeys.has(item.key) &&
        isSystemGiftItem(item)
      );
    });
    if (remainingGiftItems.length >= 2) {
      addAssigned(remainingGiftItems);
      addGroup(
        "remaining-gift",
        {
          badge: giftLineGroupBadgeText(remainingGiftItems, labels),
          giftLineDisplay: giftLineGroupSignature(remainingGiftItems, labels),
        },
        itemKeys(remainingGiftItems)
      );
    }

    var remainingRegularItems = cart.items.filter(function (item) {
      return (
        item &&
        item.key &&
        !assignedLineKeys.has(item.key) &&
        !isSystemGiftItem(item)
      );
    });
    if (remainingRegularItems.length >= 2) {
      addAssigned(remainingRegularItems);
      addGroup("remaining-regular", {}, itemKeys(remainingRegularItems));
    }

    var standaloneKeys = cart.items
      .filter(function (item) {
        return item && item.key && !assignedLineKeys.has(item.key);
      })
      .map(function (item) {
        return String(item.key);
      });

    return {
      assignedLineKeys: assignedLineKeys,
      groupedLineKeys: groupedLineKeys,
      hasContent: Boolean(groups.length),
      value: JSON.stringify({
        groups: groups,
        standaloneKeys: standaloneKeys,
      }),
    };
  }

  function mountContainsLineKeys(mount, lineKeys) {
    if (!lineKeys || !lineKeys.length) return true;
    var present = new Set(
      Array.from(mount.querySelectorAll("[data-ss-line-key]")).map(function (
        element
      ) {
        return element.dataset.ssLineKey;
      })
    );
    return lineKeys.every(function (key) {
      return present.has(key);
    });
  }

  function resetGroupedCartItems(mount, root) {
    if (mount) delete mount.__ssCartPromotionSignature;
    var anchor = mount.nextSibling;
    clearPartialPromotionControlLineEnhancements(mount);
    clearBuyNPayMLineEnhancements(mount);
    clearBuyXGetYLineEnhancements(mount);
    Array.from(mount.querySelectorAll("[data-ss-line-key]")).forEach(function (
      itemNode
    ) {
      root.insertBefore(itemNode, anchor);
    });
    clearStandaloneCartItems(root);
    clearPartialPromotionControlLineEnhancements(root);
    clearBuyNPayMLineEnhancements(root);
    clearBuyXGetYLineEnhancements(root);
    mount.innerHTML = "";
  }

  function appendStandaloneGiftItems(mount, itemNodes) {
    if (!itemNodes.length) return false;
    var container = document.createElement("div");
    container.className = "ss-cart-promotion-global-gifts";
    mount.appendChild(container);
    itemNodes.forEach(function (itemNode) {
      markStandaloneCartItemNode(itemNode, true);
      container.appendChild(itemNode);
    });
    return true;
  }

  function appendGlobalGiftLineItemGroup(mount, itemNodes, labels, lineItems) {
    if (!itemNodes || !itemNodes.length) return false;
    appendLineItemGroup(mount, {
      badge: giftLineGroupBadgeText(lineItems, labels),
      className:
        "ss-cart-promotion-group--gift ss-cart-promotion-group--global-gift ss-cart-promotion-group--reward-lines ss-cart-promotion-group--line-items ss-cart-promotion-group--line-items-gift ss-cart-promotion-group--untitled",
      items: itemNodes,
      type: "global-gift-items",
    });
    return true;
  }

  function appendGiftLineItemGroup(mount, itemNodes, labels, lineItems) {
    if (!itemNodes || itemNodes.length < 2) return false;
    appendLineItemGroup(mount, {
      badge: giftLineGroupBadgeText(lineItems, labels),
      className:
        "ss-cart-promotion-group--gift ss-cart-promotion-group--reward-lines ss-cart-promotion-group--line-items ss-cart-promotion-group--line-items-gift ss-cart-promotion-group--untitled",
      items: itemNodes,
      type: "gift-items",
    });
    return true;
  }

  function appendRemainingGiftLineItemGroup(
    mount,
    root,
    cart,
    assignedLineKeys,
    labels
  ) {
    var pairs = unassignedLineItemPairs(
      cart,
      assignedLineKeys,
      isSystemGiftItem,
      root
    );
    if (pairs.length < 2) return false;
    pairs.forEach(function (pair) {
      if (pair.item && pair.item.key) assignedLineKeys.add(pair.item.key);
    });
    return appendGiftLineItemGroup(
      mount,
      pairs.map(function (pair) {
        return pair.node;
      }),
      labels,
      pairs.map(function (pair) {
        return pair.item;
      })
    );
  }

  function appendRemainingRegularLineItemGroup(
    mount,
    root,
    cart,
    assignedLineKeys
  ) {
    var pairs = unassignedLineItemPairs(
      cart,
      assignedLineKeys,
      function (item) {
        return !isSystemGiftItem(item);
      },
      root
    );
    if (pairs.length < 2) return false;
    pairs.forEach(function (pair) {
      if (pair.item && pair.item.key) assignedLineKeys.add(pair.item.key);
    });
    appendLineItemGroup(mount, {
      className:
        "ss-cart-promotion-group--line-items ss-cart-promotion-group--line-items-regular ss-cart-promotion-group--untitled",
      items: pairs.map(function (pair) {
        return pair.node;
      }),
      type: "regular-items",
    });
    return true;
  }

  function unassignedLineItemPairs(cart, assignedLineKeys, predicate, root) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items
      .filter(function (item) {
        return (
          item &&
          item.key &&
          !assignedLineKeys.has(item.key) &&
          (!predicate || predicate(item))
        );
      })
      .map(function (item) {
        return {
          item: item,
          node: lineElementForItem(item, root),
        };
      })
      .filter(function (pair) {
        return Boolean(pair.node);
      });
  }

  function markStandaloneCartItems(root, mount, cart, assignedLineKeys) {
    var cartItemByKey = new Map();
    cart.items.forEach(function (item) {
      if (item && item.key) cartItemByKey.set(item.key, item);
    });
    Array.from(root.children).forEach(function (itemNode) {
      if (!itemNode || itemNode === mount || !itemNode.dataset) return;
      var lineKey = itemNode.dataset.ssLineKey;
      if (!lineKey || assignedLineKeys.has(lineKey)) return;
      var item = cartItemByKey.get(lineKey);
      markStandaloneCartItemNode(itemNode, isSystemGiftItem(item));
    });
  }

  function clearStandaloneCartItems(root) {
    Array.from(root.querySelectorAll("[data-ss-line-key]")).forEach(function (
      itemNode
    ) {
      itemNode.removeAttribute("data-ss-cart-promotion-standalone");
      itemNode.classList.remove("ss-cart-promotion-standalone-item");
      itemNode.classList.remove("ss-cart-promotion-standalone-item--gift");
    });
  }

  function markStandaloneCartItemNode(itemNode, isGift) {
    itemNode.setAttribute("data-ss-cart-promotion-standalone", "");
    itemNode.classList.add("ss-cart-promotion-standalone-item");
    itemNode.classList.toggle(
      "ss-cart-promotion-standalone-item--gift",
      Boolean(isGift)
    );
  }

  function appendPromotionGroup(mount, options) {
    var group = document.createElement("div");
    var campaign = options.campaign;
    var benefitType = campaignBenefitType(campaign);
    group.className =
      "ss-cart-promotion-group" +
      (options.isGiftGroup
        ? " ss-cart-promotion-group--gift ss-cart-promotion-group--campaign-gift"
        : " ss-cart-promotion-group--price") +
      (benefitType === BUY_N_PAY_M_TYPE
        ? " ss-cart-promotion-group--buy-n-pay-m"
        : benefitType === BUY_X_GET_Y_TYPE
        ? " ss-cart-promotion-group--buy-x-get-y"
        : "");
    group.dataset.ssCartPromotionGroup = String(
      (campaign && campaign.id) || ""
    );
    group.dataset.ssCartPromotionGroupType = options.isGiftGroup
      ? "gift"
      : "price";
    if (benefitType) group.dataset.ssCartPromotionBenefitType = benefitType;
    group.innerHTML =
      groupHeaderHtml(
        campaign,
        options.cart,
        options.labels,
        mount,
        options.isGiftGroup
      ) + '<div class="ss-cart-promotion-group__items"></div>';
    mount.appendChild(group);
    var itemContainer = group.querySelector(".ss-cart-promotion-group__items");
    if (!options.isGiftGroup && benefitType === BUY_N_PAY_M_TYPE) {
      appendBuyNPayMGroupItems(
        itemContainer,
        options.lineEntries,
        mount,
        campaign,
        options.labels
      );
      return;
    }
    if (!options.isGiftGroup && benefitType === BUY_X_GET_Y_TYPE) {
      appendBuyXGetYGroupItems(
        itemContainer,
        options.lineEntries,
        mount,
        campaign,
        options.labels
      );
      return;
    }
    if (options.isGiftGroup) {
      appendGiftCampaignGroupItems(itemContainer, options);
      return;
    }
    appendItemNodes(itemContainer, options.items);
  }

  function appendGiftCampaignGroupItems(itemContainer, options) {
    var giftEntries = (options.giftLineEntries || []).filter(function (entry) {
      return Boolean(entry.item && entry.node);
    });
    if (giftEntries.length < 2) {
      appendItemNodes(itemContainer, options.items);
      return;
    }
    var giftNodes = giftEntries.map(function (entry) {
      return entry.node;
    });
    var giftNodeSet = new Set(giftNodes);
    appendRewardLineGroup(itemContainer, giftNodes, {
      badge: giftLineGroupBadgeText(
        giftEntries.map(function (entry) {
          return entry.item;
        }),
        options.labels
      ),
      className: "ss-cart-promotion-reward-lines--gift",
      type: "gift-reward-items",
    });
    appendItemNodes(
      itemContainer,
      (options.items || []).filter(function (itemNode) {
        return !giftNodeSet.has(itemNode);
      })
    );
  }

  function appendBuyNPayMGroupItems(
    itemContainer,
    lineEntries,
    mount,
    campaign,
    labels
  ) {
    var entries = (lineEntries || []).filter(function (entry) {
      return Boolean(entry.item && entry.node);
    });
    var rewardEntries = [];
    var regularEntries = [];
    entries.forEach(function (entry) {
      var displayPlan = buyNPayMRewardDisplayPlan(entry.item, campaign);
      if (!displayPlan.useRewardCard) {
        regularEntries.push(entry);
        return;
      }
      rewardEntries.push({
        entry: {
          item: entry.item,
          node: displayPlan.keepRegularLine
            ? cloneBuyNPayMRewardNode(entry.node)
            : entry.node,
        },
        freeQuantity: displayPlan.freeQuantity,
      });
      if (displayPlan.keepRegularLine) {
        decoratePartialPromotionControlLine(entry.node, entry.item, mount);
        regularEntries.push(entry);
      }
    });

    rewardEntries.forEach(function (rewardEntry) {
      decorateBuyNPayMFreeLine(
        rewardEntry.entry.node,
        rewardEntry.entry.item,
        mount,
        campaign,
        {
          freeQuantity: rewardEntry.freeQuantity,
          suppressRibbon: rewardEntries.length > 1,
        }
      );
    });
    if (rewardEntries.length > 1) {
      appendRewardLineGroup(
        itemContainer,
        rewardEntries.map(function (rewardEntry) {
          return rewardEntry.entry.node;
        }),
        {
          badge: buyNPayMFreeGroupBadgeText(campaign, labels, rewardEntries),
          className: "ss-cart-promotion-reward-lines--buy-n-pay-m",
          type: "buy-n-pay-m-reward-items",
        }
      );
    } else {
      appendItemNodes(
        itemContainer,
        rewardEntries.map(function (rewardEntry) {
          return rewardEntry.entry.node;
        })
      );
    }
    appendItemNodes(
      itemContainer,
      regularEntries.map(function (entry) {
        return entry.node;
      })
    );
  }

  function buyNPayMRewardDisplayPlan(item, campaign) {
    var quantity = Math.max(0, Number((item && item.quantity) || 0));
    var freeQuantity = buyNPayMFreeQuantityForItem(item, campaign);
    return {
      freeQuantity: freeQuantity,
      keepRegularLine: freeQuantity < quantity,
      useRewardCard: freeQuantity > 0,
    };
  }

  function cloneBuyNPayMRewardNode(node) {
    return clonePromotionRewardNode(
      node,
      "data-ss-buy-n-pay-m-virtual-item"
    );
  }

  function clonePromotionRewardNode(node, markerAttribute) {
    if (!node || typeof node.cloneNode !== "function") return null;
    var clone = node.cloneNode(true);
    clone.removeAttribute("id");
    clone.removeAttribute("data-ss-line-key");
    clone.setAttribute(markerAttribute, "");
    Array.from(clone.querySelectorAll("[id]")).forEach(function (element) {
      element.removeAttribute("id");
    });
    Array.from(clone.querySelectorAll("[for]")).forEach(function (element) {
      element.removeAttribute("for");
    });
    Array.from(clone.querySelectorAll("svg[hidden]")).forEach(function (svg) {
      svg.remove();
    });
    Array.from(
      clone.querySelectorAll(
        "button, input, select, textarea, .minicart__actions, .minicart__item-top-actions"
      )
    ).forEach(function (control) {
      control.remove();
    });
    return clone;
  }

  function appendBuyXGetYGroupItems(
    itemContainer,
    lineEntries,
    mount,
    campaign,
    labels
  ) {
    var entries = (lineEntries || []).filter(function (entry) {
      return Boolean(entry.item && entry.node);
    });
    var assignments = buyXGetYLineAssignments(entries, campaign);
    var rewardEntries = [];
    var regularEntries = [];
    entries.forEach(function (entry, index) {
      var assignment = assignments.get(String(entry.item.key || ""));
      var displayPlan = buyXGetYRewardDisplayPlan(
        entry.item,
        assignment,
        campaign
      );
      if (displayPlan.rewardAssignments.length) {
        displayPlan.rewardAssignments.forEach(function (
          rewardAssignment,
          segmentIndex
        ) {
          rewardEntries.push({
            assignment: rewardAssignment,
            entry: {
              item: entry.item,
              node:
                !displayPlan.keepRegularLine && segmentIndex === 0
                  ? entry.node
                  : cloneBuyXGetYRewardNode(entry.node),
            },
            index: index,
            segmentIndex: segmentIndex,
          });
        });
        if (displayPlan.keepRegularLine) {
          decoratePartialPromotionControlLine(entry.node, entry.item, mount);
          regularEntries.push(entry);
        }
        return;
      }
      regularEntries.push(entry);
    });

    rewardEntries.sort(function (left, right) {
      var discountGap =
        buyXGetYAssignmentDiscountBasisPoints(right.assignment) -
        buyXGetYAssignmentDiscountBasisPoints(left.assignment);
      return (
        discountGap ||
        left.index - right.index ||
        left.segmentIndex - right.segmentIndex
      );
    });
    var rewardGroups = new Map();
    rewardEntries.forEach(function (rewardEntry) {
      var badge = buyXGetYRewardBadgeText(rewardEntry.assignment, labels);
      var groupEntries = rewardGroups.get(badge) || [];
      groupEntries.push(rewardEntry);
      rewardGroups.set(badge, groupEntries);
    });
    rewardGroups.forEach(function (groupEntries, badge) {
      if (groupEntries.length === 1) {
        var rewardEntry = groupEntries[0];
        decorateBuyXGetYRewardLine(
          rewardEntry.entry.node,
          rewardEntry.entry.item,
          rewardEntry.assignment,
          mount,
          labels
        );
        appendItemNodes(itemContainer, [rewardEntry.entry.node]);
        return;
      }
      groupEntries.forEach(function (rewardEntry) {
        decorateBuyXGetYRewardLine(
          rewardEntry.entry.node,
          rewardEntry.entry.item,
          rewardEntry.assignment,
          mount,
          labels,
          { suppressRibbon: true }
        );
      });
      appendRewardLineGroup(
        itemContainer,
        groupEntries.map(function (rewardEntry) {
          return rewardEntry.entry.node;
        }),
        {
          badge: badge,
          className: "ss-cart-promotion-reward-lines--buy-x-get-y",
          type: "buy-x-get-y-reward-items",
        }
      );
    });
    appendItemNodes(
      itemContainer,
      regularEntries.map(function (entry) {
        return entry.node;
      })
    );
  }

  function isBuyXGetYRewardLine(item, assignment, campaign) {
    var quantity = Math.max(0, Number((item && item.quantity) || 0));
    return Boolean(
      quantity > 0 &&
        assignment &&
        assignment.segments &&
        assignment.segments.length > 0 &&
        Number(assignment.totalQuantity || 0) >= quantity &&
        lineCampaignDiscountAmountCents(item, campaign) > 0
    );
  }

  function buyXGetYRewardDisplayPlan(item, assignment, campaign) {
    var quantity = Math.max(0, Number((item && item.quantity) || 0));
    var hasAppliedReward = Boolean(
      quantity > 0 &&
        assignment &&
        assignment.segments &&
        assignment.segments.length > 0 &&
        Number(assignment.totalQuantity || 0) > 0 &&
        lineCampaignDiscountAmountCents(item, campaign) > 0
    );
    var rewardAssignments = hasAppliedReward
      ? buyXGetYRewardAssignments(assignment)
      : [];
    var rewardQuantity = rewardAssignments.reduce(function (
      total,
      rewardAssignment
    ) {
      return total + Number(rewardAssignment.totalQuantity || 0);
    }, 0);
    return {
      keepRegularLine: !hasAppliedReward || rewardQuantity < quantity,
      rewardAssignments: rewardAssignments,
    };
  }

  function buyXGetYRewardAssignments(assignment) {
    return (assignment && Array.isArray(assignment.segments)
      ? assignment.segments
      : []
    )
      .filter(function (segment) {
        return Number(segment && segment.quantity) > 0;
      })
      .map(function (segment) {
        return {
          segments: [segment],
          totalQuantity: Number(segment.quantity),
        };
      });
  }

  function cloneBuyXGetYRewardNode(node) {
    return clonePromotionRewardNode(
      node,
      "data-ss-buy-x-get-y-virtual-item"
    );
  }

  function buyXGetYAssignmentDiscountBasisPoints(assignment) {
    var segment = assignment && assignment.segments && assignment.segments[0];
    if (!segment) return 0;
    return Math.max(0, Math.round(Number(segment.percentage || 0) * 100));
  }

  function buyXGetYRewardBadgeText(assignment, labels) {
    var discount = buyXGetYAssignmentDiscountBasisPoints(assignment) / 100;
    if (!(discount > 0)) return "";
    return (
      trimDisplayNumber(discount) + "% " + ((labels && labels.off) || "OFF")
    );
  }

  function buyXGetYRewardUnitPriceCents(item, assignment) {
    var segment = assignment && assignment.segments && assignment.segments[0];
    var quantity = Math.max(0, Number((segment && segment.quantity) || 0));
    if (quantity <= 0) return 0;
    return Math.max(
      0,
      Math.round(Number(segment.discountedPriceCents || 0) / quantity)
    );
  }

  function buyXGetYLineAssignments(lineEntries, campaign) {
    var entries = (lineEntries || [])
      .filter(function (entry) {
        return (
          entry.item &&
          Number(entry.item.quantity || 0) > 0 &&
          originalUnitPriceCents(entry.item) > 0
        );
      })
      .slice()
      .sort(function (left, right) {
        var leftAppliedDiscount = lineCampaignDiscountAmountCents(
          left.item,
          campaign
        );
        var rightAppliedDiscount = lineCampaignDiscountAmountCents(
          right.item,
          campaign
        );
        var appliedGap =
          Number(rightAppliedDiscount > 0) - Number(leftAppliedDiscount > 0);
        if (appliedGap) return appliedGap;
        if (leftAppliedDiscount > 0 && rightAppliedDiscount > 0) {
          var leftDiscountRate =
            leftAppliedDiscount / originalLinePriceCents(left.item);
          var rightDiscountRate =
            rightAppliedDiscount / originalLinePriceCents(right.item);
          if (leftDiscountRate !== rightDiscountRate) {
            return rightDiscountRate - leftDiscountRate;
          }
        }
        var priceGap =
          originalUnitPriceCents(left.item) -
          originalUnitPriceCents(right.item);
        return priceGap || String(left.item.key).localeCompare(right.item.key);
      });
    var basis = entries.reduce(function (total, entry) {
      return total + Math.max(0, Number(entry.item.quantity || 0));
    }, 0);
    var rewards = buyXGetYPlanSegments(campaign, basis);
    var assignments = new Map();
    var lineIndex = 0;
    var lineRemaining = entries.length
      ? Math.max(0, Number(entries[0].item.quantity || 0))
      : 0;

    rewards.forEach(function (reward) {
      var rewardRemaining = reward.quantity;
      while (rewardRemaining > 0 && lineIndex < entries.length) {
        if (lineRemaining <= 0) {
          lineIndex += 1;
          lineRemaining = entries[lineIndex]
            ? Math.max(0, Number(entries[lineIndex].item.quantity || 0))
            : 0;
          continue;
        }
        var quantity = Math.min(rewardRemaining, lineRemaining);
        var entry = entries[lineIndex];
        var key = String(entry.item.key || "");
        var assignment = assignments.get(key) || {
          segments: [],
          totalQuantity: 0,
        };
        assignment.segments.push({
          percentage: reward.percentage,
          discountedPriceCents: Math.round(
            (originalUnitPriceCents(entry.item) *
              quantity *
              (100 - reward.percentage)) /
              100
          ),
          quantity: quantity,
        });
        assignment.totalQuantity += quantity;
        assignments.set(key, assignment);
        rewardRemaining -= quantity;
        lineRemaining -= quantity;
      }
    });
    return assignments;
  }

  function decorateBuyXGetYRewardLine(
    node,
    item,
    assignment,
    mount,
    labels,
    options
  ) {
    if (!node || !item || !assignment) return;
    node.classList.add("ss-cart-item--buy-x-get-y-reward");
    node.setAttribute("data-ss-buy-x-get-y-reward-item", "");
    node.dataset.ssBuyXGetYRewardQuantity = trimDisplayNumber(
      assignment.totalQuantity
    );
    node.dataset.ssBuyXGetYRewardDiscount = trimDisplayNumber(
      buyXGetYAssignmentDiscountBasisPoints(assignment) / 100
    );
    updateBuyXGetYRewardLinePrice(node, item, assignment, mount);
    if (!options || !options.suppressRibbon) {
      insertBuyXGetYRewardRibbon(node, assignment, labels);
    }
    insertBuyXGetYRewardQuantity(
      node,
      assignment.totalQuantity,
      mount
    );
  }

  function updateBuyXGetYRewardLinePrice(node, item, assignment, mount) {
    var priceWrapper =
      node && node.querySelector(".minicart__item-price-wrapper");
    if (!priceWrapper) return;
    var discountedUnitPrice = buyXGetYRewardUnitPriceCents(item, assignment);
    var originalUnitPrice = Math.max(
      discountedUnitPrice,
      Math.round(originalUnitPriceCents(item))
    );
    if (!(originalUnitPrice > 0)) return;
    if (priceWrapper.__ssBuyXGetYOriginalHtml === undefined) {
      priceWrapper.__ssBuyXGetYOriginalHtml = priceWrapper.innerHTML;
    }
    priceWrapper.innerHTML =
      '<div class="minicart__discounted-prices">' +
      '<span class="minicart__item-price minicart__item-regular-price text-color-regular-price heading_weight primary-color">' +
      escapeHtml(formatMoneyCents(discountedUnitPrice, mount)) +
      "</span> " +
      '<s class="minicart__item-original-price">' +
      escapeHtml(formatMoneyCents(originalUnitPrice, mount)) +
      "</s>" +
      "</div>";
  }

  function insertBuyXGetYRewardRibbon(node, assignment, labels) {
    if (!node || node.querySelector("[data-ss-buy-x-get-y-reward-tag]"))
      return;
    var badge = buyXGetYRewardBadgeText(assignment, labels);
    if (!badge) return;
    node.insertAdjacentHTML(
      "afterbegin",
      '<div class="ss-cart-item-free-gift__tag ss-cart-item-free-gift__tag--buy-x-get-y" data-ss-buy-x-get-y-reward-tag>' +
        escapeHtml(badge) +
        "</div>"
    );
  }

  function insertBuyXGetYRewardQuantity(node, quantity, mount) {
    if (!node || node.querySelector("[data-ss-buy-x-get-y-reward-quantity]"))
      return;
    var safeQuantity = Math.max(0, Number(quantity || 0));
    if (safeQuantity <= 0) return;
    var quantityText = trimDisplayNumber(safeQuantity);
    var quantityLabel = getLabels(mount).quantity || "Quantity";
    var html =
      '<span class="ss-cart-item-free-line__quantity" data-ss-buy-x-get-y-reward-quantity aria-label="' +
      escapeHtml(quantityLabel + " " + quantityText) +
      '">x' +
      escapeHtml(quantityText) +
      "</span>";
    var priceWrapper = node.querySelector(".minicart__item-price-wrapper");
    if (priceWrapper) {
      priceWrapper.insertAdjacentHTML("beforeend", html);
      return;
    }
    var anchor =
      node.querySelector(".minicart__item-prices") ||
      node.querySelector(".product-item__name-minicart") ||
      node.querySelector(".product-item__name");
    if (anchor) {
      anchor.insertAdjacentHTML("afterend", html);
      return;
    }
    node.insertAdjacentHTML("beforeend", html);
  }

  function clearBuyXGetYLineEnhancements(root) {
    if (!root) return;
    Array.from(
      root.querySelectorAll("[data-ss-buy-x-get-y-reward-item]")
    ).forEach(function (node) {
      node.removeAttribute("data-ss-buy-x-get-y-reward-item");
      node.classList.remove("ss-cart-item--buy-x-get-y-reward");
      delete node.dataset.ssBuyXGetYRewardQuantity;
      delete node.dataset.ssBuyXGetYRewardDiscount;
      var priceWrapper = node.querySelector(".minicart__item-price-wrapper");
      if (
        priceWrapper &&
        priceWrapper.__ssBuyXGetYOriginalHtml !== undefined
      ) {
        priceWrapper.innerHTML = priceWrapper.__ssBuyXGetYOriginalHtml;
        delete priceWrapper.__ssBuyXGetYOriginalHtml;
      }
      Array.from(
        node.querySelectorAll(
          "[data-ss-buy-x-get-y-reward-tag], [data-ss-buy-x-get-y-reward-quantity]"
        )
      ).forEach(function (element) {
        element.remove();
      });
    });
  }

  function buyXGetYLineGroupSignature(lineItems, campaign) {
    return (lineItems || [])
      .map(function (item) {
        return [
          item && item.key,
          item && item.quantity,
          originalLinePriceCents(item),
          lineCampaignDiscountAmountCents(item, campaign),
        ].join(":");
      })
      .join("|");
  }

  function appendItemNodes(container, itemNodes) {
    (itemNodes || []).forEach(function (itemNode) {
      if (itemNode) container.appendChild(itemNode);
    });
  }

  function appendRewardLineGroup(container, itemNodes, options) {
    var nodes = (itemNodes || []).filter(Boolean);
    if (!nodes.length) return false;
    var group = document.createElement("div");
    group.className =
      "ss-cart-promotion-reward-lines " + String(options.className || "");
    group.dataset.ssCartPromotionGroupType = String(
      options.type || "reward-items"
    );
    group.innerHTML =
      lineItemGroupBadgeHtml(options.badge) +
      '<div class="ss-cart-promotion-reward-lines__items"></div>';
    container.appendChild(group);
    appendItemNodes(
      group.querySelector(".ss-cart-promotion-reward-lines__items"),
      nodes
    );
    return true;
  }

  function giftLineGroupBadgeText(lineItems, labels) {
    var fallback = (labels && labels.freeGift) || "FREE GIFT";
    var badges = uniqueDisplayStrings(
      (lineItems || []).map(function (item) {
        return giftRewardBadgeTextForGiftLine(item, labels);
      })
    );
    if (!badges.length) return "";
    return badges.length === 1 ? badges[0] : fallback;
  }

  function giftLineGroupSignature(lineItems, labels) {
    return (lineItems || [])
      .map(function (item) {
        return [
          item && item.key,
          item && item.quantity,
          giftRewardBadgeTextForGiftLine(item, labels),
        ].join(":");
      })
      .join("|");
  }

  function buyNPayMFreeGroupBadgeText(campaign, labels, rewardEntries) {
    var quantity = (rewardEntries || []).reduce(function (total, entry) {
      return total + Number((entry && entry.freeQuantity) || 0);
    }, 0);
    var itemLabels = buyNPayMItemLabels(campaign, labels);
    if (itemLabels.hasCustom) {
      return ((labels && labels.free) || "Free") + " " + itemLabels.plural;
    }
    if (quantity === 1) return (labels && labels.freeItem) || "FREE ITEM";
    return (
      ((labels && labels.free) || "Free") +
      " " +
      ((labels && labels.items) || "items")
    );
  }

  function uniqueDisplayStrings(values) {
    var seen = new Set();
    return (values || []).reduce(function (items, value) {
      var text = String(value || "").trim();
      if (!text || seen.has(text)) return items;
      seen.add(text);
      items.push(text);
      return items;
    }, []);
  }

  function originalUnitPriceCents(item) {
    var quantity = Number((item && item.quantity) || 0);
    if (quantity <= 0) return 0;
    return originalLinePriceCents(item) / quantity;
  }

  function partialPromotionControlLinePricePlan(
    item,
    compareAtUnitPriceCents
  ) {
    var originalUnitPrice = Math.max(
      0,
      Math.round(originalUnitPriceCents(item))
    );
    var compareAtUnitPrice = Math.max(
      0,
      Math.round(Number(compareAtUnitPriceCents) || 0)
    );
    return {
      compareAtUnitPriceCents:
        compareAtUnitPrice > originalUnitPrice ? compareAtUnitPrice : 0,
      originalUnitPriceCents: originalUnitPrice,
    };
  }

  function decoratePartialPromotionControlLine(node, item, mount) {
    if (!node || !item) return;
    var priceWrapper = node.querySelector(".minicart__item-price-wrapper");
    if (!priceWrapper) return;
    var pricePlan = partialPromotionControlLinePricePlan(
      item,
      node.dataset.ssCompareAtUnitPrice
    );
    if (!(pricePlan.originalUnitPriceCents > 0)) return;
    node.setAttribute("data-ss-cart-promotion-partial-control-item", "");
    if (priceWrapper.__ssPartialPromotionOriginalHtml === undefined) {
      priceWrapper.__ssPartialPromotionOriginalHtml = priceWrapper.innerHTML;
    }
    priceWrapper.innerHTML = partialPromotionControlLinePriceHtml(
      pricePlan,
      mount
    );
    var discounts = node.querySelector(".discounts");
    if (!discounts) return;
    discounts.classList.add(
      "ss-cart-promotion-partial-control-discounts-hidden"
    );
    discounts.hidden = true;
    discounts.setAttribute("aria-hidden", "true");
  }

  function partialPromotionControlLinePriceHtml(pricePlan, mount) {
    var priceHtml =
      '<span class="minicart__item-price text-color-original-price heading-color heading-weight">' +
      escapeHtml(formatMoneyCents(pricePlan.originalUnitPriceCents, mount)) +
      "</span>";
    if (!(pricePlan.compareAtUnitPriceCents > 0)) return priceHtml;
    return (
      '<span class="minicart__item-price minicart__item-regular-price heading_weight primary-color me-3">' +
      escapeHtml(formatMoneyCents(pricePlan.originalUnitPriceCents, mount)) +
      "</span>" +
      '<s class="minicart__item-original-price">' +
      escapeHtml(formatMoneyCents(pricePlan.compareAtUnitPriceCents, mount)) +
      "</s>"
    );
  }

  function clearPartialPromotionControlLineEnhancements(root) {
    if (!root) return;
    Array.from(
      root.querySelectorAll(
        "[data-ss-cart-promotion-partial-control-item]"
      )
    ).forEach(function (node) {
      node.removeAttribute("data-ss-cart-promotion-partial-control-item");
      var priceWrapper = node.querySelector(".minicart__item-price-wrapper");
      if (
        priceWrapper &&
        priceWrapper.__ssPartialPromotionOriginalHtml !== undefined
      ) {
        priceWrapper.innerHTML = priceWrapper.__ssPartialPromotionOriginalHtml;
        delete priceWrapper.__ssPartialPromotionOriginalHtml;
      }
      Array.from(
        node.querySelectorAll(
          ".ss-cart-promotion-partial-control-discounts-hidden"
        )
      ).forEach(function (discounts) {
        discounts.classList.remove(
          "ss-cart-promotion-partial-control-discounts-hidden"
        );
        discounts.removeAttribute("hidden");
        discounts.removeAttribute("aria-hidden");
      });
    });
  }

  function buyNPayMFreeQuantityForItem(item, campaign) {
    var quantity = Math.max(0, Number((item && item.quantity) || 0));
    var unitPriceCents = originalUnitPriceCents(item);
    if (quantity <= 0 || unitPriceCents <= 0) return 0;
    var discountCents = lineCampaignDiscountAmountCents(item, campaign);
    return Math.min(
      quantity,
      Math.max(0, Math.round(discountCents / unitPriceCents))
    );
  }

  function lineCampaignDiscountAmountCents(item, campaign) {
    var campaignId = String((campaign && campaign.id) || "");
    if (!campaignId) return 0;
    var campaigns = activeCampaigns().slice();
    if (
      !campaigns.some(function (activeCampaign) {
        return (
          String((activeCampaign && activeCampaign.id) || "") === campaignId
        );
      })
    ) {
      campaigns.push(campaign);
    }
    return lineDiscountAllocations(item).reduce(function (total, allocation) {
      var matchedCampaign = campaignForDiscountApplication(
        allocation.discount_application || {},
        item,
        campaigns
      );
      return String((matchedCampaign && matchedCampaign.id) || "") ===
        campaignId
        ? total + Math.max(0, Math.round(Number(allocation.amount) || 0))
        : total;
    }, 0);
  }

  function decorateBuyNPayMFreeLine(node, item, mount, campaign, options) {
    if (!node || !item) return;
    var freeQuantity =
      options && options.freeQuantity !== undefined
        ? Math.max(0, Number(options.freeQuantity || 0))
        : buyNPayMFreeQuantityForItem(item, campaign);
    if (freeQuantity <= 0) return;
    node.classList.add("ss-cart-item--buy-n-pay-m-free");
    node.setAttribute("data-ss-buy-n-pay-m-free-item", "");
    node.dataset.ssBuyNPayMFreeQuantity = trimDisplayNumber(freeQuantity);
    updateBuyNPayMFreeLinePrice(node, item, mount);
    if (!options || !options.suppressRibbon) {
      insertBuyNPayMFreeRibbon(node, mount, campaign, freeQuantity);
    }
    insertBuyNPayMFreeQuantity(node, freeQuantity, mount);
    hideBuyNPayMDiscountLabels(node);
  }

  function updateBuyNPayMFreeLinePrice(node, item, mount) {
    var priceWrapper =
      node && node.querySelector(".minicart__item-price-wrapper");
    if (!priceWrapper) return;
    var originalUnitPrice = Math.max(
      0,
      Math.round(originalUnitPriceCents(item))
    );
    if (!(originalUnitPrice > 0)) return;
    if (priceWrapper.__ssBuyNPayMOriginalHtml === undefined) {
      priceWrapper.__ssBuyNPayMOriginalHtml = priceWrapper.innerHTML;
    }
    priceWrapper.innerHTML =
      '<div class="minicart__discounted-prices">' +
      '<span class="minicart__item-price minicart__item-regular-price text-color-regular-price heading_weight primary-color">' +
      escapeHtml(formatMoneyCents(0, mount)) +
      "</span> " +
      '<s class="minicart__item-original-price">' +
      escapeHtml(formatMoneyCents(originalUnitPrice, mount)) +
      "</s>" +
      "</div>";
  }

  function insertBuyNPayMFreeRibbon(
    node,
    mount,
    campaign,
    freeQuantity
  ) {
    if (!node || node.querySelector("[data-ss-buy-n-pay-m-free-tag]")) return;
    var labels = getLabels(mount);
    var label = buyNPayMFreeBadgeText(campaign, labels, freeQuantity);
    node.insertAdjacentHTML(
      "afterbegin",
      '<div class="ss-cart-item-free-gift__tag ss-cart-item-free-gift__tag--buy-n-pay-m" data-ss-buy-n-pay-m-free-tag>' +
        escapeHtml(label) +
        "</div>"
    );
  }

  function insertBuyNPayMFreeQuantity(node, freeQuantity, mount) {
    if (!node || node.querySelector("[data-ss-buy-n-pay-m-free-quantity]"))
      return;
    var quantity = Math.max(0, Number(freeQuantity || 0));
    if (quantity <= 0) return;
    var quantityText = trimDisplayNumber(quantity);
    var quantityLabel = getLabels(mount).quantity || "Quantity";
    var html =
      '<span class="ss-cart-item-free-line__quantity" data-ss-buy-n-pay-m-free-quantity aria-label="' +
      escapeHtml(quantityLabel + " " + quantityText) +
      '">x' +
      escapeHtml(quantityText) +
      "</span>";
    var priceWrapper = node.querySelector(".minicart__item-price-wrapper");
    if (priceWrapper) {
      priceWrapper.insertAdjacentHTML("beforeend", html);
      return;
    }
    var anchor =
      node.querySelector(".minicart__item-prices") ||
      node.querySelector(".product-item__name-minicart") ||
      node.querySelector(".product-item__name");
    if (anchor) {
      anchor.insertAdjacentHTML("afterend", html);
      return;
    }
    node.insertAdjacentHTML("beforeend", html);
  }

  function hideBuyNPayMDiscountLabels(node) {
    var discounts = node && node.querySelector(".discounts");
    if (!discounts) return;
    discounts.classList.add("ss-cart-promotion-buy-n-pay-m-discounts-hidden");
    discounts.hidden = true;
    discounts.setAttribute("aria-hidden", "true");
  }

  function clearBuyNPayMLineEnhancements(root) {
    if (!root) return;
    Array.from(
      root.querySelectorAll(".ss-cart-promotion-buy-n-pay-m-summary")
    ).forEach(function (summary) {
      summary.remove();
    });
    Array.from(
      root.querySelectorAll(".ss-cart-promotion-buy-n-pay-m-summary-line")
    ).forEach(function (node) {
      node.classList.remove("ss-cart-promotion-buy-n-pay-m-summary-line");
      delete node.dataset.ssCartPromotionBuyNPayMPaidQuantity;
      delete node.dataset.ssCartPromotionBuyNPayMFreeQuantity;
      delete node.dataset.ssCartPromotionBuyNPayMTotalQuantity;
      Array.from(
        node.querySelectorAll(".ss-cart-promotion-buy-n-pay-m-discounts-hidden")
      ).forEach(function (discounts) {
        discounts.classList.remove(
          "ss-cart-promotion-buy-n-pay-m-discounts-hidden"
        );
        discounts.removeAttribute("hidden");
        discounts.removeAttribute("aria-hidden");
      });
    });
    Array.from(
      root.querySelectorAll("[data-ss-buy-n-pay-m-free-item]")
    ).forEach(function (node) {
      node.removeAttribute("data-ss-buy-n-pay-m-free-item");
      node.classList.remove("ss-cart-item--buy-n-pay-m-free");
      delete node.dataset.ssBuyNPayMFreeQuantity;
      var priceWrapper = node.querySelector(".minicart__item-price-wrapper");
      if (
        priceWrapper &&
        priceWrapper.__ssBuyNPayMOriginalHtml !== undefined
      ) {
        priceWrapper.innerHTML = priceWrapper.__ssBuyNPayMOriginalHtml;
        delete priceWrapper.__ssBuyNPayMOriginalHtml;
      }
      Array.from(
        node.querySelectorAll(
          "[data-ss-buy-n-pay-m-free-tag], [data-ss-buy-n-pay-m-free-quantity]"
        )
      ).forEach(function (element) {
        element.remove();
      });
      Array.from(
        node.querySelectorAll(".ss-cart-promotion-buy-n-pay-m-discounts-hidden")
      ).forEach(function (discounts) {
        discounts.classList.remove(
          "ss-cart-promotion-buy-n-pay-m-discounts-hidden"
        );
        discounts.removeAttribute("hidden");
        discounts.removeAttribute("aria-hidden");
      });
    });
  }

  function buyNPayMLineGroupSignature(lineItems, campaign) {
    return (lineItems || [])
      .map(function (item) {
        return [
          item && item.key,
          item && item.quantity,
          finalLinePriceCents(item),
          originalLinePriceCents(item),
          buyNPayMFreeQuantityForItem(item, campaign),
        ].join(":");
      })
      .join("|");
  }

  function appendLineItemGroup(mount, options) {
    var group = document.createElement("div");
    group.className =
      "ss-cart-promotion-group " + String(options.className || "");
    group.dataset.ssCartPromotionGroupType = String(options.type || "items");
    group.innerHTML =
      lineItemGroupBadgeHtml(options.badge) +
      lineItemGroupHeaderHtml(options.title) +
      '<div class="ss-cart-promotion-group__items"></div>';
    mount.appendChild(group);
    var itemContainer = group.querySelector(".ss-cart-promotion-group__items");
    options.items.forEach(function (itemNode) {
      itemContainer.appendChild(itemNode);
    });
  }

  function lineItemGroupHeaderHtml(title) {
    var label = String(title || "").trim();
    if (!label) return "";
    return (
      '<div class="ss-cart-promotion-group__header">' +
      '<div class="ss-cart-promotion-group__copy">' +
      '<div class="ss-cart-promotion-group__title">' +
      escapeHtml(label) +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  function lineItemGroupBadgeHtml(label) {
    var value = String(label || "").trim();
    if (!value) return "";
    return (
      '<div class="ss-cart-promotion-group__badge ss-cart-item-free-gift__tag">' +
      escapeHtml(value) +
      "</div>"
    );
  }

  function campaignGroupTitle(campaign, progress, labels, mount, isGiftGroup) {
    if (isGiftGroup) {
      return (
        giftCampaignGroupTitle(campaign, labels) ||
        campaignDisplayTitle(campaign) ||
        campaignRuleTitle(campaign, progress && progress.displayTier, mount) ||
        displayGroupLabel(labels && labels.freeGift, "Free Gift")
      );
    }
    return (
      campaignDisplayTitle(campaign) ||
      campaignRuleTitle(campaign, progress && progress.displayTier, mount) ||
      ""
    );
  }

  function campaignGroupHeaderTitle(campaign) {
    return campaignDisplayTitle(campaign);
  }

  function giftCampaignGroupTitle(campaign, labels) {
    var giftTitles = uniqueGiftTitles(campaign, labels);
    if (giftTitles.length === 1) {
      return giftTitles[0];
    }
    if (giftTitles.length > 1) {
      return giftPluralGroupTitle(labels);
    }
    return "";
  }

  function uniqueGiftTitles(campaign, labels) {
    var seen = new Set();
    return sortTiers(campaign).reduce(function (items, tier) {
      var rawTitle = giftTierRawTitle(tier);
      var value = rawTitle ? localizedGiftTitle(rawTitle, labels) : "";
      if (!value || seen.has(value)) return items;
      seen.add(value);
      items.push(value);
      return items;
    }, []);
  }

  function giftPluralGroupTitle(labels) {
    return displayGroupLabel(labels && labels.freeGifts, "Free Gifts");
  }

  function groupHeaderHtml(campaign, cart, labels, mount, isGiftGroup) {
    var progress = campaignProgress(campaign, cart, mount, labels);
    var title = campaignGroupHeaderTitle(campaign);
    var titleHtml = groupTitleHtml(campaign, title);
    var actionHtml = "";
    if (shouldShowGroupPromotionAction(campaign, progress, mount)) {
      var actionAttributes = promotionDiscoverActionAttributes(campaign);
      actionHtml =
        '<button type="button" class="ss-cart-promotion-group__action" ' +
        actionAttributes +
        ">" +
        escapeHtml(labels.add || "Add") +
        "</button>";
    }
    return (
      '<div class="ss-cart-promotion-group__header">' +
      '<div class="ss-cart-promotion-group__copy">' +
      titleHtml +
      '<div class="ss-cart-promotion-group__subtitle">' +
      progress.subtitle +
      "</div>" +
      "</div>" +
      actionHtml +
      "</div>"
    );
  }

  function groupTitleHtml(campaign, title) {
    var escapedTitle = escapeHtml(title);
    return (
      '<div class="ss-cart-promotion-group__title">' +
      "<span>" +
      escapedTitle +
      "</span>" +
      descriptionHelpButtonHtml(
        campaign,
        "ss-cart-promotion-group__title-help"
      ) +
      "</div>"
    );
  }

  function descriptionHelpButtonHtml(campaign, className) {
    if (!campaignDescriptionHtml(campaign)) return "";
    var title = (campaign && campaign.name) || "Promotion";
    return (
      '<button type="button" class="' +
      escapeHtml(className) +
      '" data-ss-cart-promotion-description data-ss-cart-promotion-campaign-id="' +
      escapeHtml((campaign && campaign.id) || "") +
      '" aria-label="' +
      escapeHtml(title + " details") +
      '">' +
      '<span class="ss-cart-promotion-group__help" aria-hidden="true">' +
      lucideIconSvg("circle-help", 16, 16) +
      "</span>" +
      "</button>"
    );
  }

  function campaignDescriptionHtml(campaign) {
    return String(
      (campaign &&
        (campaign.descriptionHtml ||
          campaign.description_html ||
          campaign.description)) ||
        ""
    ).trim();
  }

  function giftPromptHtml(campaign, cart, labels, mount) {
    var progress = campaignProgress(campaign, cart, mount, labels);
    var promptText = giftPromptText(campaign, progress, labels, mount);
    var actionHtml = "";
    if (
      shouldShowPromotionAction(progress) &&
      canOpenDiscoverForMount(
        mount,
        "campaign",
        campaign,
        Boolean(progress.currentTier && !progress.nextTier)
      )
    ) {
      var actionAttributes = promotionDiscoverActionAttributes(campaign);
      actionHtml =
        '<button type="button" class="ss-cart-promotion-gift-row__action" ' +
        actionAttributes +
        ">" +
        escapeHtml(labels.add || "Add") +
        "</button>";
    }
    return (
      '<div class="ss-cart-promotion-gift-row">' +
      '<span class="ss-cart-promotion-gift-row__icon" aria-hidden="true">' +
      giftSmallIcon() +
      "</span>" +
      '<span class="ss-cart-promotion-gift-row__text">' +
      '<span class="ss-cart-promotion-gift-row__label">' +
      escapeHtml(promptText) +
      "</span>" +
      descriptionHelpButtonHtml(campaign, "ss-cart-promotion-gift-row__help") +
      "</span>" +
      actionHtml +
      giftTierProgressHtml(campaign, progress, labels) +
      "</div>"
    );
  }

  function giftTierProgressHtml(campaign, progress, labels) {
    var tiers = sortTiers(campaign).filter(function (tier) {
      return tierThreshold(tier) > 0;
    });
    if (tiers.length < 2) return "";
    var basis = Number((progress && progress.basis) || 0);
    var nextIndex = tiers.findIndex(function (tier) {
      return basis < tierThreshold(tier);
    });
    var hasNext = nextIndex >= 0;
    var isComplete = !hasNext;
    var segments = tiers
      .map(function (tier, index) {
        var previousThreshold = index > 0 ? tierThreshold(tiers[index - 1]) : 0;
        var threshold = tierThreshold(tier);
        var range = Math.max(1, threshold - previousThreshold);
        var fill =
          basis >= threshold
            ? 100
            : Math.max(
                0,
                Math.min(100, ((basis - previousThreshold) / range) * 100)
              );
        var status =
          basis >= threshold
            ? "earned"
            : hasNext && index === nextIndex
            ? "current"
            : "future";
        var flex = status === "current" || isComplete ? 1 : 0;
        var width = status === "current" || isComplete ? "auto" : "5.2rem";
        return (
          '<div class="ss-cart-promotion-gift-progress__segment is-' +
          status +
          '" role="listitem" style="--segment-flex:' +
          flex +
          ";--segment-width:" +
          width +
          ";--segment-fill:" +
          fill.toFixed(2) +
          '%;--segment-node:100%;">' +
          '<span class="ss-cart-promotion-gift-progress__bar"><span class="ss-cart-promotion-gift-progress__fill"></span></span>' +
          '<span class="ss-cart-promotion-gift-progress__node" aria-hidden="true">' +
          giftProgressNodeIcon(status) +
          "</span>" +
          '<span class="ss-cart-promotion-gift-progress__label">' +
          giftTierProgressLabel(tier, status, labels, index) +
          "</span>" +
          "</div>"
        );
      })
      .join("");
    return (
      '<div class="ss-cart-promotion-gift-progress" role="list" aria-label="' +
      escapeHtml(labels.freeGift || "Free Gift") +
      '">' +
      segments +
      "</div>"
    );
  }

  function priceTierProgressHtml(campaign, progress, labels, mount) {
    var tiers = sortTiers(campaign).filter(function (tier) {
      return tierThreshold(tier) > 0;
    });
    if (tiers.length < 2) return "";
    var basis = Number((progress && progress.basis) || 0);
    var nextIndex = tiers.findIndex(function (tier) {
      return basis < tierThreshold(tier);
    });
    var hasNext = nextIndex >= 0;
    var isComplete = !hasNext;
    var segments = tiers
      .map(function (tier, index) {
        var previousThreshold = index > 0 ? tierThreshold(tiers[index - 1]) : 0;
        var threshold = tierThreshold(tier);
        var range = Math.max(1, threshold - previousThreshold);
        var fill =
          basis >= threshold
            ? 100
            : Math.max(
                0,
                Math.min(100, ((basis - previousThreshold) / range) * 100)
              );
        var status =
          basis >= threshold
            ? "earned"
            : hasNext && index === nextIndex
            ? "current"
            : "future";
        var flex = status === "current" || isComplete ? 1 : 0;
        var width = status === "current" || isComplete ? "auto" : "5.2rem";
        return (
          '<div class="ss-cart-promotion-gift-progress__segment is-' +
          status +
          '" role="listitem" style="--segment-flex:' +
          flex +
          ";--segment-width:" +
          width +
          ";--segment-fill:" +
          fill.toFixed(2) +
          '%;--segment-node:100%;">' +
          '<span class="ss-cart-promotion-gift-progress__bar"><span class="ss-cart-promotion-gift-progress__fill"></span></span>' +
          '<span class="ss-cart-promotion-gift-progress__node" aria-hidden="true">' +
          priceProgressNodeIcon(status) +
          "</span>" +
          '<span class="ss-cart-promotion-gift-progress__label">' +
          priceTierProgressLabel(campaign, tier, status, labels, index, mount) +
          "</span>" +
          "</div>"
        );
      })
      .join("");
    return (
      '<div class="ss-cart-promotion-gift-progress ss-cart-promotion-gift-progress--price" role="list" aria-label="' +
      escapeHtml((campaign && campaign.name) || labels.discount || "Discount") +
      '">' +
      segments +
      "</div>"
    );
  }

  function priceTierProgressLabel(
    campaign,
    tier,
    status,
    labels,
    index,
    mount
  ) {
    if (status === "earned") {
      return escapeHtml(
        compactText(priceTierRewardLabel(campaign, tier, mount), 28)
      );
    }
    if (status === "current") {
      return escapeHtml(
        compactText(priceTierRewardLabel(campaign, tier, mount), 28)
      );
    }
    return escapeHtml(
      template(labels.priceTierFuture || "Tier {{ index }}", {
        index: String(Number(index || 0) + 1),
      })
    );
  }

  function priceTierRewardLabel(campaign, tier, mount) {
    var benefitType = campaignBenefitType(campaign);
    if (
      benefitType === "PERCENTAGE_OFF" ||
      benefitType === "FIXED_AMOUNT_OFF"
    ) {
      return discountOffRewardText(campaign, tier, mount, getLabels(mount));
    }
    if (benefitType === "FIXED_BUNDLE_PRICE") {
      return "For " + formatMoney(tier && tier.fixedBundlePrice, mount);
    }
    if (benefitType === BUY_N_PAY_M_TYPE) {
      return buyNPayMFreeItemLabel(campaign, tier, getLabels(mount));
    }
    if (benefitType === BUY_X_GET_Y_TYPE) {
      return buyXGetYTierRewardLabel(campaign, tier, getLabels(mount));
    }
    return formatMoney((tier && tier.discountAmount) || 0, mount);
  }

  function giftTierProgressLabel(tier, status, labels, index) {
    if (status === "earned") {
      return escapeHtml(
        template(labels.giftTierEarned, {
          gift: compactGiftTierTitle(tier, labels),
        })
      );
    }
    if (status === "current") {
      return escapeHtml(compactGiftTierTitle(tier, labels));
    }
    return escapeHtml(
      template(labels.giftTierFuture, {
        index: String(Number(index || 0) + 1),
      })
    );
  }

  function giftTierTitle(tier, labels) {
    var rawTitle = giftTierRawTitle(tier);
    return rawTitle
      ? localizedGiftTitle(rawTitle, labels)
      : displayGroupLabel(labels && labels.freeGift, "Free Gift");
  }

  function giftTierRawTitle(tier) {
    return (
      configuredGiftTitle(tier) ||
      firstPresentString(tier || {}, [
        "giftProductHandle",
        "gift_product_handle",
      ])
    );
  }

  function configuredGiftTitle(tier) {
    return firstPresentString(tier || {}, ["giftTitle", "gift_title"]);
  }

  function localizedGiftTitle(value, labels) {
    var rawTitle = cleanDisplayLabel(value);
    if (!rawTitle) {
      return displayGroupLabel(labels && labels.freeGift, "Free Gift");
    }
    if (giftTitleHasFreeAffix(rawTitle, labels)) return rawTitle;
    return template((labels && labels.giftTitle) || "{{ free }} {{ gift }}", {
      free: displayGroupLabel(labels && labels.free, "Free"),
      gift: rawTitle,
    })
      .replace(/\s+/g, " ")
      .trim();
  }

  function giftTitleHasFreeAffix(value, labels) {
    var normalizedTitle = normalizeGiftLineTitle(value);
    if (!normalizedTitle) return false;
    var templateAffix = String((labels && labels.giftTitle) || "")
      .replace(/\{\{\s*(?:free|gift)\s*\}\}/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
    return uniqueDisplayStrings([
      labels && labels.free,
      templateAffix,
      "free",
    ]).some(function (candidate) {
      var token = normalizeGiftLineTitle(candidate);
      var suffixIndex = normalizedTitle.length - token.length - 1;
      return (
        token &&
        (normalizedTitle === token ||
          normalizedTitle.indexOf(token + " ") === 0 ||
          (suffixIndex >= 0 &&
            normalizedTitle.lastIndexOf(" " + token) === suffixIndex))
      );
    });
  }

  function giftGapRewardText(tier, labels, hasUnlockedGift) {
    var giftTitle = giftTierTitle(tier, labels);
    if (!hasUnlockedGift) return giftTitle;
    return template(labels.nextGiftGapReward || "next {{ gift }}", {
      gift: giftTitle,
    });
  }

  function giftTierUnlockedText(tier, labels) {
    return template(
      (labels && labels.giftEarnedRewardSummaryOne) ||
        "You earned {{ count }} {{ gift }}",
      {
        count: "1",
        gift: giftTierTitle(tier, labels),
      }
    );
  }

  function giftTierRewardBadge(tier, labels) {
    return (labels && labels.freeGift) || "FREE GIFT";
  }

  function compactGiftTierTitle(tier, labels) {
    var title = giftTierTitle(tier, labels);
    var productTitle = title.split(" / ")[0] || title;
    return compactText(productTitle, 34);
  }

  function giftTierTitles(tiers, labels) {
    return (tiers || [])
      .map(function (tier) {
        return giftTierTitle(tier, labels);
      })
      .filter(Boolean)
      .join(", ");
  }

  function giftProgressNodeIcon(status) {
    return lucideIconSvg("gift", 12, 12);
  }

  function priceProgressNodeIcon(status) {
    return '<svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M8 2v12M5.1 5.1h4.4a1.7 1.7 0 0 1 0 3.4H6.5a1.7 1.7 0 0 0 0 3.4h4.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function shippingProgressNodeIcon() {
    return lucideIconSvg("truck", 12, 12);
  }

  function shouldShowPromotionAction(progress) {
    if (progress && typeof progress.hasNextReward === "boolean") {
      return progress.hasNextReward;
    }
    return Boolean(progress && (!progress.currentTier || progress.nextTier));
  }

  function shouldShowGroupPromotionAction(campaign, progress, mount) {
    if (campaignBenefitType(campaign) === BUY_N_PAY_M_TYPE) {
      return canOpenDiscoverForMount(mount, "campaign", campaign, false);
    }
    return shouldShowPromotionAction(progress);
  }

  function promotionDiscoverActionAttributes(campaign) {
    return (
      'data-ss-cart-promotion-open data-ss-cart-promotion-source="campaign" data-ss-cart-promotion-campaign-id="' +
      escapeHtml((campaign && campaign.id) || "") +
      '"'
    );
  }

  function campaignProgress(campaign, cart, mount, labels) {
    labels = labels || getLabels(mount);
    var tiers = sortTiers(campaign);
    var basis = campaignBasis(cart, campaign);
    var reached = tiers.filter(function (tier) {
      return basis >= tierThreshold(tier);
    });
    var current = reached[reached.length - 1] || null;
    var next =
      tiers.find(function (tier) {
        return basis < tierThreshold(tier);
      }) || null;
    var displayTier = current || next || tiers[tiers.length - 1] || null;
    var subtitle = "";
    var buyXGetYProgress = null;
    if (isGiftCampaign(campaign)) {
      if (current && next) {
        subtitle =
          giftEarnedSummaryHtml(reached.length, labels, current) +
          " · " +
          giftGapSentenceHtml(
            campaign,
            tierThreshold(next) - basis,
            giftGapRewardText(next, labels, true),
            mount,
            labels
          );
      } else if (current) {
        subtitle = giftEarnedSummaryHtml(reached.length, labels, current);
      } else if (next) {
        subtitle = giftGapSentenceHtml(
          campaign,
          tierThreshold(next) - basis,
          giftGapRewardText(next, labels, false),
          mount,
          labels
        );
      }
    } else {
      var saved = "";
      if (campaignBenefitType(campaign) === BUY_X_GET_Y_TYPE) {
        buyXGetYProgress = buyXGetYRepeatableProgress(campaign, basis);
        saved = buyXGetYProgressSubtitleHtml(
          campaign,
          buyXGetYProgress,
          labels
        );
      } else if (current) {
        if (campaignBenefitType(campaign) === BUY_N_PAY_M_TYPE) {
          saved = buyNPayMRewardStatusHtml(
            campaign,
            current,
            basis,
            cart,
            labels
          );
        } else if (campaignBenefitType(campaign) === "FIXED_BUNDLE_PRICE") {
          saved = fixedBundleRewardStatusHtml(
            campaign,
            current,
            cart,
            mount,
            labels
          );
        } else {
          var savingsCents = effectiveCampaignSavingsCents(campaign, cart);
          if (savingsCents > 0) {
            saved = template(escapeHtml(labels.saved), {
              amount: promotionAmountHtml(
                formatMoneyCents(savingsCents, mount)
              ),
            });
          } else {
            saved = escapeHtml(
              priceUnlockedText(campaign, current, mount, labels)
            );
          }
        }
      }
      var benefitType = campaignBenefitType(campaign);
      var nextText =
        benefitType !== BUY_X_GET_Y_TYPE &&
        next
        ? priceGapSentenceHtml(
            campaign,
            tierThreshold(next) - basis,
            next,
            mount,
            labels
          )
        : "";
      subtitle = saved ? saved + (nextText ? " · " + nextText : "") : nextText;
    }
    return {
      basis: basis,
      currentTier: current,
      nextTier: next,
      displayTier: displayTier,
      hasNextReward: buyXGetYProgress
        ? Boolean(buyXGetYProgress.nextQuantity != null)
        : undefined,
      subtitle: subtitle || "",
    };
  }

  function giftPromptText(campaign, progress, labels, mount) {
    if (!progress) return "";
    if (progress.nextTier) {
      return giftGapSentence(
        campaign,
        tierThreshold(progress.nextTier) - Number(progress.basis || 0),
        giftGapRewardText(
          progress.nextTier,
          labels,
          Boolean(progress.currentTier)
        ),
        mount,
        labels
      );
    }
    if (progress.currentTier) {
      var tiers = sortTiers(campaign);
      if (tiers.length === 1) {
        return giftTierUnlockedText(progress.currentTier, labels);
      }
      return labels.allGiftsUnlocked || "You've unlocked all free gifts";
    }
    return "";
  }

  function giftEarnedSummaryHtml(count, labels, tier) {
    var safeCount = Math.max(0, Number(count || 0));
    if (safeCount <= 0) return "";
    if (safeCount === 1) {
      return template(
        escapeHtml(
          labels.giftEarnedRewardSummaryOne ||
            "You earned {{ count }} {{ gift }}"
        ),
        {
          count: promotionAmountHtml(String(safeCount)),
          gift: escapeHtml(giftTierTitle(tier, labels)),
        }
      );
    }
    var templateText =
      safeCount === 1
        ? labels.giftEarnedSummaryOne
        : labels.giftEarnedSummaryOther;
    return template(escapeHtml(templateText), {
      count: promotionAmountHtml(String(safeCount)),
    });
  }

  function giftGapSentence(campaign, gap, giftTitle, mount, labels) {
    var safeGap = Math.max(0, Number(gap || 0));
    if (campaignThresholdType(campaign) === "QUANTITY") {
      var count = Math.ceil(safeGap);
      var itemLabels = campaignItemLabels(campaign, labels);
      if (itemLabels.hasCustom) {
        return template(
          count === 1
            ? labels.quantityGiftItemGapOne
            : labels.quantityGiftItemGapOther,
          {
            count: String(count),
            item: campaignItemLabel(campaign, count, labels),
            gift: giftTitle,
          }
        );
      }
      return template(
        count === 1 ? labels.quantityGiftGapOne : labels.quantityGiftGapOther,
        {
          count: String(count),
          gift: giftTitle,
        }
      );
    }
    return template(labels.subtotalGiftGap, {
      amount: formatMoney(safeGap, mount),
      gift: giftTitle,
    });
  }

  function giftGapSentenceHtml(campaign, gap, giftTitle, mount, labels) {
    var safeGap = Math.max(0, Number(gap || 0));
    if (campaignThresholdType(campaign) === "QUANTITY") {
      var count = Math.ceil(safeGap);
      var itemLabels = campaignItemLabels(campaign, labels);
      if (itemLabels.hasCustom) {
        return template(
          escapeHtml(
            count === 1
              ? labels.quantityGiftItemGapOne
              : labels.quantityGiftItemGapOther
          ),
          {
            count: promotionAmountHtml(String(count)),
            item: escapeHtml(campaignItemLabel(campaign, count, labels)),
            gift: escapeHtml(giftTitle),
          }
        );
      }
      return template(
        escapeHtml(
          count === 1 ? labels.quantityGiftGapOne : labels.quantityGiftGapOther
        ),
        {
          count: promotionAmountHtml(String(count)),
          gift: escapeHtml(giftTitle),
        }
      );
    }
    return template(escapeHtml(labels.subtotalGiftGap), {
      amount: promotionAmountHtml(formatMoney(safeGap, mount)),
      gift: escapeHtml(giftTitle),
    });
  }

  function priceGapSentence(campaign, gap, tier, mount, labels) {
    var safeGap = Math.max(0, Number(gap || 0));
    if (campaignThresholdType(campaign) === "QUANTITY") {
      var count = Math.ceil(safeGap);
      if (campaignBenefitType(campaign) === "FIXED_BUNDLE_PRICE") {
        return template(
          count === 1
            ? labels.bundleQuantityPriceGapOne
            : labels.bundleQuantityPriceGapOther,
          {
            count: String(count),
            quantity: trimDisplayNumber(tierThreshold(tier)),
            amount: formatMoney((tier && tier.fixedBundlePrice) || 0, mount),
          }
        );
      }
      if (campaignBenefitType(campaign) === BUY_N_PAY_M_TYPE) {
        return template(
          count === 1
            ? labels.buyNPayMQuantityPriceGapOne
            : labels.buyNPayMQuantityPriceGapOther,
          {
            count: String(count),
            item: buyNPayMItemLabel(campaign, count, labels),
            reward: tierRewardText(campaign, tier, mount),
          }
        );
      }
      if (campaignBenefitType(campaign) === BUY_X_GET_Y_TYPE) {
        var rewardQuantity = Math.max(
          0,
          Math.floor(Number((tier && tier.discountedQuantity) || 0))
        );
        var rewardDiscount = buyXGetYTierPercentage(tier);
        return template(
          count === 1
            ? labels.buyXGetYQuantityPriceGapOne
            : labels.buyXGetYQuantityPriceGapOther,
          {
            count: String(count),
            discount: trimDisplayNumber(rewardDiscount) + "%",
            item: campaignItemLabel(campaign, count, labels),
            reward_count: trimDisplayNumber(rewardQuantity),
            reward_item: campaignItemLabel(
              campaign,
              rewardQuantity,
              labels
            ),
          }
        );
      }
      return template(
        count === 1 ? labels.quantityPriceGapOne : labels.quantityPriceGapOther,
        {
          count: String(count),
          reward: discountOffRewardText(campaign, tier, mount, labels),
        }
      );
    }
    return template(labels.subtotalPriceGap, {
      amount: formatMoney(safeGap, mount),
      reward: discountOffRewardText(campaign, tier, mount, labels),
    });
  }

  function priceGapSentenceHtml(campaign, gap, tier, mount, labels) {
    var safeGap = Math.max(0, Number(gap || 0));
    if (campaignThresholdType(campaign) === "QUANTITY") {
      var count = Math.ceil(safeGap);
      if (campaignBenefitType(campaign) === "FIXED_BUNDLE_PRICE") {
        return template(
          escapeHtml(
            count === 1
              ? labels.bundleQuantityPriceGapOne
              : labels.bundleQuantityPriceGapOther
          ),
          {
            count: promotionAmountHtml(String(count)),
            quantity: promotionAmountHtml(
              trimDisplayNumber(tierThreshold(tier))
            ),
            amount: promotionAmountHtml(
              formatMoney((tier && tier.fixedBundlePrice) || 0, mount)
            ),
          }
        );
      }
      if (campaignBenefitType(campaign) === BUY_N_PAY_M_TYPE) {
        return template(
          escapeHtml(
            count === 1
              ? labels.buyNPayMQuantityPriceGapOne
              : labels.buyNPayMQuantityPriceGapOther
          ),
          {
            count: promotionAmountHtml(String(count)),
            item: escapeHtml(buyNPayMItemLabel(campaign, count, labels)),
            reward: promotionLeadingNumberHtml(
              tierRewardText(campaign, tier, mount)
            ),
          }
        );
      }
      if (campaignBenefitType(campaign) === BUY_X_GET_Y_TYPE) {
        var rewardQuantity = Math.max(
          0,
          Math.floor(Number((tier && tier.discountedQuantity) || 0))
        );
        var rewardDiscount = buyXGetYTierPercentage(tier);
        return template(
          escapeHtml(
            count === 1
              ? labels.buyXGetYQuantityPriceGapOne
              : labels.buyXGetYQuantityPriceGapOther
          ),
          {
            count: promotionAmountHtml(String(count)),
            discount: promotionAmountHtml(
              trimDisplayNumber(rewardDiscount) + "%"
            ),
            item: escapeHtml(campaignItemLabel(campaign, count, labels)),
            reward_count: promotionAmountHtml(
              trimDisplayNumber(rewardQuantity)
            ),
            reward_item: escapeHtml(
              campaignItemLabel(campaign, rewardQuantity, labels)
            ),
          }
        );
      }
      return template(
        escapeHtml(
          count === 1
            ? labels.quantityPriceGapOne
            : labels.quantityPriceGapOther
        ),
        {
          count: promotionAmountHtml(String(count)),
          reward: promotionLeadingNumberHtml(
            discountOffRewardText(campaign, tier, mount, labels)
          ),
        }
      );
    }
    return template(escapeHtml(labels.subtotalPriceGap), {
      amount: promotionAmountHtml(formatMoney(safeGap, mount)),
      reward: promotionLeadingNumberHtml(
        discountOffRewardText(campaign, tier, mount, labels)
      ),
    });
  }

  function priceUnlockedText(campaign, tier, mount, labels) {
    if (campaignBenefitType(campaign) === BUY_N_PAY_M_TYPE) {
      return (
        template(labels.buyNPayMEligible, {
          reward: campaignRuleTitle(campaign, tier, mount),
        }) + "."
      );
    }
    if (campaignBenefitType(campaign) === "FIXED_BUNDLE_PRICE") {
      return template(labels.amountUnlocked, {
        reward: campaignRuleTitle(campaign, tier, mount),
      });
    }
    return template(labels.amountUnlocked, {
      reward: discountOffRewardText(campaign, tier, mount, labels),
    });
  }

  function fixedBundleRewardStatusHtml(campaign, tier, cart, mount, labels) {
    var savingsCents = effectiveCampaignSavingsCents(campaign, cart);
    if (savingsCents <= 0) {
      return escapeHtml(priceUnlockedText(campaign, tier, mount, labels));
    }
    var plan = fixedBundleDiscountPlan(campaign, cart);
    var status = template(escapeHtml(labels.bundleApplied), {
      quantity: promotionAmountHtml(
        trimDisplayNumber((plan && plan.quantity) || tierThreshold(tier))
      ),
      amount: promotionAmountHtml(
        plan
          ? formatMoneyCents(plan.fixedPriceCents, mount)
          : formatMoney((tier && tier.fixedBundlePrice) || 0, mount)
      ),
    });
    return (
      status +
      " · " +
      template(escapeHtml(labels.saved), {
        amount: promotionAmountHtml(formatMoneyCents(savingsCents, mount)),
      })
    );
  }

  function promotionAmountHtml(amount) {
    return (
      '<span class="ss-cart-promotion-amount">' + escapeHtml(amount) + "</span>"
    );
  }

  function promotionLeadingNumberHtml(value) {
    return promotionDynamicValueHtml(value);
  }

  function promotionDynamicValueHtml(value) {
    var text = String(value == null ? "" : value);
    var pattern =
      /(?:[A-Z]{3}\s*)?(?:[$€£¥]\s*)\d[\d,]*(?:\.\d+)?|\d[\d,]*(?:\.\d+)?\s*(?:%|[$€£¥]|[A-Z]{3})|\d[\d,]*(?:\.\d+)?/g;
    var html = "";
    var lastIndex = 0;
    var match;
    while ((match = pattern.exec(text))) {
      html += escapeHtml(text.slice(lastIndex, match.index));
      html += promotionAmountHtml(match[0]);
      lastIndex = match.index + match[0].length;
    }
    html += escapeHtml(text.slice(lastIndex));
    return html;
  }

  function campaignDisplayTitle(campaign) {
    return String((campaign && campaign.name) || "").trim();
  }

  function campaignRuleTitle(campaign, tier, mount) {
    if (!campaign || !tier) return (campaign && campaign.name) || "";
    var threshold = tierThreshold(tier);
    var thresholdText =
      campaignThresholdType(campaign) === "QUANTITY"
        ? trimDisplayNumber(threshold)
        : formatMoney(threshold, mount);
    var prefix =
      campaignThresholdType(campaign) === "QUANTITY" ? "Buy " : "Spend ";
    var benefitType = campaignBenefitType(campaign);
    if (benefitType === BUY_N_PAY_M_TYPE) {
      return (
        "Buy " +
        trimDisplayNumber(threshold) +
        " Pay " +
        trimDisplayNumber(tier.payQuantity || 0)
      );
    }
    if (benefitType === BUY_X_GET_Y_TYPE) {
      return (
        "Buy " +
        trimDisplayNumber(threshold) +
        " Get " +
        buyXGetYTierRewardLabel(campaign, tier, getLabels(mount))
      );
    }
    if (benefitType === "FIXED_BUNDLE_PRICE") {
      return (
        "Buy " +
        thresholdText +
        " For " +
        formatMoney(tier.fixedBundlePrice || 0, mount)
      );
    }
    if (benefitType === "PERCENTAGE_OFF") {
      return (
        prefix +
        thresholdText +
        " Get " +
        discountOffRewardText(campaign, tier, mount, getLabels(mount))
      );
    }
    if (benefitType === "FIXED_AMOUNT_OFF") {
      return (
        prefix +
        thresholdText +
        " Save " +
        discountOffRewardText(campaign, tier, mount, getLabels(mount))
      );
    }
    return campaign.name || "";
  }

  function fixedBundleDiscountPlan(campaign, cart) {
    var tiers = fixedBundleTierOptions(campaign);
    if (!tiers.length || !cart || !Array.isArray(cart.items)) return null;
    var units = fixedBundleUnitPrices(campaign, cart);
    if (!units.length) return null;

    var maxQuantity = units.length;
    var prefixSubtotals = [0];
    units.forEach(function (price) {
      prefixSubtotals.push(
        prefixSubtotals[prefixSubtotals.length - 1] +
          Math.max(0, Math.round(price || 0))
      );
    });

    var bestFixedPrices = new Array(maxQuantity + 1).fill(null);
    bestFixedPrices[0] = 0;

    for (var quantity = 1; quantity <= maxQuantity; quantity += 1) {
      tiers.forEach(function (tierOption) {
        if (quantity < tierOption.thresholdQuantity) return;
        var previousPrice =
          bestFixedPrices[quantity - tierOption.thresholdQuantity];
        if (previousPrice == null) return;
        var candidatePrice = previousPrice + tierOption.fixedPriceCents;
        if (
          bestFixedPrices[quantity] == null ||
          candidatePrice < bestFixedPrices[quantity]
        ) {
          bestFixedPrices[quantity] = candidatePrice;
        }
      });
    }

    var bestQuantity = 0;
    var bestDiscountCents = 0;
    for (
      var selectedQuantity = 1;
      selectedQuantity <= maxQuantity;
      selectedQuantity += 1
    ) {
      var fixedPriceCents = bestFixedPrices[selectedQuantity];
      if (fixedPriceCents == null) continue;
      var discountCents = Math.max(
        0,
        prefixSubtotals[selectedQuantity] - fixedPriceCents
      );
      if (
        discountCents > bestDiscountCents ||
        (discountCents === bestDiscountCents && selectedQuantity > bestQuantity)
      ) {
        bestQuantity = selectedQuantity;
        bestDiscountCents = discountCents;
      }
    }

    if (bestQuantity <= 0 || bestDiscountCents <= 0) return null;
    return {
      discountCents: bestDiscountCents,
      fixedPriceCents: bestFixedPrices[bestQuantity],
      quantity: bestQuantity,
    };
  }

  function fixedBundleTierOptions(campaign) {
    return sortTiers(campaign)
      .map(function (tier) {
        var threshold = tierThreshold(tier);
        return {
          threshold: threshold,
          thresholdQuantity: Math.floor(threshold),
          fixedPriceCents: centsFromAmount(
            (tier && tier.fixedBundlePrice) || 0
          ),
        };
      })
      .filter(function (tierOption) {
        return (
          tierOption.threshold === tierOption.thresholdQuantity &&
          tierOption.thresholdQuantity > 0 &&
          tierOption.fixedPriceCents > 0
        );
      });
  }

  function fixedBundleUnitPrices(campaign, cart) {
    var units = [];
    if (!cart || !Array.isArray(cart.items)) return units;
    cart.items.forEach(function (item) {
      if (isSystemGiftItem(item) || !isLineEligibleForCampaign(item, campaign))
        return;
      var quantity = Math.max(0, Math.round(Number(item.quantity || 0)));
      var unitPrice = quantity > 0 ? originalUnitPriceCents(item) : 0;
      for (var index = 0; index < quantity; index += 1) {
        units.push(unitPrice);
      }
    });
    units.sort(function (left, right) {
      return right - left;
    });
    return units;
  }

  function giftSmallIcon() {
    return lucideIconSvg("gift", 17, 17);
  }

  function shippingSmallIcon() {
    return lucideIconSvg("truck", 17, 17);
  }

  function lucideIconSvg(name, width, height) {
    var paths = "";
    if (name === "truck") {
      paths =
        '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>' +
        '<path d="M15 18H9"></path>' +
        '<path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>' +
        '<circle cx="17" cy="18" r="2"></circle>' +
        '<circle cx="7" cy="18" r="2"></circle>';
    } else if (name === "circle-help") {
      paths =
        '<circle cx="12" cy="12" r="10"></circle>' +
        '<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>' +
        '<path d="M12 17h.01"></path>';
    } else {
      paths =
        '<path d="M20 12v10H4V12"></path>' +
        '<path d="M2 7h20v5H2z"></path>' +
        '<path d="M12 22V7"></path>' +
        '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>' +
        '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>';
    }
    return (
      '<svg width="' +
      width +
      '" height="' +
      height +
      '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      paths +
      "</svg>"
    );
  }

  function currentGiftTier(campaign, tiers, basis) {
    return (
      tiers.find(function (tier) {
        return basis < tierThreshold(tier);
      }) ||
      tiers[tiers.length - 1] ||
      null
    );
  }

  function giftTierHtml(tier, basis, labels, mount, campaign) {
    var threshold = tierThreshold(tier);
    var unlocked = basis >= threshold;
    var canOpenDiscover = canOpenDiscoverForMount(
      mount,
      "campaign",
      campaign,
      unlocked
    );
    var image = tier.giftImageUrl
      ? '<img src="' +
        escapeHtml(tier.giftImageUrl) +
        '" alt="" loading="lazy">'
      : giftPlaceholderIcon();
    var title = giftTierTitle(tier, labels);
    var rewardBadge = giftTierRewardBadge(tier, labels);
    var sellingPrice = giftSellingPrice(tier, mount);
    var priceHtml = sellingPrice
      ? '<span class="ss-cart-promotion-gift__price-strike">' +
        escapeHtml(sellingPrice) +
        "</span>"
      : '<span class="ss-cart-promotion-gift__price-strike" data-ss-cart-promotion-gift-original-price hidden></span>';
    var noteHtml = unlocked
      ? escapeHtml(labels.giftUnlocked)
      : template(escapeHtml(labels.giftLocked), {
          amount:
            '<span class="ss-cart-promotion-gift__highlight">' +
            escapeHtml(progressGapText(campaign, threshold - basis, mount)) +
            "</span>",
        });
    var addHtml = canOpenDiscover
      ? '<span class="ss-cart-promotion-link ss-cart-promotion-gift__add" aria-hidden="true">' +
        escapeHtml(labels.add) +
        "</span>"
      : "";
    var cardAttributes = canOpenDiscover
      ? ' data-ss-cart-promotion-open data-ss-cart-promotion-source="campaign" data-ss-cart-promotion-campaign-id="' +
        escapeHtml((campaign && campaign.id) || "") +
        '" role="button" tabindex="0" aria-label="' +
        escapeHtml(labels.add + " " + title) +
        '"'
      : "";
    return (
      '<div class="ss-cart-promotion-gift' +
      (unlocked ? " is-unlocked" : "") +
      '"' +
      cardAttributes +
      ">" +
      '<div class="ss-cart-promotion-gift__tag-wrap"><span class="ss-cart-promotion-gift__tag">' +
      escapeHtml(rewardBadge) +
      "</span></div>" +
      '<div class="ss-cart-promotion-gift__media">' +
      image +
      "</div>" +
      '<div class="ss-cart-promotion-gift__body">' +
      '<div class="ss-cart-promotion-gift__title product-item__name product-item__name-minicart fs-custom heading-color">' +
      escapeHtml(title) +
      "</div>" +
      '<div class="ss-cart-promotion-gift__price">' +
      priceHtml +
      '<span class="ss-cart-promotion-gift__price-free">' +
      escapeHtml(formatMoneyCents(0, mount)) +
      "</span></div>" +
      '<div class="ss-cart-promotion-gift__note-row">' +
      '<div class="ss-cart-promotion-gift__note">' +
      noteHtml +
      "</div>" +
      addHtml +
      "</div>" +
      "</div>" +
      giftProgressIcon(unlocked, threshold, basis, labels) +
      "</div>"
    );
  }

  function progressGapText(campaign, gap, mount) {
    var safeGap = Math.max(0, Number(gap || 0));
    return campaignThresholdType(campaign) === "QUANTITY"
      ? String(Math.ceil(safeGap))
      : formatMoney(safeGap, mount);
  }

  function tierRewardText(campaign, tier, mount) {
    var benefitType = campaignBenefitType(campaign);
    if (benefitType === "PERCENTAGE_OFF") {
      return trimDisplayNumber(tier && tier.percentage) + "%";
    }
    if (benefitType === "FIXED_BUNDLE_PRICE") {
      return formatMoney(tier && tier.fixedBundlePrice, mount);
    }
    if (benefitType === BUY_N_PAY_M_TYPE) {
      return buyNPayMFreeItemLabel(campaign, tier, getLabels(mount));
    }
    if (benefitType === BUY_X_GET_Y_TYPE) {
      return buyXGetYTierRewardLabel(campaign, tier, getLabels(mount));
    }
    if (benefitType === GIFT_TYPE || benefitType === "FREE_GIFT") {
      return giftTierTitle(tier, getLabels(mount));
    }
    return formatDiscountMoney((tier && tier.discountAmount) || 0, mount);
  }

  function isDiscountOffCampaign(campaign) {
    var benefitType = campaignBenefitType(campaign);
    return (
      benefitType === "FIXED_AMOUNT_OFF" || benefitType === "PERCENTAGE_OFF"
    );
  }

  function discountOffRewardText(campaign, tier, mount, labels) {
    var reward = tierRewardText(campaign, tier, mount);
    if (!isDiscountOffCampaign(campaign)) return reward;
    return reward + " " + ((labels && labels.off) || "OFF");
  }

  function formatDiscountMoney(amount, mount) {
    return formatMoney(amount, mount).replace(
      /([.,])00(?=(?:\s|&nbsp;|[^\d])*$)/,
      ""
    );
  }

  function buyNPayMFreeItemLabel(campaign, tier, themeLabels) {
    var buyQuantity = Math.floor(tierThreshold(tier));
    var payQuantity = Math.floor(Number((tier && tier.payQuantity) || 0));
    var freeQuantity = Math.max(0, buyQuantity - payQuantity);
    return buyNPayMFreeQuantityLabel(campaign, freeQuantity, themeLabels);
  }

  function buyNPayMRewardStatusLabel(campaign, tier, basis, cart, themeLabels) {
    var applied = buyNPayMAppliedDiscountSummary(campaign, cart);
    if (applied.freeQuantity > 0 || applied.savingsCents > 0) {
      return template(
        (themeLabels && themeLabels.buyNPayMApplied) || "{{ reward }} applied",
        {
          reward: buyNPayMFreeQuantityLabel(
            campaign,
            applied.freeQuantity ||
              buyNPayMExpectedFreeQuantity(campaign, basis, tier),
            themeLabels
          ),
        }
      );
    }
    return buyNPayMEligibleRewardLabel(campaign, tier, basis, themeLabels);
  }

  function buyNPayMRewardStatusHtml(campaign, tier, basis, cart, themeLabels) {
    var applied = buyNPayMAppliedDiscountSummary(campaign, cart);
    var freeQuantity =
      applied.freeQuantity ||
      buyNPayMExpectedFreeQuantity(campaign, basis, tier);
    var statusTemplate =
      applied.freeQuantity > 0 || applied.savingsCents > 0
        ? (themeLabels && themeLabels.buyNPayMApplied) || "{{ reward }} applied"
        : (themeLabels && themeLabels.buyNPayMEligible) ||
          "{{ reward }} eligible";
    return template(escapeHtml(statusTemplate), {
      reward: buyNPayMFreeQuantityHtml(campaign, freeQuantity, themeLabels),
    });
  }

  function buyNPayMEligibleRewardLabel(campaign, tier, basis, themeLabels) {
    return template(
      (themeLabels && themeLabels.buyNPayMEligible) || "{{ reward }} eligible",
      {
        reward: buyNPayMFreeQuantityLabel(
          campaign,
          buyNPayMExpectedFreeQuantity(campaign, basis, tier),
          themeLabels
        ),
      }
    );
  }

  function buyNPayMExpectedFreeQuantity(campaign, basis, fallbackTier) {
    var plan = repeatablePackPlan(campaign, basis);
    if (plan) return repeatablePackRewardQuantity(plan);
    var buyQuantity = Math.floor(tierThreshold(fallbackTier));
    var payQuantity = Math.floor(
      Number((fallbackTier && fallbackTier.payQuantity) || 0)
    );
    if (buyQuantity < 2 || payQuantity < 1 || payQuantity >= buyQuantity) {
      return 0;
    }
    return (
      Math.floor(Number(basis || 0) / buyQuantity) *
      (buyQuantity - payQuantity)
    );
  }

  function buyXGetYTierRewardLabel(campaign, tier, themeLabels) {
    var quantity = Math.max(
      0,
      Math.floor(Number((tier && tier.discountedQuantity) || 0))
    );
    var discount = buyXGetYTierPercentage(tier);
    return template(
      quantity === 1
        ? (themeLabels && themeLabels.buyXGetYRewardOne) ||
            "{{ count }} {{ item }} {{ discount }} off"
        : (themeLabels && themeLabels.buyXGetYRewardOther) ||
            "{{ count }} {{ item }} {{ discount }} off",
      {
        count: trimDisplayNumber(quantity),
        discount: trimDisplayNumber(discount) + "%",
        item: campaignItemLabel(campaign, quantity, themeLabels),
      }
    );
  }

  function buyXGetYSegmentDiscount(segment) {
    if (!segment) return 0;
    var basisPoints = Number(segment.discountBasisPoints || 0);
    if (basisPoints > 0) return basisPoints / 100;
    return Math.max(0, Number(segment.percentage || 0));
  }

  function buyXGetYRewardSegmentsHtml(campaign, segments, themeLabels) {
    return (segments || [])
      .map(function (segment, index) {
        var text =
          index === 0
            ? (themeLabels && themeLabels.buyXGetYResultFirst) ||
              "{{ count }} {{ item }} {{ discount }} off"
            : (themeLabels && themeLabels.buyXGetYResultAdditional) ||
              "another {{ count }} {{ item }} {{ discount }} off";
        return template(escapeHtml(text), {
          count: promotionAmountHtml(
            trimDisplayNumber(segment.quantity)
          ),
          discount: promotionAmountHtml(
            trimDisplayNumber(buyXGetYSegmentDiscount(segment)) + "%"
          ),
          item: escapeHtml(
            campaignItemLabel(campaign, segment.quantity, themeLabels)
          ),
        });
      })
      .join(" · ");
  }

  function buyXGetYRewardStatusHtml(campaign, basis, themeLabels) {
    var segments = buyXGetYPlanSegments(campaign, basis);
    if (!segments.length) return "";
    var rewards = buyXGetYRewardSegmentsHtml(
      campaign,
      segments,
      themeLabels
    );
    return template(
      escapeHtml(
        (themeLabels && themeLabels.buyXGetYApplied) ||
          "You've unlocked {{ rewards }}"
      ),
      { rewards: rewards }
    );
  }

  function buyXGetYProgressSubtitleHtml(campaign, progress, themeLabels) {
    if (!progress) return "";
    var unlockedStatus = progress.currentSegments.length
      ? buyXGetYRewardStatusHtml(
          campaign,
          progress.eligibleQuantity,
          themeLabels
        )
      : "";
    if (progress.firstRoundComplete) {
      return unlockedStatus;
    }
    if (progress.nextQuantity == null) {
      return unlockedStatus;
    }
    var joinPrompt = function (prompt) {
      if (!prompt) return unlockedStatus;
      return unlockedStatus
        ? unlockedStatus + " · " + prompt
        : prompt;
    };
    var gap = Math.max(
      0,
      Number(progress.nextQuantity || 0) -
        Number(progress.eligibleQuantity || 0)
    );
    if (gap <= 0) {
      return buyXGetYRewardStatusHtml(
        campaign,
        progress.eligibleQuantity,
        themeLabels
      );
    }
    var promptSegment =
      progress.currentSegments.length === 0 &&
      progress.nextSegments.length === 1
        ? progress.nextSegments[0]
        : progress.addedSegments.length === 1
        ? progress.addedSegments[0]
        : null;
    if (promptSegment && !progress.isUpgrade) {
      var isRepeat = progress.currentSegments.length > 0;
      var templateText = isRepeat
        ? Number(promptSegment.quantity || 0) === 1
          ? themeLabels.buyXGetYProgressRepeatOne
          : themeLabels.buyXGetYProgressRepeatOther
        : gap === 1
        ? themeLabels.buyXGetYQuantityPriceGapOne
        : themeLabels.buyXGetYQuantityPriceGapOther;
      var fallback = isRepeat
        ? Number(promptSegment.quantity || 0) === 1
          ? "Add {{ count }} more {{ item }}; another item will get {{ discount }} off"
          : "Add {{ count }} more {{ item }}; {{ reward_count }} more items will get {{ discount }} off"
        : "Add {{ count }} more {{ item }}; {{ reward_count }} {{ reward_item }} will get {{ discount }} off";
      return joinPrompt(
        template(escapeHtml(templateText || fallback), {
          count: promotionAmountHtml(trimDisplayNumber(gap)),
          discount: promotionAmountHtml(
            trimDisplayNumber(buyXGetYSegmentDiscount(promptSegment)) + "%"
          ),
          item: escapeHtml(campaignItemLabel(campaign, gap, themeLabels)),
          reward_count: promotionAmountHtml(
            trimDisplayNumber(promptSegment.quantity)
          ),
          reward_item: escapeHtml(
            campaignItemLabel(campaign, promptSegment.quantity, themeLabels)
          ),
        })
      );
    }
    return joinPrompt(
      template(
        escapeHtml(
          themeLabels.buyXGetYProgressUpgrade ||
            "Add {{ count }} more {{ item }} to unlock {{ rewards }}"
        ),
        {
          count: promotionAmountHtml(trimDisplayNumber(gap)),
          item: escapeHtml(campaignItemLabel(campaign, gap, themeLabels)),
          rewards: buyXGetYRewardSegmentsHtml(
            campaign,
            progress.nextSegments,
            themeLabels
          ),
        }
      )
    );
  }

  function buyNPayMAppliedDiscountSummary(campaign, cart) {
    var summary = { freeQuantity: 0, savingsCents: 0 };
    if (!cart || !Array.isArray(cart.items)) return summary;
    cart.items.forEach(function (item) {
      if (
        !item ||
        isSystemGiftItem(item) ||
        !isLineEligibleForCampaign(item, campaign)
      ) {
        return;
      }
      summary.freeQuantity += buyNPayMFreeQuantityForItem(item, campaign);
      summary.savingsCents += lineCampaignDiscountAmountCents(item, campaign);
    });
    return summary;
  }

  function buyNPayMFreeQuantityLabel(campaign, freeQuantity, themeLabels) {
    var safeFreeQuantity = Math.max(0, Number(freeQuantity || 0));
    return template(
      buyNPayMFreeQuantityTemplate(safeFreeQuantity, themeLabels),
      {
        count: trimDisplayNumber(safeFreeQuantity),
        free: (themeLabels && themeLabels.free) || "Free",
        item: buyNPayMItemLabel(campaign, safeFreeQuantity, themeLabels),
      }
    );
  }

  function buyNPayMFreeQuantityHtml(campaign, freeQuantity, themeLabels) {
    var safeFreeQuantity = Math.max(0, Number(freeQuantity || 0));
    return template(
      escapeHtml(buyNPayMFreeQuantityTemplate(safeFreeQuantity, themeLabels)),
      {
        count:
          '<span class="ss-cart-promotion-count">' +
          escapeHtml(trimDisplayNumber(safeFreeQuantity)) +
          "</span>",
        free: escapeHtml((themeLabels && themeLabels.free) || "Free"),
        item: escapeHtml(
          buyNPayMItemLabel(campaign, safeFreeQuantity, themeLabels)
        ),
      }
    );
  }

  function buyNPayMFreeQuantityTemplate(quantity, themeLabels) {
    return Number(quantity || 0) === 1
      ? (themeLabels && themeLabels.buyNPayMFreeRewardOne) ||
          "{{ count }} {{ free }} {{ item }}"
      : (themeLabels && themeLabels.buyNPayMFreeRewardOther) ||
          "{{ count }} {{ free }} {{ item }}";
  }

  function buyNPayMFreeBadgeText(campaign, labels, freeQuantity) {
    var quantity = Math.max(0, Number(freeQuantity || 0));
    var itemLabels = buyNPayMItemLabels(campaign, labels);
    if (!itemLabels.hasCustom && quantity === 1) {
      return (labels && labels.freeItem) || "FREE ITEM";
    }
    return (
      ((labels && labels.free) || "Free") +
      " " +
      (itemLabels.hasCustom
        ? buyNPayMItemLabel(campaign, quantity, labels)
        : (labels && labels.items) || "items")
    );
  }

  function buyNPayMItemLabel(campaign, quantity, labels) {
    return campaignItemLabel(campaign, quantity, labels);
  }

  function buyNPayMItemLabels(campaign, labels) {
    return campaignItemLabels(campaign, labels);
  }

  function campaignItemLabel(campaign, quantity, fallbackLabels) {
    var labels = campaignItemLabels(campaign, fallbackLabels);
    return Number(quantity || 0) === 1 ? labels.singular : labels.plural;
  }

  function campaignItemLabels(campaign, fallbackLabels) {
    var displayConfig =
      campaign && typeof campaign.displayConfig === "object"
        ? campaign.displayConfig
        : {};
    var itemLabel =
      displayConfig && typeof displayConfig.itemLabel === "object"
        ? displayConfig.itemLabel
        : {};
    var singular = cleanDisplayLabel(itemLabel && itemLabel.singular);
    var plural = cleanDisplayLabel(itemLabel && itemLabel.plural);
    var hasCustom = Boolean(singular || plural);
    var fallbackSingular =
      singular || (fallbackLabels && fallbackLabels.item) || "item";
    return {
      hasCustom: hasCustom,
      singular: fallbackSingular,
      plural:
        plural ||
        (singular
          ? inferPluralItemLabel(fallbackSingular)
          : (fallbackLabels && fallbackLabels.items) ||
            inferPluralItemLabel(fallbackSingular)),
    };
  }

  function inferPluralItemLabel(singular) {
    var value = cleanDisplayLabel(singular) || "item";
    if (value.toLowerCase() === "item") return "items";
    if (/[^aeiou]y$/i.test(value)) return value.slice(0, -1) + "ies";
    if (/(s|x|z|ch|sh)$/i.test(value)) return value + "es";
    return value + "s";
  }

  function cleanDisplayLabel(value) {
    return String(value == null ? "" : value)
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 80);
  }

  function trimDisplayNumber(value) {
    var number = Number(value || 0);
    if (!Number.isFinite(number)) return "0";
    return number % 1 === 0
      ? String(number)
      : number.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
  }

  function giftSellingPrice(tier, mount) {
    var display = firstPresentString(tier, [
      "giftPriceFormatted",
      "gift_price_formatted",
    ]);
    if (display) return display;
    var centsValue = [
      tier.giftProductPriceCents,
      tier.gift_product_price_cents,
      tier.giftVariantPriceCents,
      tier.gift_variant_price_cents,
      tier.giftPriceCents,
      tier.gift_price_cents,
    ].find(function (item) {
      return item != null && item !== "";
    });
    var cents = Number(centsValue);
    if (Number.isFinite(cents) && cents > 0) {
      return formatMoneyCents(cents, mount);
    }
    var value = [
      tier.giftProductPrice,
      tier.gift_product_price,
      tier.giftVariantPrice,
      tier.gift_variant_price,
      tier.giftPrice,
      tier.gift_price,
    ].find(function (item) {
      return item != null && item !== "";
    });
    if (value == null || value === "") return "";
    if (typeof value === "string" && value.trim() === "") return "";
    var numeric = Number(
      typeof value === "string" ? value.replace(/,/g, "").trim() : value
    );
    if (typeof value === "string" && !Number.isFinite(numeric))
      return value.trim();
    if (!Number.isFinite(numeric) || numeric <= 0) return "";
    return formatMoney(numeric, mount);
  }

  function giftSellingPriceCacheKey(tier) {
    var variantId = giftVariantId(tier);
    if (variantId) return "variant:" + variantId;
    var handle = giftProductHandle(tier);
    return handle ? "product:" + handle : "";
  }

  function resolveGiftSellingPriceCents(tier) {
    var key = giftSellingPriceCacheKey(tier);
    if (!key) return Promise.resolve(0);
    var cached = Number(state.giftSellingPriceCentsCache.get(key) || 0);
    if (cached > 0) return Promise.resolve(cached);
    if (!state.giftSellingPriceRequestCache.has(key)) {
      state.giftSellingPriceRequestCache.set(
        key,
        fetchGiftSellingPriceCents(
          giftProductHandle(tier),
          giftVariantId(tier),
          giftProductUrl(tier)
        )
          .then(function (priceCents) {
            var resolved = positiveCents(priceCents);
            if (resolved > 0) {
              state.giftSellingPriceCentsCache.set(key, resolved);
            }
            return resolved;
          })
          .catch(function (error) {
            console.warn("Unable to resolve gift original price", error);
            return 0;
          })
      );
    }
    return state.giftSellingPriceRequestCache.get(key);
  }

  function giftProductHandle(tier) {
    return normalizeHandle(
      tier &&
        (tier.giftProductHandle ||
          tier.gift_product_handle ||
          tier.giftHandle ||
          tier.gift_handle ||
          tier.productHandle ||
          tier.product_handle)
    );
  }

  function giftProductUrl(tier) {
    return firstPresentString(tier || {}, [
      "giftProductUrl",
      "gift_product_url",
      "productUrl",
      "product_url",
      "url",
    ]);
  }

  function giftVariantId(tier) {
    var value =
      tier &&
      (tier.giftVariantLegacyId ||
        tier.gift_variant_legacy_id ||
        tier.giftVariantId ||
        tier.gift_variant_id ||
        tier.variantLegacyId ||
        tier.variant_legacy_id ||
        tier.variantId ||
        tier.variant_id);
    return normalizeLegacyId(value);
  }

  function normalizeLegacyId(value) {
    if (value == null || value === "") return "";
    var raw = String(value).trim();
    return raw ? raw.split("/").pop() : "";
  }

  function hydrateGiftSellingPrice(mount, tier) {
    var target = mount.querySelector(
      "[data-ss-cart-promotion-gift-original-price]"
    );
    if (!target) return;
    var handle = giftProductHandle(tier);
    var variantId = giftVariantId(tier);
    if (!handle && !variantId) return;
    resolveGiftSellingPriceCents(tier)
      .then(function (priceCents) {
        if (!(priceCents > 0)) return;
        target.textContent = formatMoneyCents(priceCents, mount);
        target.hidden = false;
      })
      .catch(function (error) {
        console.warn("Unable to hydrate gift original price", error);
      });
  }

  async function fetchGiftSellingPriceCents(handle, variantId, productUrl) {
    var product = handle ? await fetchProductJson(handle, productUrl) : null;
    var productPrice = giftSellingPriceCentsFromProduct(product, variantId);
    if (productPrice > 0) return productPrice;
    var variant = variantId ? await fetchVariantJson(variantId) : null;
    return variant ? giftSellingPriceCentsFromVariant(variant) : 0;
  }

  function giftSellingPriceCentsFromProduct(product, variantId) {
    if (!product) return 0;
    var variant = giftProductVariant(product, variantId);
    if (variant) {
      return giftSellingPriceCentsFromVariant(variant);
    }
    return positiveCents(product.price || product.price_min);
  }

  function giftProductVariant(product, variantId) {
    var variants = Array.isArray(product && product.variants)
      ? product.variants
      : [];
    if (!variants.length) return null;
    if (variantId) {
      var matched = variants.find(function (variant) {
        return (
          normalizeLegacyId(variant && variant.id) === variantId ||
          normalizeLegacyId(variant && variant.admin_graphql_api_id) ===
            variantId
        );
      });
      if (matched) return matched;
    }
    return variants[0];
  }

  function giftSellingPriceCentsFromVariant(variant) {
    return positiveCents(variant.price);
  }

  function giftPlaceholderIcon() {
    return '<span class="ss-cart-promotion-gift__placeholder" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5"/><circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" stroke-width="1.5"/><path d="M21 15l-5-5L5 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  }

  function giftProgressIcon(unlocked, threshold, subtotal, labels) {
    var circumference = 113.1;
    var progress =
      threshold > 0 ? Math.max(0, Math.min(1, subtotal / threshold)) : 1;
    var offset = (circumference * (1 - (unlocked ? 1 : progress))).toFixed(1);
    var icon = unlocked
      ? '<path d="M15.5 22.5l4.1 4.1 8.9-10.2" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>'
      : '<path d="M22 22.5v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><rect x="17.5" y="20.5" width="9" height="7" rx="1.5" stroke="currentColor" stroke-width="1.5" fill="none"/><path d="M20 20.5v-2a2 2 0 0 1 4 0v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/>';
    return (
      '<span class="ss-cart-promotion-gift__action" aria-label="' +
      escapeHtml(unlocked ? labels.giftUnlocked : labels.locked) +
      '">' +
      '<svg class="ss-cart-promotion-gift__progress-ring" viewBox="0 0 44 44" width="44" height="44" aria-hidden="true">' +
      '<circle cx="22" cy="22" r="18" fill="none" stroke="currentColor" stroke-opacity="0.28" stroke-width="3"></circle>' +
      '<circle class="ss-cart-promotion-gift__progress-circle" cx="22" cy="22" r="18" fill="none" stroke="currentColor" stroke-width="3" stroke-dasharray="' +
      circumference +
      '" stroke-dashoffset="' +
      offset +
      '" stroke-linecap="round" transform="rotate(-90 22 22)"></circle>' +
      icon +
      "</svg>" +
      "</span>"
    );
  }

  function giftKeyPart(value) {
    return value == null ? "" : String(value);
  }

  function giftLineKey(campaignId, tierKey, variantId) {
    return [campaignId, tierKey, variantId].map(giftKeyPart).join(":");
  }

  function giftTierLineKey(campaign, tier) {
    return giftLineKey(
      campaign && campaign.id,
      tier && tier.sortOrder,
      giftVariantId(tier)
    );
  }

  function giftItemLineKey(item) {
    return giftLineKey(
      getProperty(item, SYSTEM_GIFT_CAMPAIGN),
      getProperty(item, SYSTEM_GIFT_TIER),
      getProperty(item, SYSTEM_GIFT_VARIANT)
    );
  }

  async function syncGiftLines(options) {
    options = options || {};
    if (state.isSyncing) return false;
    var cart = state.cart;
    if (!cart || !Array.isArray(cart.items)) return false;

    var giftCampaigns = activeCampaigns().filter(isGiftCampaign);
    var desired = [];
    var desiredKeys = new Set();
    giftCampaigns.forEach(function (campaign) {
      reachedGiftTiers(campaign, cart).forEach(function (tier) {
        if (!giftVariantId(tier)) return;
        desired.push({ campaign: campaign, tier: tier });
      });
    });
    desired = desired.filter(function (entry) {
      var key = giftTierLineKey(entry.campaign, entry.tier);
      if (desiredKeys.has(key)) return false;
      desiredKeys.add(key);
      return true;
    });
    var currentGifts = cart.items.filter(isSystemGiftItem);
    var signature = JSON.stringify({
      campaigns: giftCampaigns
        .map(function (campaign) {
          return campaign.id;
        })
        .sort(),
      desired: Array.from(desiredKeys).sort(),
      current: currentGifts
        .map(function (item) {
          return [item.key, giftItemLineKey(item), item.quantity].join(":");
        })
        .sort(),
    });
    if (!options.force && signature === state.lastSyncSignature) return false;

    state.isSyncing = true;
    var changed = false;
    try {
      var keptGiftKeys = new Set();
      for (var i = 0; i < currentGifts.length; i += 1) {
        var item = currentGifts[i];
        var giftKey = giftItemLineKey(item);
        var shouldKeep = desiredKeys.has(giftKey);
        var duplicateGift = shouldKeep && keptGiftKeys.has(giftKey);
        if (shouldKeep && !duplicateGift) keptGiftKeys.add(giftKey);
        if (!shouldKeep || duplicateGift || item.quantity !== 1) {
          await changeCartLine(item.key, shouldKeep && !duplicateGift ? 1 : 0);
          changed = true;
        }
      }

      for (var j = 0; j < desired.length; j += 1) {
        var entry = desired[j];
        var tier = entry.tier;
        var campaign = entry.campaign;
        var desiredKey = giftTierLineKey(campaign, tier);
        if (!keptGiftKeys.has(desiredKey)) {
          await addGiftVariant(campaign, tier);
          keptGiftKeys.add(desiredKey);
          changed = true;
        }
      }
      state.lastSyncSignature = signature;
    } finally {
      state.isSyncing = false;
    }

    return changed;
  }

  function highestReachedTier(campaign, cart) {
    var reached = reachedGiftTiers(campaign, cart);
    return reached[reached.length - 1] || null;
  }

  function reachedGiftTiers(campaign, cart) {
    var basis = campaignBasis(cart, campaign);
    return sortTiers(campaign).filter(function (tier) {
      return tierThreshold(tier) > 0 && basis >= tierThreshold(tier);
    });
  }

  function cartJsonHeaders() {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }

  async function addGiftVariant(campaign, tier) {
    var variantId = giftVariantId(tier);
    var numericVariantId = Number(variantId);
    if (!Number.isFinite(numericVariantId) || numericVariantId <= 0)
      return null;
    var properties = {};
    var giftTitle = configuredGiftTitle(tier);
    properties[SYSTEM_GIFT_CAMPAIGN] = String(campaign.id);
    properties[SYSTEM_GIFT_TIER] = String(tier.sortOrder);
    properties[SYSTEM_GIFT_VARIANT] = String(variantId);
    if (giftTitle) properties[SYSTEM_GIFT_TITLE] = giftTitle;
    return fetchJson(routesFallback("cart_add_url", "/cart/add.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: cartJsonHeaders(),
      [INTERNAL_CART_MUTATION_OPTION]: true,
      body: JSON.stringify({
        id: numericVariantId,
        quantity: 1,
        properties: properties,
      }),
    });
  }

  async function changeCartLine(key, quantity) {
    return fetchJson(routesFallback("cart_change_url", "/cart/change.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: cartJsonHeaders(),
      [INTERNAL_CART_MUTATION_OPTION]: true,
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  }

  async function updateCartLines(updates, options) {
    options = options || {};
    var body = { updates: updates || {} };
    if (options.includeSections === true) {
      var sectionIds = Array.from(
        new Set(
          cartSectionRenderTargets().map(function (target) {
            return target.section;
          })
        )
      );
      if (sectionIds.length) {
        body.sections = sectionIds;
        body.sections_url = window.location.pathname;
      }
    }
    return fetchJson(routesFallback("cart_update_url", "/cart/update.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: cartJsonHeaders(),
      [INTERNAL_CART_MUTATION_OPTION]: true,
      body: JSON.stringify(body),
    });
  }

  function cartRepriceSignature(bootstrap) {
    var campaigns =
      bootstrap && Array.isArray(bootstrap.activeCampaigns)
        ? bootstrap.activeCampaigns
        : [];
    return JSON.stringify(
      campaigns
        .filter(function (campaign) {
          return (
            campaign &&
            PRICE_BENEFIT_TYPES.includes(campaignBenefitType(campaign))
          );
        })
        .map(function (campaign) {
          return [
            String(campaign.id || ""),
            campaignBenefitType(campaign),
            String(campaign.discountApplicationTitle || ""),
            String(campaign.status || ""),
            String(campaign.thresholdType || ""),
            String(campaign.startsAt || ""),
            String(campaign.endsAt || ""),
            campaign.targetingConfig || null,
            campaign.eligibleCollectionHandles || [],
            campaign.eligibleProductHandles || [],
            campaign.excludedCollectionHandles || [],
            campaign.excludedProductHandles || [],
            campaign.tiers || [],
          ];
        })
    );
  }

  function cartRepriceNeeded() {
    return (
      state.lastRepriceSignature !== cartRepriceSignature(state.bootstrap)
    );
  }

  function cartPresentationSignature(cart) {
    function normalize(value) {
      if (Array.isArray(value)) return value.map(normalize);
      if (!value || typeof value !== "object") return value;
      return Object.keys(value)
        .filter(function (key) {
          return key !== "sections";
        })
        .sort()
        .reduce(function (result, key) {
          result[key] = normalize(value[key]);
          return result;
        }, {});
    }

    function normalizeList(value) {
      return normalize(Array.isArray(value) ? value : []).sort(function (
        left,
        right
      ) {
        return JSON.stringify(left).localeCompare(JSON.stringify(right));
      });
    }

    if (!isCartSnapshot(cart)) return "";
    return JSON.stringify({
      cartLevelDiscounts: normalizeList(
        cart.cart_level_discount_applications
      ),
      discountCodes: normalizeList(cart.discount_codes),
      itemCount: Math.max(0, Number(cart.item_count || 0)),
      items: cart.items.map(function (item) {
        return {
          discounts: normalizeList(
            item.line_level_discount_allocations || item.discounts || []
          ),
          finalLinePrice: finalLinePriceCents(item),
          key: String(item.key || item.id || ""),
          originalLinePrice: originalLinePriceCents(item),
          quantity: Number(item.quantity || 0),
          totalDiscount: Number(item.total_discount || 0),
        };
      }),
      itemsSubtotalPrice: Number(cart.items_subtotal_price || 0),
      originalTotalPrice: Number(cart.original_total_price || 0),
      totalDiscount: Number(cart.total_discount || 0),
      totalPrice: Number(cart.total_price || 0),
    });
  }

  async function repriceCartIfNeeded(options) {
    if (
      !options ||
      options.repriceCart !== true ||
      (options.forceReprice !== true && !cartRepriceNeeded())
    ) {
      return null;
    }
    var signature = cartRepriceSignature(state.bootstrap);
    var previousCart = null;
    try {
      previousCart = await fetchCart();
    } catch (error) {
      previousCart = isCartSnapshot(state.cart) ? state.cart : null;
      console.warn("Unable to snapshot cart before repricing", error);
    }
    var cart = await updateCartLines(
      {},
      {
        includeSections: true,
      }
    );
    return {
      cart: cart,
      cartChanged:
        !previousCart ||
        cartPresentationSignature(previousCart) !==
          cartPresentationSignature(cart),
      signature: signature,
    };
  }

  function commitCartReprice(result) {
    if (!result) return;
    state.lastRepriceSignature = result.signature;
  }

  function shouldRefreshMinicartAfterReprice(
    repriceResult,
    giftsChanged,
    refreshSections
  ) {
    return Boolean(
      (repriceResult && repriceResult.cartChanged) ||
        giftsChanged ||
        refreshSections
    );
  }

  function cartSectionsAreRenderable(sections, targets) {
    return Boolean(
      sections &&
        typeof sections === "object" &&
        targets.every(function (target) {
          var markup = sections[target.section];
          return typeof markup === "string" && markup.trim().length > 0;
        })
    );
  }

  async function fetchMinicartSections(targets) {
    var sectionIds = Array.from(
      new Set(
        targets.map(function (target) {
          return target.section;
        })
      )
    );
    var url = new URL(
      routesFallback("cart_url", "/cart"),
      window.location.origin
    );
    url.searchParams.set("sections", sectionIds.join(","));
    url.searchParams.set("sections_url", window.location.pathname);
    return fetchJson(url.toString(), {
      cache: "no-store",
      credentials: "same-origin",
    });
  }

  async function refreshMinicartSections(sections, cart) {
    var targets = cartSectionRenderTargets();
    if (!cartSectionsAreRenderable(sections, targets)) {
      sections = await fetchMinicartSections(targets);
    }
    if (!cartSectionsAreRenderable(sections, targets)) {
      throw new Error("Unable to render refreshed cart sections.");
    }
    var cartElement = document.querySelector("cart-notification");
    var renderedMinicart = false;
    if (cartElement && typeof cartElement.renderContents === "function") {
      renderedMinicart = cartElement.renderContents(
        { sections: sections },
        { notifyPromotion: false }
      );
    }
    var renderFailed = false;
    targets.forEach(function (target) {
      if (renderedMinicart && target.selector === "#MinicartCartPanel") return;
      var root = target.selector
        ? document.querySelector(target.selector)
        : document.getElementById(target.id);
      var markup = sections[target.section];
      if (!root) return;
      var doc = new DOMParser().parseFromString(markup, "text/html");
      var nextRoot = target.selector
        ? doc.querySelector(target.selector)
        : doc.getElementById(target.id);
      if (!nextRoot) {
        renderFailed = true;
        return;
      }
      root.innerHTML = nextRoot.innerHTML;
    });
    if (renderFailed) {
      throw new Error("Unable to find refreshed cart section markup.");
    }
    if (
      !renderedMinicart &&
      cartElement &&
      typeof cartElement.cartAction === "function"
    ) {
      cartElement.cartAction();
    }
    await updateCartCount(cart);
    return true;
  }

  function cartSectionRenderTargets() {
    var targets = [];
    var seen = new Set();

    function addTarget(section, forceFullReplace) {
      if (!section) return;
      var id = section.id || section.section;
      var renderSection = section.section || section.id;
      if (!id || !renderSection) return;
      var selector = forceFullReplace ? "" : section.selector || "";
      var key = id + ":" + renderSection + ":" + selector;
      if (seen.has(key)) return;
      seen.add(key);
      targets.push({
        id: id,
        section: renderSection,
        selector: selector,
      });
    }

    var cartElement = document.querySelector("cart-notification");
    if (cartElement && typeof cartElement.getSectionsToRender === "function") {
      cartElement.getSectionsToRender().forEach(function (section) {
        addTarget(section, false);
      });
    }

    var cartItems = document.querySelector("cart-items");
    if (cartItems && typeof cartItems.getSectionsToRender === "function") {
      cartItems.getSectionsToRender().forEach(function (section) {
        addTarget(section, true);
      });
    }

    if (!targets.length) {
      addTarget(
        {
          id: "minicart-form",
          section: "minicart-form",
          selector: "#MinicartCartPanel",
        },
        false
      );
    }
    return targets;
  }

  async function updateCartCount(cart) {
    try {
      cart = cart || (await fetchCart());
      document.querySelectorAll(".cart-count").forEach(function (element) {
        element.innerHTML = element.classList.contains("cart-count-drawer")
          ? "(" + cart.item_count + ")"
          : cart.item_count > 100
          ? "~"
          : cart.item_count;
      });
      if (document.querySelector("header-total-price")) {
        document.querySelector("header-total-price").updateTotal(cart);
      }
    } catch (error) {
      console.warn("Unable to refresh cart count", error);
    }
  }

  function refresh(options) {
    options = options || {};
    if (state.isRefreshing) {
      state.refreshPending = true;
      return state.refreshPromise || Promise.resolve(false);
    }
    var mount = getPrimaryMount();
    if (!mount) return Promise.resolve(false);
    state.isRefreshing = true;
    state.refreshPromise = (async function () {
      try {
        ensureRuntimeMounts(mount);
        await loadBootstrap(mount, options);
        var repriceResult = await repriceCartIfNeeded(options);
        var repricedCart = repriceResult && repriceResult.cart;
        var repriceChangedCart = Boolean(
          repriceResult && repriceResult.cartChanged
        );
        state.cart = repricedCart || (await fetchCart());
        var giftsChanged = false;
        var refreshSections = options.refreshSections === true;
        if (options.syncGifts !== false) {
          try {
            giftsChanged = await syncGiftLines({ force: options.force });
            if (giftsChanged) {
              state.cart = await fetchCart();
            }
          } catch (error) {
            console.warn("Unable to sync free gift lines", error);
            throw error;
          }
        }
        if (repriceResult && !repriceChangedCart) {
          commitCartReprice(repriceResult);
        }
        if (
          shouldRefreshMinicartAfterReprice(
            repriceResult,
            giftsChanged,
            refreshSections
          )
        ) {
          try {
            await refreshMinicartSections(
              repricedCart && !giftsChanged ? repricedCart.sections : null,
              state.cart
            );
            commitCartReprice(repriceResult);
            ensureRuntimeMounts(getPrimaryMount() || mount);
          } catch (error) {
            console.warn("Unable to refresh cart sections", error);
          }
        }
        syncLoyaltyCartSnapshot(state.cart);
        renderAllMounts();
        return true;
      } catch (error) {
        console.warn("Unable to load cart promotion", error);
        if (!state.bootstrap || !state.cart) {
          getMounts().forEach(hideMount);
        }
        return false;
      } finally {
        state.isRefreshing = false;
        state.refreshPromise = null;
        drainPendingPromotionRefresh();
      }
    })();
    return state.refreshPromise;
  }

  function mergeRefreshRequest(options) {
    var current = state.refreshRequest || {
      force: false,
      forceReprice: false,
      refreshBootstrap: false,
      refreshSections: false,
      repriceCart: false,
      syncGifts: false,
    };
    current.force = current.force || !options || options.force !== false;
    current.forceReprice =
      current.forceReprice || Boolean(options && options.forceReprice);
    current.refreshBootstrap =
      current.refreshBootstrap || Boolean(options && options.refreshBootstrap);
    current.refreshSections =
      current.refreshSections || Boolean(options && options.refreshSections);
    current.repriceCart =
      current.repriceCart || Boolean(options && options.repriceCart);
    current.syncGifts =
      current.syncGifts || !options || options.syncGifts !== false;
    state.refreshRequest = current;
  }

  function schedulePromotionRefresh(reason, options) {
    options = options || {};
    var source = String(reason || "cart-change");
    var now = Date.now();
    if (source === "minicart-section-render") {
      state.lastSectionRenderAt = now;
    } else if (
      source === "promotion-refresh-event" &&
      state.lastSectionRenderAt &&
      now - state.lastSectionRenderAt < 300
    ) {
      return;
    }
    state.refreshReasons.add(source);
    mergeRefreshRequest(options);
    if (state.isRefreshing || state.isSyncing) {
      state.refreshPending = true;
      return;
    }
    var delay =
      options.delay != null
        ? Number(options.delay)
        : source === "minicart-section-render"
        ? 0
        : 150;
    var dueAt = now + Math.max(0, delay || 0);
    if (
      state.cartRefreshTimer &&
      state.cartRefreshDueAt &&
      state.cartRefreshDueAt <= dueAt
    ) {
      return;
    }
    window.clearTimeout(state.cartRefreshTimer);
    state.cartRefreshDueAt = dueAt;
    state.cartRefreshTimer = window.setTimeout(
      runScheduledPromotionRefresh,
      Math.max(0, delay || 0)
    );
  }

  function runScheduledPromotionRefresh() {
    state.cartRefreshTimer = null;
    state.cartRefreshDueAt = 0;
    if (state.isRefreshing || state.isSyncing) {
      state.refreshPending = true;
      return;
    }
    var request = state.refreshRequest || {
      force: true,
      forceReprice: false,
      refreshBootstrap: false,
      refreshSections: false,
      repriceCart: false,
      syncGifts: true,
    };
    state.refreshRequest = null;
    state.refreshPending = false;
    state.refreshReasons.clear();
    state.lastSyncSignature = "";
    refresh(request);
  }

  function drainPendingPromotionRefresh() {
    if (!state.refreshPending && !state.refreshReasons.size) return;
    state.refreshPending = false;
    schedulePromotionRefresh("pending", { delay: 0 });
  }

  function scheduleCartRefresh(delay, reason, options) {
    if (!shouldRefreshPromotionForCartChange()) return;
    options = options || {};
    options.delay = delay;
    schedulePromotionRefresh(reason || "cart-mutation", options);
  }

  async function flushPromotionRefresh(options) {
    if (!getPrimaryMount()) return true;
    mergeRefreshRequest(options || { force: true, syncGifts: true });
    for (var attempt = 0; attempt < 3; attempt += 1) {
      window.clearTimeout(state.cartRefreshTimer);
      state.cartRefreshTimer = null;
      state.cartRefreshDueAt = 0;
      if (state.isRefreshing && state.refreshPromise) {
        await state.refreshPromise;
        window.clearTimeout(state.cartRefreshTimer);
        state.cartRefreshTimer = null;
        state.cartRefreshDueAt = 0;
      }
      var request = state.refreshRequest || {
        force: true,
        forceReprice: false,
        refreshBootstrap: false,
        refreshSections: false,
        repriceCart: false,
        syncGifts: true,
      };
      state.refreshRequest = null;
      state.refreshPending = false;
      state.refreshReasons.clear();
      state.lastSyncSignature = "";
      var refreshed = await refresh(request);
      if (!refreshed) {
        throw new Error(
          window.cartStrings && window.cartStrings.error
            ? window.cartStrings.error
            : "Unable to update the cart."
        );
      }
      if (
        !state.refreshPending &&
        !state.refreshReasons.size &&
        !state.refreshRequest
      ) {
        return true;
      }
    }
    throw new Error(
      window.cartStrings && window.cartStrings.error
        ? window.cartStrings.error
        : "Unable to update the cart."
    );
  }

  function bindCartRefreshEvents() {
    if (state.cartRefreshBound) return;
    state.cartRefreshBound = true;

    var refreshFromCartChange = function (payload) {
      var source =
        (payload && payload.source) ||
        (payload && payload.detail && payload.detail.source) ||
        "cart-change";
      if (shouldCloseDiscoverAfterCartUpdate(payload)) closeDiscoverPanel();
      scheduleCartRefresh(
        source === "minicart-section-render" ? 0 : 150,
        source,
        { refreshSections: source !== "minicart-section-render" }
      );
    };

    if (
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined" &&
      PUB_SUB_EVENTS &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromCartChange);
      } catch (error) {
        console.warn("Unable to subscribe cart promotion refresh", error);
      }
    }

    [
      "cart-update",
      "cart:updated",
      "cart:change",
      "cart:refresh",
      "ajaxCart:updated",
    ].forEach(function (eventName) {
      document.addEventListener(eventName, refreshFromCartChange);
      window.addEventListener(eventName, refreshFromCartChange);
    });

    patchCartMutationFetch(refreshFromCartChange);
  }

  function patchCartMutationFetch(refreshFromCartChange) {
    if (!window.fetch || window.fetch.__ssCartPromotionFetchPatched) return;
    var originalFetch = window.fetch.bind(window);
    var patchedFetch = function (input, init) {
      var shouldRefresh =
        isCartMutationRequest(input) && !isInternalCartMutation(init);
      return originalFetch(input, init).then(
        function (response) {
          if (shouldRefresh) {
            if (isCartAddRequest(input) && isDiscoverPanelOpen()) {
              closeDiscoverPanel();
            }
            refreshFromCartChange({ source: "cart-mutation-fetch" });
          }
          return response;
        },
        function (error) {
          if (shouldRefresh) {
            refreshFromCartChange({ source: "cart-mutation-fetch" });
          }
          throw error;
        }
      );
    };
    patchedFetch.__ssCartPromotionFetchPatched = true;
    patchedFetch.__ssCartPromotionOriginalFetch = originalFetch;
    window.fetch = patchedFetch;
  }

  function isInternalCartMutation(init) {
    return Boolean(init && init[INTERNAL_CART_MUTATION_OPTION]);
  }

  function shouldCloseDiscoverAfterCartUpdate(payload) {
    if (!isDiscoverPanelOpen()) return false;
    var source =
      (payload && payload.source) ||
      (payload && payload.detail && payload.detail.source) ||
      "";
    return source === "product-form";
  }

  function isCartMutationRequest(input) {
    var rawUrl =
      typeof input === "string"
        ? input
        : input && typeof input.url === "string"
        ? input.url
        : "";
    if (!rawUrl) return false;
    try {
      var pathname = new URL(rawUrl, window.location.origin).pathname;
      return /\/cart\/(add|change|update|clear)(?:\.js)?$/.test(pathname);
    } catch (error) {
      return /\/cart\/(add|change|update|clear)(?:\.js)?(?:$|\?)/.test(rawUrl);
    }
  }

  function isCartAddRequest(input) {
    var rawUrl =
      typeof input === "string"
        ? input
        : input && typeof input.url === "string"
        ? input.url
        : "";
    if (!rawUrl) return false;
    try {
      return /\/cart\/add(?:\.js)?$/.test(
        new URL(rawUrl, window.location.origin).pathname
      );
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:$|\?)/.test(rawUrl);
    }
  }

  function scheduleExpiryRefresh() {
    if (state.expiresTimer) {
      clearTimeout(state.expiresTimer);
      state.expiresTimer = null;
    }
    var campaigns = activeCampaigns().filter(function (campaign) {
      return campaign && campaign.endsAt;
    });
    if (!campaigns.length || !state.bootstrap || !state.bootstrap.serverNow)
      return;
    var serverNow = new Date(state.bootstrap.serverNow).getTime();
    var endsAt = Math.min.apply(
      Math,
      campaigns
        .map(function (campaign) {
          return new Date(campaign.endsAt).getTime();
        })
        .filter(Number.isFinite)
    );
    var delay = endsAt - serverNow;
    if (!Number.isFinite(delay) || delay <= 0) {
      schedulePromotionRefresh("campaign-expired", {
        delay: 0,
        refreshBootstrap: true,
        refreshSections: true,
        repriceCart: true,
      });
      return;
    }
    state.expiresTimer = setTimeout(function () {
      state.lastSyncSignature = "";
      schedulePromotionRefresh("campaign-expired", {
        delay: 0,
        refreshBootstrap: true,
        refreshSections: true,
        repriceCart: true,
      });
    }, Math.min(delay + 1000, 2147483647));
  }

  async function openDiscoverPanel(source, campaignId) {
    source = source || "campaign";
    var requestId = (state.discoverRequestId += 1);
    var mount = getPrimaryMount();
    var labels = getLabels(mount);
    var campaign = source === "campaign" ? campaignById(campaignId) : null;
    var panelTitle = discoverPanelTitle(source, campaign, mount, labels);
    var wrapper = document.querySelector(".minicart__wrapper") || document.body;
    var panel = ensureDiscoverPanel(wrapper);
    var bodyHtml = "";
    renderDiscoverPanelShell(
      panel,
      labels,
      panelTitle,
      discoverLoadingHtml(labels),
      true
    );
    panel.classList.add("is-open");
    panel.querySelector("[data-ss-cart-promotion-close]")?.focus();
    try {
      bodyHtml = await discoverProductHtml(source, mount, campaign);
    } catch (error) {
      console.warn("Unable to prepare Discover more products", error);
      bodyHtml = discoverEmptyHtml(labels);
    }
    if (!bodyHtml) {
      bodyHtml = discoverEmptyHtml(labels);
    }
    if (
      requestId !== state.discoverRequestId ||
      !panel.classList.contains("is-open")
    )
      return;
    setDiscoverPanelBody(panel, bodyHtml, false);
    hydrateDiscoverProducts(panel, mount);
  }

  function ensureDiscoverPanel(wrapper) {
    var panel = wrapper.querySelector(".ss-cart-promotion-discover");
    if (!panel) {
      panel = document.createElement("div");
      panel.className = "ss-cart-promotion-discover";
      wrapper.appendChild(panel);
    }
    return panel;
  }

  function discoverPanelTitle(source, campaign, mount, labels) {
    if (source === "free-shipping") {
      return labels.discover || "Discover more items";
    }
    if (!campaign) return labels.discover || "Discover more items";
    var campaignTitle = campaignDisplayTitle(campaign);
    if (campaignTitle) return campaignTitle;
    var progress = state.cart
      ? campaignProgress(campaign, state.cart, mount, labels)
      : null;
    return (
      campaignGroupTitle(campaign, progress, labels, mount, false) ||
      labels.discover ||
      "Discover more items"
    );
  }

  function renderDiscoverPanelShell(panel, labels, title, bodyHtml, isLoading) {
    panel.innerHTML =
      '<div class="ss-cart-promotion-discover__header minicart__header flex gap-10 align-center justify-between pr-15 color-default">' +
      '<div class="minicart__header-tab flex align-center justify-between">' +
      '<div class="minicart-heading minicart-tab px-10 py-5 inline-flex align-center active">' +
      "<span>" +
      escapeHtml(title) +
      "</span>" +
      "</div>" +
      "</div>" +
      '<button type="button" class="ss-cart-promotion-discover__close btn-reset button-close close-cart-button pointer hover-svg-zoom inline-flex align-center" data-ss-cart-promotion-close aria-label="' +
      escapeHtml(labels.back) +
      '">' +
      '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="transition" aria-hidden="true"><use href="#icon-close"></use></svg>' +
      "</button>" +
      "</div>" +
      '<div class="ss-cart-promotion-discover__body' +
      (isLoading ? " is-loading" : "") +
      '" aria-live="polite"' +
      (isLoading ? ' aria-busy="true"' : "") +
      ">" +
      bodyHtml +
      "</div>" +
      '<div class="ss-cart-promotion-discover__footer">' +
      '<button type="button" class="ss-cart-promotion-discover__back btn-primary w-full btn-checkout" data-ss-cart-promotion-close>' +
      escapeHtml(labels.back) +
      "</button>" +
      "</div>";
  }

  function setDiscoverPanelBody(panel, bodyHtml, isLoading) {
    var body = panel.querySelector(".ss-cart-promotion-discover__body");
    if (!body) return;
    body.innerHTML = bodyHtml;
    body.classList.toggle("is-loading", Boolean(isLoading));
    if (isLoading) {
      body.setAttribute("aria-busy", "true");
    } else {
      body.removeAttribute("aria-busy");
    }
  }

  function discoverEmptyHtml(labels) {
    return (
      '<div class="ss-cart-promotion-discover__empty">' +
      escapeHtml(
        (labels && labels.discoverEmpty) ||
          "No matching products are available right now."
      ) +
      "</div>"
    );
  }

  function discoverLoadingHtml(labels) {
    return (
      '<div class="ss-cart-promotion-discover__loading" role="status">' +
      '<span class="ss-cart-promotion-discover__spinner" aria-hidden="true"></span>' +
      "<span>" +
      escapeHtml((labels && labels.discoverLoading) || "Loading products...") +
      "</span>" +
      "</div>"
    );
  }

  function openDescriptionModal(campaignId, campaignOverride) {
    var mount = getPrimaryMount();
    var labels = getLabels(mount);
    var campaign =
      campaignOverride || campaignById(campaignId) || activeCampaign();
    var rawHtml = campaignDescriptionHtml(campaign);
    var descriptionHtml = sanitizeDescriptionHtml(rawHtml);
    if (!descriptionHtml) return;
    var minicartWrapper = document.querySelector(".minicart__wrapper");
    var wrapper = descriptionModalHost(
      minicartWrapper,
      document.body,
      minicartWrapper && typeof window.getComputedStyle === "function"
        ? window.getComputedStyle(minicartWrapper)
        : null
    );
    var modal = document.querySelector(".ss-cart-promotion-description-modal");
    var title =
      campaign && campaign.name
        ? campaign.name
        : labels.freeGift || "Promotion";
    if (!modal) {
      modal = document.createElement("div");
      modal.className = "ss-cart-promotion-description-modal";
      wrapper.appendChild(modal);
    } else if (modal.parentNode !== wrapper) {
      wrapper.appendChild(modal);
    }
    modal.innerHTML =
      '<div class="ss-cart-promotion-description-modal__backdrop" data-ss-cart-promotion-description-close></div>' +
      '<section class="ss-cart-promotion-description-modal__dialog" role="dialog" aria-modal="true" aria-label="' +
      escapeHtml(title) +
      '">' +
      '<div class="ss-cart-promotion-description-modal__header">' +
      '<h2 class="ss-cart-promotion-description-modal__title">' +
      escapeHtml(title) +
      "</h2>" +
      '<button type="button" class="ss-cart-promotion-description-modal__close" data-ss-cart-promotion-description-close aria-label="' +
      escapeHtml(labels.close || "Close") +
      '">&times;</button>' +
      "</div>" +
      '<div class="ss-cart-promotion-description-modal__body rte">' +
      descriptionHtml +
      "</div>" +
      "</section>";
    modal.classList.add("is-open");
    modal.querySelector(".ss-cart-promotion-description-modal__close")?.focus();
  }

  function descriptionModalHost(minicartWrapper, body, styles) {
    if (!minicartWrapper) return body;
    var isHidden =
      minicartWrapper.hidden ||
      minicartWrapper.getAttribute?.("aria-hidden") === "true" ||
      (styles && (styles.display === "none" || styles.visibility === "hidden"));
    return isHidden ? body : minicartWrapper;
  }

  function closeDescriptionModal() {
    document
      .querySelectorAll(".ss-cart-promotion-description-modal.is-open")
      .forEach(function (modal) {
        modal.classList.remove("is-open");
      });
  }

  function sanitizeDescriptionHtml(html) {
    var template = document.createElement("template");
    template.innerHTML = String(html || "");
    var removableTags = [
      "script",
      "style",
      "iframe",
      "object",
      "embed",
      "form",
      "input",
      "button",
      "textarea",
      "select",
    ];
    removableTags.forEach(function (tag) {
      template.content.querySelectorAll(tag).forEach(function (node) {
        node.remove();
      });
    });
    var allowedTags = new Set([
      "A",
      "B",
      "BR",
      "BLOCKQUOTE",
      "DIV",
      "EM",
      "FIGURE",
      "FIGCAPTION",
      "H1",
      "H2",
      "H3",
      "H4",
      "H5",
      "H6",
      "HR",
      "I",
      "IMG",
      "LI",
      "OL",
      "P",
      "SPAN",
      "STRONG",
      "TABLE",
      "TBODY",
      "TD",
      "TH",
      "THEAD",
      "TR",
      "U",
      "UL",
    ]);
    var allowedAttributes = new Set([
      "alt",
      "colspan",
      "height",
      "href",
      "rel",
      "rowspan",
      "src",
      "style",
      "target",
      "title",
      "width",
    ]);
    Array.from(template.content.querySelectorAll("*")).forEach(function (node) {
      if (!allowedTags.has(node.tagName)) {
        node.replaceWith.apply(node, Array.from(node.childNodes));
        return;
      }
      Array.from(node.attributes).forEach(function (attribute) {
        var name = attribute.name.toLowerCase();
        if (!allowedAttributes.has(name) || name.startsWith("on")) {
          node.removeAttribute(attribute.name);
          return;
        }
        if (name === "style") {
          var safeStyle = sanitizeDescriptionStyle(attribute.value);
          if (safeStyle) {
            node.setAttribute("style", safeStyle);
          } else {
            node.removeAttribute(attribute.name);
          }
          return;
        }
        if (
          (name === "href" || name === "src") &&
          !isSafeDescriptionUrl(attribute.value, name === "src")
        ) {
          node.removeAttribute(attribute.name);
        }
      });
      if (node.tagName === "A") {
        node.setAttribute("target", "_blank");
        node.setAttribute("rel", "noopener noreferrer");
      }
    });
    return template.innerHTML.trim();
  }

  function sanitizeDescriptionStyle(value) {
    var declarations = String(value || "")
      .split(";")
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
    var safe = [];
    declarations.forEach(function (declaration) {
      var separatorIndex = declaration.indexOf(":");
      if (separatorIndex <= 0) return;
      var property = declaration.slice(0, separatorIndex).trim().toLowerCase();
      var styleValue = declaration.slice(separatorIndex + 1).trim();
      if (
        (property === "color" || property === "background-color") &&
        isSafeDescriptionColorValue(styleValue)
      ) {
        safe.push(property + ": " + styleValue);
      }
    });
    return safe.join("; ");
  }

  function isSafeDescriptionColorValue(value) {
    var color = String(value || "").trim();
    if (!color || color.length > 80) return false;
    if (/url|expression|javascript|@|\\/i.test(color)) return false;
    return /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\)|hsla?\([\d\s.,%deg]+\)|[a-z]+)$/i.test(
      color
    );
  }

  function isSafeDescriptionUrl(value, allowImages) {
    var url = String(value || "").trim();
    if (!url) return false;
    if (url.startsWith("/") || url.startsWith("#")) return true;
    if (allowImages && url.startsWith("data:image/")) return true;
    try {
      var parsed = new URL(url, window.location.origin);
      return ["http:", "https:", "mailto:", "tel:"].includes(parsed.protocol);
    } catch (error) {
      return false;
    }
  }

  async function discoverProductHtml(source, mount, selectedCampaign) {
    var campaign = selectedCampaign || firstPriceCampaign() || activeCampaign();
    var candidates = await resolveDiscoverCandidateProducts(source, campaign);
    var products = await prepareDiscoverProducts(
      candidates,
      source,
      campaign,
      mount
    );
    if (!products.length) return "";
    return productGridHtml(products);
  }

  function hasDiscoverProducts(source, campaign) {
    var products = getDiscoverCandidateProducts(
      source,
      campaign || firstPriceCampaign() || activeCampaign()
    );
    var cartHandles = cartProductHandleSet();
    var hasProducts = products.some(function (product, index) {
      var normalized = normalizeDiscoverProduct(
        product,
        index,
        getPrimaryMount()
      );
      return (
        normalized &&
        isDiscoverProductAllowed(
          normalized,
          source,
          campaign || firstPriceCampaign() || activeCampaign(),
          cartHandles,
          false
        )
      );
    });
    if (hasProducts) return true;
    if (source === "free-shipping") return !hasFreeShippingProductSource();
    var selectedCampaign = campaign || firstPriceCampaign() || activeCampaign();
    return (
      source !== "free-shipping" &&
      (campaignEligibleCollectionHandles(selectedCampaign).length > 0 ||
        canUseAllCollectionDiscover(selectedCampaign))
    );
  }

  function getDiscoverCandidateProducts(source, campaign) {
    return source === "free-shipping"
      ? getFreeShippingProducts()
      : getCampaignDiscoverProducts(
          campaign || firstPriceCampaign() || activeCampaign()
        );
  }

  async function resolveDiscoverCandidateProducts(source, campaign) {
    var products = getDiscoverCandidateProducts(source, campaign);
    if (source === "free-shipping") {
      return hasFreeShippingProductSource()
        ? products
        : fetchFreeShippingCollectionProducts();
    }
    if (products.length >= DISCOVER_PRODUCT_LIMIT) return products;
    var collectionProducts = await fetchCampaignCollectionProducts(
      campaign,
      products.length
    );
    return products.concat(collectionProducts);
  }

  async function prepareDiscoverProducts(products, source, campaign, mount) {
    var cartHandles = cartProductHandleSet();
    var seen = new Set();
    var normalized = products.reduce(function (items, product, index) {
      var item = normalizeDiscoverProduct(product, index, mount);
      if (!item || seen.has(item.handle)) return items;
      seen.add(item.handle);
      if (
        isDiscoverProductAllowed(item, source, campaign, cartHandles, false)
      ) {
        items.push(item);
      }
      return items;
    }, []);
    var needsHydration = normalized.some(needsDiscoverSortHydration);
    var sortableProducts = needsHydration
      ? normalized.slice(0, DISCOVER_PRODUCT_LIMIT)
      : normalized;

    if (needsHydration) {
      await Promise.all(
        sortableProducts
          .filter(needsDiscoverSortHydration)
          .map(function (product) {
            return hydrateDiscoverProductData(product, mount);
          })
      );
    }

    var filtered = sortableProducts.filter(function (product) {
      return isDiscoverProductAllowed(
        product,
        source,
        campaign,
        cartHandles,
        true
      );
    });
    if (!filtered.length) {
      filtered = sortableProducts.filter(function (product) {
        return isDiscoverProductAllowed(
          product,
          source,
          campaign,
          cartHandles,
          false
        );
      });
    }
    return dedupeDiscoverDisplayProducts(
      sortDiscoverProducts(filtered, discoverGapAmount(source, campaign))
    ).slice(0, DISCOVER_PRODUCT_LIMIT);
  }

  function normalizeDiscoverProduct(product, index, mount) {
    var source =
      typeof product === "string" ? { handle: product } : product || {};
    var handle = normalizeHandle(
      source.handle || source.productHandle || source.product_handle
    );
    if (!handle) return null;
    var priceCents = discoverPriceCents(source);
    var title =
      firstPresentString(source, ["title", "name"]) ||
      handle.replace(/-/g, " ");
    var item = {
      handle: handle,
      title: title,
      url:
        firstPresentString(source, [
          "url",
          "productUrl",
          "product_url",
          "onlineStoreUrl",
        ]) || "",
      imageUrl: discoverImageUrl(source),
      price: discoverDisplayPrice(source, priceCents, mount),
      priceCents: priceCents,
      available:
        typeof source.available === "boolean" ? source.available : null,
      sortIndex: discoverSortIndex(source, index),
      trustCampaignEligibility: Boolean(
        source.discoverTrustCampaignEligibility ||
          source.trustCampaignEligibility
      ),
      collectionHandles: normalizeDiscoverCollectionHandles(
        source.collectionHandles ||
          source.collection_handles ||
          source.collections
      ),
    };
    if (!item.price && item.priceCents > 0) {
      item.price = formatMoneyCents(item.priceCents, mount);
    }
    return item;
  }

  function firstPresentString(source, keys) {
    var value = keys
      .map(function (key) {
        return source[key];
      })
      .find(function (item) {
        return typeof item === "string" && item.trim() !== "";
      });
    return value ? value.trim() : "";
  }

  function discoverImageUrl(source) {
    var value = firstPresentString(source, [
      "imageUrl",
      "image_url",
      "featuredImageUrl",
      "featured_image",
      "image",
    ]);
    return value.indexOf("//") === 0 ? window.location.protocol + value : value;
  }

  function discoverDisplayPrice(source, priceCents, mount) {
    var display = firstPresentString(source, [
      "displayPrice",
      "display_price",
      "formattedPrice",
      "formatted_price",
      "priceHtml",
      "price_html",
    ]);
    if (display) return display;
    if (typeof source.price === "string" && source.price.trim() !== "")
      return source.price.trim();
    return priceCents > 0 ? formatMoneyCents(priceCents, mount) : "";
  }

  function discoverPriceCents(source) {
    var value = [
      source.priceCents,
      source.price_cents,
      source.productPriceCents,
      source.product_price_cents,
      source.variantPriceCents,
      source.variant_price_cents,
      source.minVariantPriceCents,
      source.min_variant_price_cents,
    ].find(function (item) {
      return item != null && item !== "";
    });
    return positiveCents(value);
  }

  function positiveCents(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? Math.round(number) : 0;
  }

  function discoverSortIndex(source, index) {
    var sortIndex = Number(
      source.sortIndex != null ? source.sortIndex : source.sort_index
    );
    return Number.isFinite(sortIndex) ? sortIndex : index;
  }

  function normalizeDiscoverCollectionHandles(value) {
    var source = Array.isArray(value)
      ? value
      : String(value == null ? "" : value).split(",");
    var seen = new Set();
    return source.reduce(function (items, item) {
      var handle =
        item && typeof item === "object"
          ? normalizeHandle(
              item.handle || item.product_handle || item.productHandle
            )
          : normalizeHandle(item);
      if (handle && !seen.has(handle)) {
        seen.add(handle);
        items.push(handle);
      }
      return items;
    }, []);
  }

  function cartProductHandleSet() {
    return new Set(
      state.cart && Array.isArray(state.cart.items)
        ? state.cart.items
            .map(function (item) {
              return itemTargetMeta(item).productHandle;
            })
            .filter(Boolean)
        : []
    );
  }

  function dedupeDiscoverDisplayProducts(products) {
    var seen = new Set();
    return products.filter(function (product) {
      var key = discoverDisplayDedupeKey(product);
      if (!key) return true;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function discoverDisplayDedupeKey(product) {
    var title = normalizeDiscoverDisplayTitle(product && product.title);
    if (!title) return "";
    var image = normalizeDiscoverDisplayImage(product && product.imageUrl);
    return image ? title + "|" + image : title;
  }

  function normalizeDiscoverDisplayTitle(value) {
    return String(value == null ? "" : value)
      .toLowerCase()
      .replace(/&amp;/g, "&")
      .replace(/^\s*(us|uk|ca|au|de|fr|es|it|nl|se|no|dk|fi|sa)\s*[-_]\s*/i, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function normalizeDiscoverDisplayImage(value) {
    var image = String(value == null ? "" : value).trim();
    if (!image) return "";
    try {
      var url = new URL(image, window.location.origin);
      return (
        url.hostname.toLowerCase() +
        url.pathname
          .toLowerCase()
          .replace(/(_[0-9]+x[0-9]*|_[0-9]+x|_x[0-9]+)(?=\.)/g, "")
      );
    } catch (error) {
      return image
        .split("?")[0]
        .toLowerCase()
        .replace(/(_[0-9]+x[0-9]*|_[0-9]+x|_x[0-9]+)(?=\.)/g, "");
    }
  }

  function isDiscoverProductAllowed(
    product,
    source,
    campaign,
    cartHandles,
    requirePrice
  ) {
    if (!product || !product.handle) return false;
    if (product.available === false) return false;
    if (requirePrice && !hasValidDiscoverPrice(product)) return false;
    if (
      source === "free-shipping" &&
      cartHandles &&
      cartHandles.has(product.handle)
    )
      return false;
    if (hasBlockedDiscoverKeyword(product)) return false;
    return (
      source === "free-shipping" ||
      isDiscoverProductEligibleForCampaign(product, campaign)
    );
  }

  function hasValidDiscoverPrice(product) {
    return (
      Number.isFinite(Number(product.priceCents)) &&
      Number(product.priceCents) > 0
    );
  }

  function hasBlockedDiscoverKeyword(product) {
    var handle = String(product.handle || "").toLowerCase();
    var title = String(product.title || "").toLowerCase();
    return DISCOVER_EXCLUDED_KEYWORDS.some(function (keyword) {
      return handle.includes(keyword) || title.includes(keyword);
    });
  }

  function isDiscoverProductEligibleForCampaign(product, campaign) {
    if (!campaign) return true;
    var targets = campaignTargets(campaign);
    var hasPositiveTarget =
      targets.eligibleProductHandles.length ||
      targets.eligibleCollectionHandles.length;
    if (targets.excludedProductHandles.includes(product.handle)) return false;
    if (
      hasIntersection(
        product.collectionHandles,
        targets.excludedCollectionHandles
      )
    )
      return false;
    if (!hasPositiveTarget) return true;
    if (targets.eligibleProductHandles.includes(product.handle)) return true;
    if (product.collectionHandles.length) {
      return hasIntersection(
        product.collectionHandles,
        targets.eligibleCollectionHandles
      );
    }
    return (
      product.trustCampaignEligibility && !targets.eligibleProductHandles.length
    );
  }

  function needsDiscoverSortHydration(product) {
    return !hasValidDiscoverPrice(product) || product.available == null;
  }

  async function hydrateDiscoverProductData(product, mount) {
    var details = await fetchProductJson(product.handle, product.url);
    if (!details) return product;
    if (details.title) product.title = details.title;
    if (!product.imageUrl) product.imageUrl = productJsonImageUrl(details);
    if (typeof details.available === "boolean")
      product.available = details.available;
    if (!hasValidDiscoverPrice(product) && details.price != null) {
      product.priceCents = positiveCents(details.price);
    }
    if (!product.price && hasValidDiscoverPrice(product)) {
      product.price = formatMoneyCents(product.priceCents, mount);
    }
    return product;
  }

  function sortDiscoverProducts(products, gap) {
    return products.slice().sort(function (left, right) {
      var leftScore = discoverSortScore(left, gap);
      var rightScore = discoverSortScore(right, gap);
      if (leftScore.group !== rightScore.group)
        return leftScore.group - rightScore.group;
      if (leftScore.distance !== rightScore.distance)
        return leftScore.distance - rightScore.distance;
      if (left.sortIndex !== right.sortIndex)
        return left.sortIndex - right.sortIndex;
      return left.title.localeCompare(right.title);
    });
  }

  function discoverSortScore(product, gap) {
    var price = product.priceCents / 100;
    if (!(gap > 0)) {
      return { group: 0, distance: product.sortIndex };
    }
    var cap = Math.max(gap + 30, gap * 2);
    if (price >= gap && price <= cap) {
      return { group: 0, distance: price - gap };
    }
    if (price >= gap) {
      return { group: 1, distance: price - gap };
    }
    return { group: 2, distance: gap - price };
  }

  function discoverGapAmount(source, campaign) {
    if (source === "free-shipping") return freeShippingGapAmount();
    campaign = campaign || firstPriceCampaign() || activeCampaign();
    if (!campaign || !state.cart) return 0;
    var basis = campaignBasis(state.cart, campaign);
    var tiers = sortTiers(campaign);
    if (isPriceCampaign(campaign)) {
      var nextAmountTier = tiers.find(function (tier) {
        return basis < tierThreshold(tier);
      });
      return nextAmountTier && campaignThresholdType(campaign) !== "QUANTITY"
        ? Math.max(0, tierThreshold(nextAmountTier) - basis)
        : 0;
    }
    if (isGiftCampaign(campaign)) {
      var giftTier = currentGiftTier(campaign, tiers, basis);
      return giftTier && campaignThresholdType(campaign) !== "QUANTITY"
        ? Math.max(0, tierThreshold(giftTier) - basis)
        : 0;
    }
    return 0;
  }

  function freeShippingGapAmount() {
    var progress = freeShippingProgressForMount(getPrimaryMount(), state.cart);
    return progress ? progress.gap : 0;
  }

  function productGridHtml(products) {
    return (
      '<div class="ss-cart-promotion-discover__grid">' +
      products.map(productCardHtml).join("") +
      "</div>"
    );
  }

  function productCardHtml(product) {
    var handle = product.handle || "";
    var url = product.url || "/products/" + encodeURIComponent(handle);
    var quickviewUrl =
      url +
      (url.includes("?") ? "&" : "?") +
      "section_id=product-quickview&ajax=1";
    var title = product.title || handle;
    var image = product.imageUrl
      ? '<img class="product-image first-image" src="' +
        escapeHtml(product.imageUrl) +
        '" alt="" loading="lazy">'
      : discoverPlaceholderIcon();
    var price = product.price ? discoverPriceHtml(product.price) : "";
    var quickviewAttributes =
      'data-custom-class="quickview" data-url="' +
      escapeHtml(quickviewUrl) +
      '" role="button" tabindex="0" aria-label="' +
      escapeHtml(title) +
      '"';
    return (
      '<div class="ss-cart-promotion-discover__item product-item product__item-js minicart-recommendation-card" data-ss-cart-promotion-product-card data-ss-product-handle="' +
      escapeHtml(handle) +
      '" data-ss-product-url="' +
      escapeHtml(url) +
      '">' +
      '<div class="product-item__wrapper flex gap-custom align-center">' +
      '<div class="product-item__inner hover-effect overflow-hidden relative col-w-custom">' +
      '<button-quickview class="ss-cart-promotion-discover__media product-item__quick-shop-link product__media product-item__media--ratio rounded block" ' +
      quickviewAttributes +
      ' data-ss-cart-promotion-product-media style="--aspect-ratio: 3/4;">' +
      image +
      "</button-quickview>" +
      "</div>" +
      '<div class="ss-cart-promotion-discover__content product-item__information word-break text-start align-self-center type-list" data-ss-cart-promotion-product-content>' +
      '<button-quickview class="ss-cart-promotion-discover__title product-item__quick-shop-link product-item__name no-underline fs-custom block lh-normal" ' +
      quickviewAttributes +
      " data-ss-cart-promotion-product-title>" +
      escapeHtml(title) +
      "</button-quickview>" +
      price +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  function discoverPriceHtml(price) {
    return (
      '<div class="ss-cart-promotion-discover__price product-item__price justify-content-center fs-custom flex gap-custom lh-normal" style="--font-size: 13; --gap: 3px;"><span class="card-product-price">' +
      escapeHtml(price) +
      "</span></div>"
    );
  }

  function discoverPlaceholderIcon() {
    return '<span class="ss-cart-promotion-discover__placeholder" aria-hidden="true"><svg width="26" height="26" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5"/><circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" stroke-width="1.5"/><path d="M21 15l-5-5L5 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  }

  function hydrateDiscoverProducts(panel, mount) {
    var cards = Array.from(
      panel.querySelectorAll("[data-ss-cart-promotion-product-card]")
    ).filter(function (card) {
      return card.dataset.ssProductHandle && needsProductHydration(card);
    });
    if (!cards.length) return;

    Promise.all(
      cards.map(function (card) {
        return hydrateDiscoverProduct(card, mount);
      })
    ).catch(function (error) {
      console.warn("Unable to hydrate Discover more products", error);
    });
  }

  function needsProductHydration(card) {
    return (
      !card.querySelector(".ss-cart-promotion-discover__media img") ||
      !card.querySelector(".ss-cart-promotion-discover__price")
    );
  }

  async function hydrateDiscoverProduct(card, mount) {
    var product = await fetchProductJson(
      card.dataset.ssProductHandle,
      card.dataset.ssProductUrl
    );
    if (!product) return;

    var imageUrl = productJsonImageUrl(product);
    var media = card.querySelector("[data-ss-cart-promotion-product-media]");
    if (imageUrl && media && !media.querySelector("img")) {
      media.innerHTML =
        '<img class="product-image first-image" src="' +
        escapeHtml(imageUrl) +
        '" alt="" loading="lazy">';
    }

    var title = card.querySelector("[data-ss-cart-promotion-product-title]");
    if (title && product.title) {
      title.textContent = product.title;
    }

    if (
      !card.querySelector(".ss-cart-promotion-discover__price") &&
      product.price != null &&
      product.price !== "" &&
      Number.isFinite(Number(product.price))
    ) {
      var priceTarget =
        card.querySelector("[data-ss-cart-promotion-product-content]") || card;
      priceTarget.insertAdjacentHTML(
        "beforeend",
        discoverPriceHtml(formatMoneyCents(Number(product.price), mount))
      );
    }
  }

  async function fetchProductJson(handle, productUrl) {
    var normalizedHandle = normalizeHandle(handle);
    if (!normalizedHandle) return null;
    if (!state.productJsonCache.has(normalizedHandle)) {
      state.productJsonCache.set(
        normalizedHandle,
        fetchJson(productJsonUrl(normalizedHandle, productUrl), {
          credentials: "same-origin",
        }).catch(function (error) {
          console.warn(
            "Unable to load product details for " + normalizedHandle,
            error
          );
          return null;
        })
      );
    }
    return state.productJsonCache.get(normalizedHandle);
  }

  async function fetchCampaignCollectionProducts(campaign, offset) {
    var handles = campaignEligibleCollectionHandles(campaign);
    if (!handles.length && canUseAllCollectionDiscover(campaign)) {
      handles = ["all"];
    }
    if (!handles.length) return [];
    var lists = await Promise.all(
      handles.map(function (handle, collectionIndex) {
        return fetchCollectionProducts(handle).then(function (products) {
          return products.map(function (product, index) {
            return collectionDiscoverProduct(
              product,
              handle,
              Number(offset || 0) +
                collectionIndex * DISCOVER_PRODUCT_LIMIT +
                index
            );
          });
        });
      })
    );
    return lists
      .reduce(function (items, list) {
        return items.concat(list);
      }, [])
      .slice(0, DISCOVER_PRODUCT_LIMIT);
  }

  async function fetchFreeShippingCollectionProducts() {
    var products = await fetchCollectionProducts("all");
    return products
      .map(function (product, index) {
        return collectionDiscoverProduct(product, "all", index);
      })
      .slice(0, DISCOVER_PRODUCT_LIMIT);
  }

  async function fetchCollectionProducts(handle) {
    var normalizedHandle = normalizeHandle(handle);
    if (!normalizedHandle) return [];
    if (!state.collectionProductsCache.has(normalizedHandle)) {
      state.collectionProductsCache.set(
        normalizedHandle,
        fetchJson(collectionProductsUrl(normalizedHandle), {
          credentials: "same-origin",
        })
          .then(function (payload) {
            return Array.isArray(payload && payload.products)
              ? payload.products
              : [];
          })
          .catch(function (error) {
            console.warn(
              "Unable to load collection products for " + normalizedHandle,
              error
            );
            return [];
          })
      );
    }
    return state.collectionProductsCache.get(normalizedHandle);
  }

  async function fetchVariantJson(variantId) {
    var normalizedId = normalizeLegacyId(variantId);
    if (!normalizedId) return null;
    var cacheKey = "variant:" + normalizedId;
    if (!state.variantJsonCache.has(cacheKey)) {
      state.variantJsonCache.set(
        cacheKey,
        fetchJson(variantJsonUrl(normalizedId), {
          credentials: "same-origin",
        }).catch(function (error) {
          console.warn(
            "Unable to load variant details for " + normalizedId,
            error
          );
          return null;
        })
      );
    }
    return state.variantJsonCache.get(cacheKey);
  }

  function productJsonUrl(handle, productUrl) {
    if (productUrl) {
      var url = new URL(productUrl, window.location.origin);
      url.pathname = url.pathname.replace(/\/$/, "") + ".js";
      url.search = "";
      return url.toString();
    }
    var root = routesFallback("root_url", "/");
    return (
      root.replace(/\/?$/, "/") +
      "products/" +
      encodeURIComponent(handle) +
      ".js"
    );
  }

  function collectionProductsUrl(handle) {
    var root = routesFallback("root_url", "/");
    var url = new URL(
      root.replace(/\/?$/, "/") +
        "collections/" +
        encodeURIComponent(handle) +
        "/products.json",
      window.location.origin
    );
    url.searchParams.set("limit", String(DISCOVER_PRODUCT_LIMIT));
    return url.toString();
  }

  function variantJsonUrl(variantId) {
    var root = routesFallback("root_url", "/");
    return (
      root.replace(/\/?$/, "/") +
      "variants/" +
      encodeURIComponent(variantId) +
      ".js"
    );
  }

  function productJsonImageUrl(product) {
    var imageUrl = productImageSource(
      product &&
        (product.featured_image ||
          (Array.isArray(product.images) ? product.images[0] : null) ||
          product.imageUrl ||
          product.image)
    );
    if (!imageUrl) return "";
    var normalized = String(imageUrl).trim();
    if (!normalized) return "";
    return normalized.indexOf("//") === 0
      ? window.location.protocol + normalized
      : normalized;
  }

  function productImageSource(value) {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object") {
      return value.src || value.url || value.imageUrl || value.image_url || "";
    }
    return "";
  }

  function getCampaignDiscoverProducts(campaign) {
    return eligibleProductDiscoverProducts(campaign);
  }

  function campaignEligibleCollectionHandles(campaign) {
    return campaignTargets(campaign).eligibleCollectionHandles;
  }

  function collectionDiscoverProduct(product, collectionHandle, sortIndex) {
    return {
      handle: product && product.handle,
      title: product && product.title,
      url: product && product.url,
      imageUrl: productJsonImageUrl(product),
      priceCents: productJsonPriceCents(product),
      available: productJsonAvailable(product),
      sortIndex: sortIndex,
      collectionHandles: [collectionHandle],
      discoverTrustCampaignEligibility: true,
    };
  }

  function productJsonPriceCents(product) {
    if (!product) return 0;
    var variant = Array.isArray(product.variants) ? product.variants[0] : null;
    var value = [
      product.price,
      product.price_min,
      product.priceMin,
      variant && variant.price,
    ].find(function (item) {
      return item != null && item !== "";
    });
    if (typeof value === "string" && value.indexOf(".") !== -1) {
      var decimal = Number(value);
      return Number.isFinite(decimal) && decimal > 0
        ? Math.round(decimal * 100)
        : 0;
    }
    return positiveCents(value);
  }

  function productJsonAvailable(product) {
    if (product && typeof product.available === "boolean")
      return product.available;
    if (product && Array.isArray(product.variants)) {
      var hasAvailability = product.variants.some(function (variant) {
        return variant && typeof variant.available === "boolean";
      });
      if (!hasAvailability) return null;
      return product.variants.some(function (variant) {
        return variant && variant.available === true;
      });
    }
    return null;
  }

  function getFreeShippingProducts() {
    var script = document.querySelector(
      "[data-ss-cart-promotion-free-shipping-products]"
    );
    if (!script) return [];
    try {
      var products = JSON.parse(script.textContent || "[]");
      return Array.isArray(products)
        ? products.filter(function (product) {
            return product && product.handle;
          })
        : [];
    } catch (error) {
      console.warn("Unable to parse free shipping products", error);
      return [];
    }
  }

  function hasFreeShippingProductSource() {
    return Boolean(
      document.querySelector("[data-ss-cart-promotion-free-shipping-products]")
    );
  }

  function eligibleProductDiscoverProducts(campaign) {
    var handles = campaignTargets(campaign).eligibleProductHandles;
    if (!handles.length) return [];
    return handles
      .filter(function (handle) {
        return Boolean(handle);
      })
      .slice(0, DISCOVER_PRODUCT_LIMIT)
      .map(function (handle, index) {
        return {
          handle: handle,
          title: handle.replace(/-/g, " "),
          sortIndex: index,
          discoverTrustCampaignEligibility: true,
        };
      });
  }

  function closeDiscoverPanel() {
    state.discoverRequestId += 1;
    document
      .querySelectorAll(".ss-cart-promotion-discover.is-open")
      .forEach(function (panel) {
        panel.classList.remove("is-open");
      });
  }

  function isDiscoverPanelOpen() {
    return Boolean(
      document.querySelector(".ss-cart-promotion-discover.is-open")
    );
  }

  function isCheckoutTrigger(target) {
    return Boolean(
      target.closest(
        'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
      )
    );
  }

  async function handleCheckoutPreflight(event) {
    if (window.SilkSilkyCartCoordinator) return;
    var trigger =
      event.target instanceof Element
        ? event.target.closest(
            'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
          )
        : null;
    if (!trigger || trigger.dataset.ssPromotionCheckoutPending === "true")
      return;
    if (!isCheckoutTrigger(trigger)) return;
    event.preventDefault();
    event.stopPropagation();
    trigger.dataset.ssPromotionCheckoutPending = "true";
    trigger.setAttribute("aria-busy", "true");
    try {
      await refreshPromotionsBeforeCheckout();
    } finally {
      trigger.removeAttribute("aria-busy");
      delete trigger.dataset.ssPromotionCheckoutPending;
    }
    redirectToCheckout(trigger);
  }

  async function refreshPromotionsBeforeCheckout() {
    try {
      return await flushPromotionRefresh({
        force: false,
        forceReprice: false,
        refreshBootstrap: false,
        refreshSections: false,
        repriceCart: true,
        syncGifts: true,
      });
    } catch (error) {
      console.warn("Unable to refresh cart promotions before checkout", error);
      return false;
    }
  }

  function redirectToCheckout(trigger) {
    var destination =
      trigger && trigger.tagName === "A" && trigger.href
        ? trigger.href
        : storefrontPath("checkout");
    window.location.assign(destination);
  }

  function handlePromotionClick(event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var openTrigger = target.closest("[data-ss-cart-promotion-open]");
    if (openTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openDiscoverPanel(
        openTrigger.dataset.ssCartPromotionSource || "campaign",
        openTrigger.dataset.ssCartPromotionCampaignId
      );
    } else if (target.closest("[data-ss-cart-promotion-description]")) {
      var descriptionTrigger = target.closest(
        "[data-ss-cart-promotion-description]"
      );
      event.preventDefault();
      event.stopPropagation();
      openDescriptionModal(
        descriptionTrigger.dataset.ssCartPromotionCampaignId
      );
    } else if (target.closest("[data-ss-cart-promotion-description-close]")) {
      event.preventDefault();
      event.stopPropagation();
      closeDescriptionModal();
    } else if (target.closest("[data-ss-cart-promotion-close]")) {
      event.preventDefault();
      event.stopPropagation();
      closeDiscoverPanel();
    }
  }

  function closeCartSavingsDetailsOutside(event) {
    var target = event && event.target;
    if (!target) return;
    document
      .querySelectorAll("[data-cart-savings-details][open]")
      .forEach(function (details) {
        if (!details.contains(target)) details.removeAttribute("open");
      });
  }

  function closeCartSavingsDetails() {
    document
      .querySelectorAll("[data-cart-savings-details][open]")
      .forEach(function (details) {
        details.removeAttribute("open");
      });
  }

  function bindEvents() {
    if (state.eventsBound) return;
    state.eventsBound = true;
    document.addEventListener("click", closeCartSavingsDetailsOutside, true);
    document.addEventListener("click", handlePromotionClick, true);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeCartSavingsDetails();
        closeDescriptionModal();
        return;
      }
      if (event.key !== "Enter" && event.key !== " ") return;
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var openTrigger = target.closest("[data-ss-cart-promotion-open]");
      if (!openTrigger || openTrigger.tagName === "BUTTON") return;
      event.preventDefault();
      openDiscoverPanel(
        openTrigger.dataset.ssCartPromotionSource || "campaign",
        openTrigger.dataset.ssCartPromotionCampaignId
      );
    });
    var checkoutCoordinator = window.SilkSilkyCartCoordinator;
    if (
      checkoutCoordinator &&
      typeof checkoutCoordinator.registerCheckoutStep === "function"
    ) {
      checkoutCoordinator.registerCheckoutStep(
        "cart-promotion-gifts",
        function () {
          return refreshPromotionsBeforeCheckout();
        },
        200
      );
    } else {
      document.addEventListener("click", handleCheckoutPreflight, true);
    }
    document.addEventListener("ss:cart:promotion:refresh", function (event) {
      var detail = event && event.detail;
      var source =
        (detail && detail.source) || "promotion-refresh-event";
      var refreshSectionsRequested = Boolean(
        detail && detail.refreshSections
      );
      if (
        (source === "promotion-refresh-event" ||
          source === "minicart-section-render") &&
        !shouldRefreshPromotionForCartChange()
      ) {
        return;
      }
      var snapshotRendered = false;
      if (source === "minicart-section-render") {
        snapshotRendered = renderCartSnapshot(
          detail && detail.cart
        );
      }
      schedulePromotionRefresh(source, {
        delay: source === "minicart-section-render" ? 0 : 150,
        refreshBootstrap:
          source === "promotion-refresh-event" ||
          source === "minicart-section-render",
        refreshSections:
          refreshSectionsRequested ||
          (source === "minicart-section-render" && !snapshotRendered),
        repriceCart:
          source === "promotion-refresh-event" ||
          source === "minicart-section-render",
      });
    });
    document.addEventListener(
      "ss:promotion:description:open",
      function (event) {
        var campaign = event && event.detail && event.detail.campaign;
        openDescriptionModal(campaign && campaign.id, campaign);
      }
    );
  }

  function buyNPayMCompositeQuantityEvents() {
    return ["pointerdown", "click"];
  }

  function observeMountChanges() {
    if (state.observer) return;
    state.observer = new MutationObserver(function (mutations) {
      if (state.isRendering || state.isRefreshing) return;
      var hasMountChange = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return (
            node.nodeType === 1 &&
            (node.matches?.(MOUNT_SELECTOR) ||
              node.querySelector?.(MOUNT_SELECTOR))
          );
        });
      });
      if (!hasMountChange) return;
      if (!shouldRefreshPromotionForCartChange()) return;
      clearTimeout(state.observerTimer);
      state.observerTimer = window.setTimeout(function () {
        schedulePromotionRefresh("mount-change", {
          delay: 0,
          refreshBootstrap: true,
          repriceCart: true,
        });
      }, 50);
    });
    state.observer.observe(document.body, { childList: true, subtree: true });
  }

  function shouldRefreshPromotionOnInit(mounts) {
    return (mounts || []).some(function (mount) {
      return !mount.closest || !mount.closest(".minicart__wrapper");
    });
  }

  function shouldRefreshPromotionForCartChange(mounts) {
    return (
      shouldRefreshPromotionOnInit(mounts || getMounts()) ||
      Boolean(document.querySelector(".minicart__wrapper.open"))
    );
  }

  function init() {
    bindEvents();
    var mounts = getMounts();
    if (!mounts.length) return;
    bindCartRefreshEvents();
    observeMountChanges();
    if (shouldRefreshPromotionOnInit(mounts)) {
      schedulePromotionRefresh("init-visible", {
        delay: 0,
        refreshBootstrap: true,
        repriceCart: true,
      });
    }
    window.setTimeout(updateCartSavingsSummary, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
